//React core packages
import React, { useState, useEffect, memo, useRef } from "react";
import moment from "moment";
import { useLocation, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
//Third party packages
import { InputSchedule } from "./../setting/NotificationSettings/styled.js";
import { Modal, Form } from "react-bootstrap";
import { makeStyles } from "@material-ui/core/styles";
import PeopleOutline from "@material-ui/icons/PeopleOutline";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import RoomOutlined from "@material-ui/icons/RoomOutlined";
import LocalHospitalOutlined from "@material-ui/icons/LocalHospitalOutlined";
import PersonOutline from "@material-ui/icons/PersonOutline";
import { Select } from "antd";

import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import DropdownButton from "react-bootstrap/DropdownButton";
import { Dropdown as Dropdownant } from "react-bootstrap";
import doctorLogo from "../../assets/images/fontisto_doctor.png";
import errorIcon from "../../assets/images/error-icon.png";
import {
  RepeatBtnConfirm,
  RepeatFooter,
  RepeatPopupBlock,
  RepeatPopupHeader,
} from "../schedule/styles";
import {
  Spinner,
  Button,
  ToggleButtonGroup,
  ToggleButton,
} from "react-bootstrap";
import axios from "axios";
import { DatePicker, Radio } from "antd";
import { IoCloseSharp, IoFlagOutline } from "react-icons/io5";
import { Switch } from "antd";
import { Popup } from "semantic-ui-react";
// Internal Components
import {
  setBookingData,
  SetPatientBool,
} from "./../../StateManagement/Reducers/ScheduleState";
import { Encrypt_Value, Decrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import { AccessMailUrl } from "../../axios/url.js";
import "./Popups.css";
import axiosInstance from "../../axios/axios";
import {
  Image,
  SpinnerDiv,
  StyledSvg,
  StyledButton,
  StyledDiv,
} from "../../StyledComponents";
import { Div, Span } from "../billing/CardTransactions/styles";
import { BsFillCaretDownFill } from "react-icons/bs";
import { FiAlertCircle } from "react-icons/fi";
import UpgradeRequired from "../popups/UpgradeRequired";
import CreateClient from "./CreateClient";
import { BsCheckCircle } from "react-icons/bs";
import { Tabs } from "antd";
import AddAppTemplate from "./AddAppTemplate";
//utils
import { fileurl } from "../../axios/url.js";
import GetStartedPopup from "./GetStartedPopup.js";
import { clearReturnPath } from "../../StateManagement/Reducers/AccountSetupState.js";
import waitListIcon from "../../assets/images/waitlist-blue.svg";
import CreateGroupClients from "../popups/CreateGroupClients.js";
import IntakeForms from "../../components/patient/IntakeForms";
const { Option } = Select;
const { TabPane } = Tabs;

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

export const specialityList = [
  "Plastic Surgery",
  "Dermatology",
  "Sleep Medicine",
  "Allergy & Immunology",
  "Concierge Medicine",
  "Oncology",
  "Palliative Care",
  "Endocrinology",
  "Sports Medicine",
  "Hospice",
  "Podiatry",
  "Pediatrics",
  "Pathology",
  "Obstetrics and Gynecology",
  "Hand Surgery",
  "Hematology",
  "Emergency Medicine",
  "Surgery",
  "Cardiology",
  "Vascular Surgery",
  "Pulmonology",
  "Austism",
  "Radiology",
  "ECG Management",
  "Physical Medicine & Rehabilitation",
  "Opthalmology",
  "Geriatric Medicine",
  "Neurology",
  "Infectious Disease",
  "Nephrology",
  "Ambulatory Care & Surgery",
  "Otolaryngology (ENT)",
  "Rheumatology",
  "Dental Health",
  "Chiropractic",
  "Psychiatry",
  "Urology",
  "Wound Care",
  "Orthopedic Surgery",
  "Behaviour Health",
  "Gastroenterology",
  "Anesthesiology",
  "Family Medicine",
  "Behavioral health therapy",
  "Acupuncture",
  "Lactation consulting",
  "Massage therapy",
  "Counseling",
  "Marriage and family therapy",
  "Psychology",
  "Social work",
  "Dietetics or nutrition counseling",
  "Applied behavior analysis",
  "Occupational therapy",
  "Physical therapy",
  "Speech-language pathology",
  "Substance use counseling",
  "Other",
];

const formatAppointmentOverlapMessage = (backendMsg) => {
  if (!backendMsg) return "";

  const match = backendMsg.match(/at (.+?) on ([0-9\-]+)/i);
  let facility = "this facility";
  let date = "";

  if (match) {
    facility = match[1].trim();
    date = match[2].trim();
  }

  const formattedDate = date
    ? moment(date, "YYYY-MM-DD").format("MMMM DD, YYYY")
    : "";

  return `There is an Existing Appointment Scheduled at ${facility} on ${formattedDate}. Kindly choose an alternative date or time`;
};

//------------------------------------------------Billing facility validation--------------------------------------------------------//
const NO_BILLING_FACILITY_APPOINTMENT_WARNING =
  "Appointments cannot be scheduled because no Billing Facility is enabled in the Facility Information. - After scheduling appointments";

const NewAppointment = (props) => {
  // ---------------------------------------- State and Variables Start--------------------------------------------------- //
  const { Option } = Select;
  const dispatch = useDispatch();
  const initialRender = useRef(true);
  var start = "";
  var end = "";
  const classes = useStyles();

  var currentDate = new Date();

  const roundDownToNearest5Minutes = (date) => {
    const ms = 1000 * 60 * 5;
    return new Date(Math.floor(date.getTime() / ms) * ms);
  };

  var roundedDate = roundDownToNearest5Minutes(currentDate);

  props.start ? (start = props.start.start) : (start = roundedDate);
  props.start
    ? (end = props.start.end)
    : (end = new Date(roundedDate.getTime() + 30 * 60000).toString());

  // Decrypt and Retrieve User Role and Account Information
  var accountType = Decrypt_Value(localStorage.getItem("account_type"), "vozo");
  var trial = Decrypt_Value(localStorage.getItem("trial_period"), "vozo");
  const bill_facility_id = useSelector(
    (state) => state.Schedule.BillingFacility,
  );
  const bookingData = useSelector((state) => state.Schedule.bookingData);
  const teleFlag = Decrypt_Value(
    localStorage.getItem("telehealth_flag"),
    "vozo",
  );

  const [showPopup, setShowPopup] = useState(false);
  const [onConfirm, setOnConfirm] = useState(null);

  const authorized = Decrypt_Value(localStorage.getItem("authorized"), "vozo");
  const userID = Decrypt_Value(localStorage.getItem("user_id"), "vozo");
  const main_pro = Decrypt_Value(localStorage.getItem("main_pro"), "vozo");
  const owner_id = Decrypt_Value(localStorage.getItem("owner_id"), "vozo");
  const storedNames = Decrypt_Value(localStorage.getItem("setroles"), "vozo");
  const group_id = Decrypt_Value(localStorage.getItem("group_id"), "vozo");
  let DBHost =
    localStorage.getItem("DBHost") &&
    Decrypt_Value(localStorage.getItem("DBHost"), "vozo");

  const ENABLE_REASON_DROPDOWN = DBHost?.toLowerCase() === "laibonhealth";

  // const ENABLE_REASON_DROPDOWN = true;

  const reasonOptions = [
    "Acute Care",
    "Focused Care",
    "Primary Care",
    "Occupational Health",
    "Membership Services",
    "New Patient Visit",
    "Established Patient Visit",
    "Urgent Care Visit",
    "Follow-Up Visit",
    "Focused Care Visit",
    "Wellness & Weight Management",
    "Occupational Health Visit",
    "Membership Visit",
  ];

  //States
  const [reason, setReason] = useState("");
  const [timeMismatch, setTimeMismatch] = useState(false);
  const [swict_check, setswict_check] = useState(false);
  const [Week_and_every, setWeek_and_every] = useState(false);
  const [Month_and_every, setMonth_and_every] = useState(false);
  const [Month_and_every_Interval, setMonth_and_every_Interval] = useState("");
  const [source, setSource] = useState([]);
  const [patientid, setpatientid] = useState("");
  const [popupWidth, setPopupWidth] = useState("270px");
  const [searchInput, setSearchInput] = useState("");

  const [searchInputValue, setSearchInputValue] = useState("");

  const [sourceroom, setSourceRoom] = useState([]);
  const [roomval, setRoomVal] = useState("");
  const [sourceprofile, setSourceprofile] = useState([]);
  const [profileid, setprofileid] = useState("");
  const [billingid, setbillingid] = useState("");
  const [sourceprovider, setSourceprovider] = useState([]);

  const [providerid, setproviderid] = useState("");
  const [sourceoffice, setSourceoffice] = useState([]);
  const [officeid, setofficeid] = useState("");
  const [sourcestatus, setSourcestatus] = useState([]);
  const [sourcestatustele, setSourcestatustele] = useState([]);

  const [statusid, setstatusid] = useState("");
  const dtFormat = localStorage.getItem("dateFormat");
  var dtFormatsec = `${dtFormat} hh:mm a`;
  const [aptdate, setaptdate] = useState("");
  const [dayswise, setdayswise] = useState(false);
  const [apttime, setapttime] = useState("");
  const [aptfromdate, setappfromdate] = useState("");
  const [apttodate, setapptodate] = useState("");
  const [SpinnerVal, setSpinnerVal] = useState(true);
  const [checking1, setchecking1] = useState(false);
  // const [telehealth, settelehealth] = useState([]);
  const [teleprofile, setteleprofile] = useState([]);
  const [Appttype, setAppttype] = useState(1);
  const [forteleornor, setforteleornor] = useState(1);
  const [videochck, setvideochck] = useState(false);
  const [patsrchvalue, setpatsrchvalue] = useState("");
  const [normalappointment, setnormalappointment] = useState(
    localStorage.getItem("normalapppopup") ? true : false,
  );

  const [showSuccess, setShowSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [teleappointment, setteleappointment] = useState(false);
  const [weekday, setweekday] = useState("");
  const [repeatselectnew, setrepeatselectnew] = useState("");
  const [repeatselect2new, setrepeatselect2new] = useState("0");
  const [timelimiterrorbox, settimelimiterrorbox] = useState(false);
  const [patError, setpatError] = useState(false);
  const [groupPatError, setGroupPatError] = useState(false);

  const [profileError, setprofileError] = useState(false);
  const [examroomError, setexamroomError] = useState(false);
  const [provError, setprovError] = useState(false);
  const [officeError, setofficeError] = useState(false);
  const [statusError, setstatusError] = useState(false);
  const [selectdayError, setselectdayError] = useState(false);
  const [notDisabledSpec, setNotDisabledSpec] = useState("");
  const [ModalAlerShow1, setModalAlerShow1] = useState(false);
  const [ModalMsg1, setModalMsg1] = useState("");
  const [walkincheck, setwalkincheck] = useState(false);
  const [patFlag, setPatFlag] = useState([]);
  const [isInitialWaitlistLoad, setIsInitialWaitlistLoad] = useState(false);
  const [isWaitlistDataLoaded, setIsWaitlistDataLoaded] = useState(false);
  const [fetchingOptions, setFetchingOptions] = useState(false);
  const returnPath = useSelector((state) => state.returnPath.path);
  const [emptyEmailWarning, setEmptyEmailWarning] = useState(false);

  var startformat = moment(start, "YYYY-MM-DD HH:mm:ss").format(
    "YYYY-MM-DD HH:mm:ss",
  );
  var endformat = moment(end, "YYYY-MM-DD HH:mm:ss").format(
    "YYYY-MM-DD HH:mm:ss",
  );
  var duration = moment(endformat, "YYYY-MM-DD HH:mm:ss").diff(
    moment(startformat, "YYYY-MM-DD HH:mm:ss"),
    "minutes",
  );
  const [billFacId, setBillFacId] = useState("");
  const [editing, setEditing] = useState(duration);
  const [btnDis, setBtnDis] = useState(false);
  const [showGroupModal, setShowGroupModal] = useState(false);

  const [startTime, setStartTime] = useState(9);
  const [endTime, setEndTime] = useState(17);
  const [repvalue, setrepValue] = useState("");
  const [day, setDay] = useState("");
  // const [month, setMonth] = useState("");
  // const [date, setDate] = useState("");
  const [dyOfMont, setDyOfMont] = useState("");
  const [wkOfMont, setWkOfMont] = useState("");
  // const [aftDate, setAftDate] = useState("");
  // const [onDate, setOnDate] = useState("");
  // const [occurence, setOccurence] = useState("1");
  const [custChk, setcustChk] = useState("");
  const [tempOpen, setTempOpen] = useState(false);
  const [inTimeErr, setInTimeErr] = useState(false);
  // const [wkErr, setWkErr] = useState(false);
  const [repeatselectmonth, setRepeatSelectMonth] = useState("1");
  const [endErrTime, setEndErrTime] = useState("");
  const [startErrTime, setStartErrTime] = useState("");
  const [frtimeSlots, setFromTimeSlots] = useState([]);
  const [totimeSlots, setToTimeSlots] = useState([]);
  // const currentTime = moment().format("h:mm a").split(" ");
  // const chekDate = moment().format("YYYY-MM-DD");
  const [upgrade, setUpgrade] = useState(false);
  const [userAvail, setUserAvail] = useState([]);
  const [Telehealthplatform, setTelehealthplatform] = useState("zoom");
  const [speciality, setSpeciality] = useState("");
  const [specialError, setSpecialError] = useState(false);
  const [allowAppt, setAllowAppt] = useState(0);
  // const [occurenceday, setOccurenceday] = useState();
  // const [occurencedayErr, setOccurencedayErr] = useState(false);
  const [lastdate, setLastdate] = useState(false);
  const [lastdateApp, setLastdateApp] = useState("");
  const [sortSpeciality, setSortSpecility] = useState("");
  const [dateErr, setDateErr] = useState(false);
  // const [billFacility, setBillFacility] = useState([]);
  // const [billFacilityID, setBillFacilityID] = useState("");
  // const [billFacilityError, setBillFacilityError] = useState(false);
  // changes by sridar
  const { state } = useLocation();
  // const location = useLocation();
  const history = useHistory();
  const [eid, setEid] = useState("");
  const [temShow, setTemShow] = useState(true);
  // const [clientAddIs, setClientAddIs] = useState(false);
  const [clientAddIs, setClientAddIs] = useState({ show: false, message: "" });
  const [showIntakeForm, setShowIntakeForm] = useState(false);
  const [intakeData, setIntakeData] = useState(null);
  const [show, setShow] = useState(false);
  const [id, setid] = useState(0);
  const [IdforDelete, setIdforDelete] = useState(0);
  const [singleRow, setSingleRow] = useState([]);
  const [showAvl, setShowAvl] = useState(true);
  const [switchvalue, setswitchvalue] = useState(false);
  const [WeeklyDisable, setWeeklyDisable] = useState("");
  const [changeTab, setChangeTag] = useState(
    props.ApptTab ? props.ApptTab : "1",
  );
  const [inTime, setInTime] = useState("");
  const [outTime, setOutTime] = useState("");
  const [fromShow, setFromShow] = useState(false);
  const [toShow, setToShow] = useState(false);
  const [fromId, setFromId] = useState("");
  const userid = Decrypt_Value(localStorage.getItem("user_id"), "vozo");
  const [clientFail1, setClientFail1] = useState(false);
  const [groupPatients, setGroupPatients] = useState([]);
  const [groupId, setGroupId] = useState(
    props.isGroupAppointment || props.isEditGroupAppointment
      ? props.dataObj.groupId
      : null,
  );
  const [loading, setLoading] = useState(false);
  // ---------------------------------------- State and Variables End--------------------------------------------------- //

  // ---------------------------------------- Functions Start----------------------------------------------------------- //
  const fetchGroupPatients = async ({ search = "", limit = 4 } = {}) => {
    setLoading(true);
    const payload = {
      group_name: search,
      limit: limit,
    };

    try {
      const response = await axiosInstance.get(`/vozo/grouppatientsearch`, {
        params: {
          search: JSON.stringify(payload),
        },
      });

      const res = Decrypt_Value(response.data, "vozo");

      setGroupPatients(res || []);
    } catch (error) {
      console.error("Group patient fetch error:", error);
      setGroupPatients([]);
    } finally {
      setLoading(false);
    }
  };

  // const handleClientCreateSuccess = (enablePortal, patientData) => {
  //   const msg = enablePortal
  //     ? "Client created successfully and portal access mail sent"
  //     : "Client created successfully";

  //   setSuccessMsg(msg);
  //   setShowSuccess(true);

  //   setTimeout(() => {
  //     setShowSuccess(false);
  //     setSuccessMsg("");

  //     if (enablePortal && patientData) {
  //       openIntake({
  //         id: patientData.id,
  //         name: patientData.name,
  //         email: patientData.email,
  //       });
  //     }
  //   }, 1800);
  // };

  const showAppointmentWarning = (message, duration = 5000) => {
    setBtnDis(false);
    setModalAlerShow1(false);
    setModalMsg1("");

    setTimeout(() => {
      setModalAlerShow1(true);
      setModalMsg1(message);
    }, 1);

    setTimeout(() => {
      setModalAlerShow1(false);
    }, duration);
  };

  const checkBillingFacilityEnabled = async () => {
    try {
      const response = await axiosInstance.get(
        `/vozo/facility/billing-count?t=${Date.now()}`,
      );

      const decryptedData = Decrypt_Value(response.data, "vozo");
      const billingCount = Number(decryptedData?.billing_count || 0);

      if (billingCount === 0) {
        showAppointmentWarning(NO_BILLING_FACILITY_APPOINTMENT_WARNING);
        return false;
      }

      return true;
    } catch (error) {
      console.error("Billing facility check failed:", error);

      showAppointmentWarning(
        "Unable to verify Billing Facility. Please try again.",
      );

      return false;
    }
  };

  const handleRefresh = () => {
    if (!storedNames.setProviderAvailability_viewOnly) {
      props.closepopup();
      props.FetchAppointments(
        props.provarray,
        props.facarray,
        props.appFromDate,
        props.apptoDate,
        props.pat_share,
        props.examroom,
      );
    } else {
      alert("You only have view-only access.");
    }
  };

  // changes by sridar
  const ClientAdd = (result) => {
    setClientAddIs(result);
  };
  const openIntake = (data) => {
    setShow(false);
    setIntakeData(data);
    setShowIntakeForm(true);

    const article = {
      mail: data.email,
      userID: userID,
      MailUrl: AccessMailUrl,
      pid: String(data.id),
    };

    let encrypted = Encrypt_Value(article, "vozo");
    axiosInstance
      .post("/vozo/patient/clientportalaccess/sendmail", encrypted)
      .catch((err) => {
        console.error("Portal mail sending failed", err);
      });
  };

  const enableSwitch = (checked) => {
    setswitchvalue(checked);
    const article = [
      {
        glname: "enable_availability_switch",
        glindex: "0",
        glvalue: checked === true ? "1" : "0",
      },
    ];
    let put_data_enc = Encrypt_Value(article, "vozo");
    axiosInstance
      .put("/vozo/settingdocument", put_data_enc)
      .then((response) => {});
  };

  //.....................

  const AddTemplate = () => {
    setShowAvl(!showAvl);
    setid(0);
    setEid("");
    setIdforDelete(0);
  };

  const handleShowuntildate = () => {
    setLastdate(true);
  };

  const handlerepSelect = (e) => {
    if (e === "Does not repeat") {
      setchecking1(false);
      setdayswise(false);
      setMonth_and_every(false);
      setrepeatselectnew("");
      setrepeatselect2new("");
      setRepeatSelectMonth("1");
      setweekday("");
      setcustChk("");
      setselectdayError(false);
    } else if (e === "Daily") {
      setstatusid("");
      setchecking1(true);
      setrepeatselectnew("1");
      setrepeatselect2new("0");
      setdayswise(false);
      setMonth_and_every(false);
      setselectdayError(false);
    } else if (e.includes("Week")) {
      setstatusid("");
      setchecking1(true);
      setdayswise(true);
      setMonth_and_every(false);
    }
    setrepValue(e);
  };

  const convertHMS = (value) => {
    return Math.floor(value * 60);
  };

  const disabledFromTimes = (time, meridiem, type) => {
    const now = moment();
    const currentTime = moment(`${time} ${meridiem}`, "h:mm A");
    const appointmentDate = moment(aptdate);
    if (appointmentDate.isSame(now, "day")) {
      if (type === 2 && currentTime.isBefore(now)) {
        return true;
      }
    }
    return false;
  };

  const disabledToTime = (time, meridiem, id, type) => {
    if (!inTime) return false;

    const fromTime = moment(inTime, "h:mm A");
    const toTime = moment(`${time} ${meridiem}`, "h:mm A");
    if (toTime.format("h:mm A") === "12:00 AM") {
      return false;
    }
    const appointmentDate = moment(aptdate);
    if (fromTime.isAfter(toTime) || fromTime.isSame(toTime)) {
      return true;
    }

    return false;
  };

  const handleIntroBack = () => {
    props.setShowStepSixIntro(false);
    props.setappshow(false);
    history.replace({
      pathname: "/schedule/nav/1",
      search: "?step=6.5",
    });
  };

  const handleIntroGotIt = async () => {
    props.setappshow(false);

    if (returnPath) {
      // Coming from account setup
      await axiosInstance.post(
        `/vozo/account-setup/complete-step?patient_id=${userid}&step_id=${"6.1"}`,
      );
      dispatch(clearReturnPath()); // Clear the return path
      return;
    }

    await axiosInstance
      .post(
        `/vozo/store/get-started?patient_id=${userid}&seen_intro=${"stepSix"}`,
      )
      .then((response) => {
        props.setShowStepSixIntro(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  function standardizeDate(inputDate) {
    let formats = [
      "YYYY-MM-DD", // 2023-01-15
      "YYYY/MM/DD", // 2023/01/15
      "MM-DD-YYYY", // 01-15-2023 (US format)
      "MM/DD/YYYY", // 01/15/2023 (US format)
      "DD-MM-YYYY", // 15-01-2023 (European format)
      "DD/MM/YYYY", // 15/01/2023 (European format)
    ];

    let date = moment(inputDate, formats, true); // strict mode
    if (!date.isValid()) {
      throw new Error(`Invalid date format: ${inputDate}`);
    }

    return date.format("YYYY-MM-DD");
  }

  const validateRepeatdate = () => {
    moment.locale("en");

    const validDays = weekday
      .filter((val) => val !== "" && !isNaN(val))
      .map(Number)
      .filter((d) => d >= 1 && d <= 7);

    if (validDays.length > 0) {
      const baseDate = moment(aptdate, dtFormat);
      const lastDate = moment(lastdateApp, dtFormat);

      if (!baseDate.isValid() || !lastDate.isValid()) {
        console.error("Invalid date formats for baseDate and lastDate");
        return "continue";
      } else {
        const baseWeekdayIndex = baseDate.day();
        const baseWeekdayVal =
          baseWeekdayIndex === 0 ? 1 : baseWeekdayIndex + 1;

        if (baseDate.isSame(lastDate) && validDays.includes(baseWeekdayVal)) {
          return "continue";
        }

        let nextOccur = baseDate.clone();
        let found = false;

        while (nextOccur.isSameOrBefore(lastDate)) {
          const weekdayIndex = nextOccur.day();
          const weekdayVal = weekdayIndex === 0 ? 1 : weekdayIndex + 1;

          if (validDays.includes(weekdayVal)) {
            found = true;
            break;
          }

          nextOccur.add(1, "day");
        }

        if (!found) {
          return "stop";
        }
      }
    }
    return "continue";
  };

  const hasWeekendOverlap = (startDateStr, endDateStr) => {
    let current = moment(startDateStr, "YYYY-MM-DD");
    const end = moment(endDateStr, "YYYY-MM-DD");

    while (current.isSameOrBefore(end, "day")) {
      const day = current.day(); // 0 = Sunday, 6 = Saturday
      if (day === 0 || day === 6) {
        return true;
      }
      current.add(1, "day");
    }

    return false;
  };

  const buttonClickActions = async (e) => {
    e.preventDefault();

    const isBillingFacilityEnabled = await checkBillingFacilityEnabled();

    if (!isBillingFacilityEnabled) {
      return;
    }
    if (repvalue === "Daily") {
      var overlapSatSun = hasWeekendOverlap(
        moment(aptdate, dtFormat).format("YYYY-MM-DD"),
        moment(lastdateApp, dtFormat).format("YYYY-MM-DD"),
      );
      if (overlapSatSun) {
        setShowPopup(true);
        setOnConfirm(() => () => remainingButtonClick(e));
      } else {
        remainingButtonClick(e);
      }
    } else {
      remainingButtonClick(e);
    }
  };
  const handleOpenGroupModal = () => setShowGroupModal(true);
  const handleCloseGroupModal = () => setShowGroupModal(false);
  const remainingButtonClick = async (e) => {
    let MonthOccurences;
    e.preventDefault();
    if (billFacId === undefined) {
      props.redirect();
      setBtnDis(false);
      return;
    }
    var statusid_temp;
    if (checking1 === true) {
      statusid_temp = "";
    } else {
      statusid_temp = statusid;
    }

    if (inTime === "") {
      setInTimeErr(true);
      setBtnDis(false);
      return;
    }

    let availcheckfilt = userAvail.filter((x) => {
      return x.pc_eventDate === aptdate;
    });

    if (availcheckfilt.length !== 0) {
      for (let appointment of availcheckfilt) {
        let intimeString = appointment.pc_eventDate + " " + inTime;
        let outtimeString = appointment.pc_eventDate + " " + outTime;

        let intimeDate = new Date(intimeString);
        let outtimeDate = new Date(outtimeString);
        let startTimeString =
          appointment.pc_eventDate + " " + appointment.pc_startTime;
        let endTimeString =
          appointment.pc_eventDate + " " + appointment.pc_endTime;
        let startTimeDate = new Date(startTimeString);
        let endTimeDate = new Date(endTimeString);

        // Check if outtime is the same as pc_startTime
        if (outtimeDate.getTime() === startTimeDate.getTime()) {
          // Skip the if condition and continue to the next appointment
          continue;
        }

        // Check if intime is the same as pc_endTime
        if (intimeDate.getTime() === endTimeDate.getTime()) {
          // Skip the if condition and continue to the next appointment
          continue;
        }

        // Check for overlap only if the conditions above are not met

        if (
          (startTimeDate <= outtimeDate && endTimeDate >= intimeDate) ||
          (endTimeDate >= intimeDate && startTimeDate <= outtimeDate) ||
          (startTimeDate <= intimeDate && endTimeDate >= outtimeDate)
        ) {
          setInTimeErr(true);
          setBtnDis(false);
          return;
          // You might add a break statement here if you want to exit the loop after finding an overlap
        } else {
          setInTimeErr(false);
        }
      }
    }

    const timenew_alert = moment(outTime, ["h:mm A"]).format("HH:mm");
    const time = timenew_alert.split(":");
    const timeHour = time[0];

    const a = moment(timenew_alert, "hh:mm A").format("hh:mm A");

    const maintime = moment(a, "h:mma");

    var b;
    if (endTime !== "12") {
      b = moment(`0${endTime - 12}:00pm`, "h:mma");
    } else {
      b = moment(`${endTime - 12}:00pm`, "h:mma");
    }

    if (inTimeErr || timelimiterrorbox) {
      setBtnDis(false);
      return false;
    }
    if (
      Number(startTime) <= Number(timeHour) &&
      Number(timeHour) <= Number(endTime)
    ) {
      settimelimiterrorbox(false);
    } else {
      settimelimiterrorbox(true);
      setBtnDis(false);
      return false;
    }

    let splitTime = apttime.split(":");
    let splitMin = splitTime[1].split(" ");

    if (splitMin[1] === "PM" && Number(splitTime[0]) !== Number(12)) {
      let totTime = +splitTime[0] + +12;
      if (totTime >= outTime) {
        settimelimiterrorbox(true);
        setBtnDis(false);
        return false;
      } else if (totTime < startTime) {
        settimelimiterrorbox(true);
        setBtnDis(false);
        return false;
      }
    }

    let outSplitTime = outTime.split(":");
    let outSplitMin = outSplitTime[1].split("");

    if (outSplitMin[1] === "PM" && Number(outSplitTime[0]) !== Number(12)) {
      let totTime = +outSplitTime[0] + +12;
      if (totTime >= outTime) {
        setBtnDis(false);
        settimelimiterrorbox(true);
        return false;
      }
    }

    // const toMinutes = (timeStr) => {
    //   const [time, modifier] = timeStr.split(" ");
    //   let [hours, minutes] = time.split(":").map(Number);
    //   if (modifier === "PM" && hours !== 12) hours += 12;
    //   if (modifier === "AM" && hours === 12) hours = 0;
    //   return hours * 60 + minutes;
    // };

    // // Convert numeric hour (like "5" or "16") to formatted string (e.g., "05:00 AM" or "04:00 PM")
    // const convertToTimeString = (hour) => {
    //   const numHour = Number(hour);
    //   const ampm = numHour >= 12 ? "PM" : "AM";
    //   const displayHour = numHour % 12 === 0 ? 12 : numHour % 12;
    //   return `${displayHour.toString().padStart(2, "0")}:00 ${ampm}`;
    // };

    // // Convert all times to minutes
    // const aptMinutes = toMinutes(apttime);
    // const outMinutes = toMinutes(outTime);
    // const startMinutes = toMinutes(convertToTimeString(startTime));
    // const endMinutes = toMinutes(convertToTimeString(endTime));

    // // Check conditions:
    // if (
    //   aptMinutes >= startMinutes &&
    //   aptMinutes < endMinutes &&
    //   outMinutes > startMinutes &&
    //   outMinutes <= endMinutes
    // ) {
    //   settimelimiterrorbox(false);
    // } else {
    //   settimelimiterrorbox(true);
    //   setBtnDis(false);
    //   return false;
    // }
    var timenew = aptdate + " " + apttime;
    var dtFormatWithTime1 = `${dtFormat} hh:mm a`;

    var timedetnew = moment(timenew, dtFormatWithTime1).format(
      "YYYY-MM-DD HH:mm a",
    );
    var durationnew = editing;
    var appttypenew = Appttype;
    // var alldaynew = alldaydisable;
    var walkinnew = walkincheck;
    var select1, select2, untildate, fromdate, todate, days_wise, repeats;
    if (weekday != null) {
      if (weekday || swict_check) {
        if (swict_check && (weekday === "" || weekday.length == 1)) {
          // setWkErr(true);
          setBtnDis(false);
          return false;
        } else {
          // setWkErr(false);
          repeats = weekday;
        }
      } else {
        repeats = "";
      }
    } else {
      repeats = "";
    }

    if (weekday && weekday.length > 0) {
      const repeatResponse = validateRepeatdate();

      if (repeatResponse === "stop") {
        setModalAlerShow1(true);
        setModalMsg1(
          "Please select an end date that matches the recurring day you've chosen",
        );
        setTimeout(() => setModalAlerShow1(false), 4000);
        setBtnDis(false);
        return false;
      }
    }

    if (repeatselectnew) {
      select1 = repeatselectnew;
    } else {
      select1 = 0;
    }

    if (repeatselect2new) {
      select2 = repeatselect2new;
    } else {
      select2 = "";
    }
    var repeat_type;

    if (checking1) {
      untildate = "";
      repeat_type = "notCustom";
    } else {
      untildate = "";
      repeat_type = "norepeat";
    }
    if (aptfromdate) {
      fromdate = aptfromdate;
    } else {
      fromdate = "";
    }

    if (apttodate) {
      todate = apttodate;
    } else {
      todate = "";
    }

    if (dayswise != null) {
      if (dayswise) {
        days_wise = true;
      } else {
        days_wise = false;
      }
    } else {
      days_wise = false;
    }

    var tempdatenew = moment(timedetnew, moment.defaultFormat).toDate();
    var startTimenew = moment(tempdatenew).format("hh:mm a");
    var returned_endatenew = moment(tempdatenew, dtFormatWithTime1)
      .add(durationnew, "minutes")
      .format("YYYY-MM-DD hh:mm a");
    var startdatenew = moment(tempdatenew, dtFormat).format("YYYY-MM-DD");
    var secondsnew = convertHMS(durationnew);
    var endTimenew = moment(outTime, "h:mm A").format("hh:mm a");
    var endDatenew = moment(returned_endatenew, "YYYY-MM-DD hh:mm a").format(
      "YYYY-MM-DD",
    );
    var MeetMode = Telehealthplatform;

    const repeatsString =
      repeats &&
      repeats
        .filter((value) => {
          if (typeof value === "number") {
            return !isNaN(value);
          }
          if (typeof value === "string") {
            const num = Number(value.trim());
            return !isNaN(num) && num !== "";
          }
          return false;
        })
        .map((value) =>
          typeof value === "string" ? Number(value.trim()) : value,
        )
        .filter((num) => num !== 0)
        .sort((a, b) => a - b)
        .join(",");

    // return // here

    const eventDateTime = moment(
      `${startdatenew} ${startTimenew}`,
      "YYYY-MM-DD hh:mm a",
    );

    // Get current time
    let now = moment();

    // Midnight special case
    const nowMinutes = now.minutes();
    const nowHour = now.hours(); // 0 = midnight

    if (nowHour === 0 && nowMinutes < 5) {
      // Subtract only enough minutes to reach 12:00 AM
      now = now.subtract(nowMinutes, "minutes");
    } else {
      // All other times — subtract 5 minutes
      now = now.subtract(5, "minutes");
    }

    // Check if event date/time is before adjusted current time
    if (eventDateTime.isSameOrBefore(now) && appttypenew == 2) {
      setModalAlerShow1(true);
      setModalMsg1(
        "Your Telehealth appointments cannot be scheduled for past Telehealth availability dates",
      );
      setTimeout(() => setModalAlerShow1(false), 4000);
      setBtnDis(false);
      return false;
    }
    let groupStatusGenerated = [];

    if (changeTab === "3" || props.isGroupAppointment) {
      let groupStatus = appttypenew == 1 ? "EMAIL" : "doc_confirmed";
      // find selected group
      const selectedGroup = groupPatients.find(
        (group) => group.value === groupId,
      );

      if (selectedGroup && selectedGroup.pid) {
        groupStatusGenerated = selectedGroup.pid
          .split(",")
          .map((pid) => pid.trim())
          .filter((pid) => pid) // remove empty values
          .map((pid) => ({
            pid: Number(pid),
            status: groupStatus, // "doc_confirmed"
          }));
      }
    }

    var article = {
      pc_pid: patientid,
      pc_catid: profileid,
      pc_billid: billingid !== "" ? Number(billingid) : null,
      pc_aid: providerid,
      pc_title: statusid_temp,
      pc_duration: secondsnew,
      pc_hometext: "",
      pc_apptstatus: statusid_temp,
      pc_eventDate: startdatenew,
      pc_endDate: endDatenew,
      pc_startTime: startTimenew,
      pc_endTime: endTimenew,
      pc_facility: officeid,
      pc_informant: providerid,
      pc_billing_location: "10",
      pc_select1: select1,
      pc_select2: select2,
      pc_untildate:
        untildate !== ""
          ? moment(untildate).format("YYYY-MM-DD")
          : moment(lastdateApp, dtFormat).format("YYYY-MM-DD"),

      pc_lastdate: moment(lastdateApp, dtFormat).format("YYYY-MM-DD"),
      pc_fromdate: fromdate,
      pc_todate: todate,
      days_wise: days_wise,
      days_of_week: repeatsString,
      // allday: alldaynew,
      repeats: repeats,
      // appttype: appttypenew,
      appttype: walkincheck && allowAppt === 2 ? 2 : appttypenew,
      walkin: walkinnew,
      examRoom: roomval,
      id: authorized === "1" ? userID : main_pro,
      pc_repeat_type: repeat_type,
      week_and_every_day: Week_and_every,
      month_and_every_day: Month_and_every,
      Month_and_every_Interval: Month_and_every_Interval,

      on_never_after: custChk,
      repeat_select: repvalue,
      pc_repeatselectmonth: repeatselectmonth,
      selectMonthAlp:
        repeatselectmonth === 1 || repeatselectmonth === "1"
          ? `Monthly on day ${dyOfMont}`
          : `Monthly on the ${wkOfMont} ${day}`,
      repeatSelectMonthOccurenceDates: MonthOccurences,
      speciality,
      mode: MeetMode,
      reason: reason,
      isGroup: 0,
      // billingFacilityId: billFacilityID,
    };
    const groupAppointmentArticle = {
      group_status: groupStatusGenerated,
      isGroup: 1,
      pc_pid: groupId,
      pc_catid: profileid,
      pc_billid: billingid !== "" ? Number(billingid) : null,
      pc_aid: providerid,
      pc_title: statusid_temp,
      pc_duration: secondsnew,
      pc_hometext: "",
      pc_apptstatus: statusid_temp,
      pc_eventDate: startdatenew,
      pc_endDate: endDatenew,
      pc_startTime: startTimenew,
      pc_endTime: endTimenew,
      pc_facility: officeid,
      pc_informant: providerid,
      pc_billing_location: "10",
      pc_select1: select1,
      pc_select2: select2,
      pc_untildate:
        untildate !== ""
          ? moment(untildate).format("YYYY-MM-DD")
          : moment(lastdateApp, dtFormat).format("YYYY-MM-DD"),

      pc_lastdate: moment(lastdateApp, dtFormat).format("YYYY-MM-DD"),
      pc_fromdate: fromdate,
      pc_todate: todate,
      days_wise: days_wise,
      days_of_week: repeatsString,
      // allday: alldaynew,
      repeats: repeats,
      // appttype: appttypenew,
      appttype: walkincheck && allowAppt === 2 ? 2 : appttypenew,
      walkin: walkinnew,
      examRoom: roomval,
      id: authorized === "1" ? userID : main_pro,
      pc_repeat_type: repeat_type,
      week_and_every_day: Week_and_every,
      month_and_every_day: Month_and_every,
      Month_and_every_Interval: Month_and_every_Interval,

      on_never_after: custChk,
      repeat_select: repvalue,
      pc_repeatselectmonth: repeatselectmonth,
      selectMonthAlp:
        repeatselectmonth === 1 || repeatselectmonth === "1"
          ? `Monthly on day ${dyOfMont}`
          : `Monthly on the ${wkOfMont} ${day}`,
      repeatSelectMonthOccurenceDates: MonthOccurences,
      speciality,
      mode: MeetMode,
      reason: reason,

      // billingFacilityId: billFacilityID,
    };

    const finalArticle =
      changeTab === "3" || props.isGroupAppointment
        ? groupAppointmentArticle
        : article;
    let encryptedData = Encrypt_Value(finalArticle, "vozo");

    const startTimeCheck = moment(startTimenew, "hh:mm A");
    const endTimeCheck = moment(endTimenew, "hh:mm A");
    if (select1 === 0) {
      let error = 1;
      if (
        (patientid === "" && groupId === null) ||
        profileid === "" ||
        providerid === "" ||
        providerid === null ||
        providerid === undefined ||
        endTimeCheck.isBefore(startTimeCheck) ||
        aptdate === "" ||
        officeid === "" ||
        speciality === "" ||
        (roomval === "" && !isSuffixEnabledSite) ||
        // billFacilityID === "" ||
        // billFacilityID === null ||
        (repvalue === "Week" && (weekday === "" || weekday.length == 0))
      ) {
        if (patientid === "" && groupId === null) {
          setpatError(true);
          setGroupPatError(true);
          error = 2;
        }
        if (aptdate === "") {
          setDateErr(true);
          error = 2;
        }
        if (profileid === "") {
          setprofileError(true);
          error = 2;
        }
        if (roomval === "" && !isSuffixEnabledSite) {
          setexamroomError(true);
          error = 2;
        }
        if (!endTimeCheck.isAfter(startTimeCheck)) {
          setTimeMismatch(true);
          error = 2;
        }

        if (repvalue === "Week" && (weekday === "" || weekday.length == 0)) {
          setselectdayError(true);
          error = 2;
        }
        if (
          providerid === "" ||
          providerid === null ||
          providerid === undefined
        ) {
          setprovError(true);
          error = 2;
        }
        if (officeid === "") {
          setofficeError(true);
          error = 2;
        }
        if (speciality === "") {
          setSpecialError(true);
          error = 2;
        }
        // if (billFacilityID === "" || billFacilityID === null) {
        //   setBillFacilityError(true);
        //   return;
        // }

        if (error > 1) {
          setBtnDis(false);
          return false;
        }
      } else {
        // setSpinnerVal(true);
        setBtnDis(true);
        if (statusid === "doc_confirmed" || statusid === "EMAIL") {
          axiosInstance
            .get("/vozo/pat_mail_check?pid=" + patientid)
            .then((response) => {
              if (response.data) {
                // props.setspinnerfornewapp();
                axiosInstance
                  .post("/vozo/appointment?pid=" + patientid, encryptedData)
                  .then((res) => {
                    setBtnDis(true);
                    let apptAdded = res.data;
                    // return;
                    if (
                      MeetMode === "GMeet" &&
                      videochck &&
                      (statusid === "doc_confirmed" || statusid === "EMAIL")
                    ) {
                      axiosInstance
                        .get("/vozo/getGMeet/data")
                        .then(async (response) => {
                          var res = Decrypt_Value(response.data, "vozo");

                          let article = {
                            start_time: res["start_time"],
                            end_time: res["end_time"],
                            attendees: res["attendees"],
                            start: res["pc_startTime"],
                            end: res["pc_endTime"],
                            eventdate: res["pc_eventDate"],
                            eid: res["pc_eid"],
                            aid: res["pc_aid"],
                            pid: res["pc_pid"],
                            fac_id: res["pc_facility"],
                          };

                          if (props.fromWaitList) {
                            await deleteWaitlistEntry(props.waitlistData.id);
                          }

                          axios
                            .get(
                              fileurl +
                                "/interface/customized/g-meet/index.php?action=create",
                              { params: article },
                            )
                            .then((res) => {
                              // setBtnDis(false);

                              if (apptAdded === "out of both range") {
                                setBtnDis(false);

                                setModalAlerShow1(true);
                                setModalMsg1(
                                  "Selected Date & time should be within the provider availability range.",
                                );
                                setTimeout(
                                  () => setModalAlerShow1(false),
                                  2000,
                                );
                                return;
                              } else if (apptAdded === "out of time range") {
                                setBtnDis(false);

                                setModalAlerShow1(true);
                                setModalMsg1(
                                  "Selected time should be within the provider availability range.",
                                );
                                setTimeout(
                                  () => setModalAlerShow1(false),
                                  2000,
                                );
                                return;
                              } else if (apptAdded === "out of date range") {
                                setBtnDis(false);

                                setModalAlerShow1(true);
                                setModalMsg1(
                                  "Selected Date should be within the provider availability range.",
                                );
                                setTimeout(
                                  () => setModalAlerShow1(false),
                                  2000,
                                );
                                return;
                              } else if (
                                apptAdded === "Provider Not Available"
                              ) {
                                setBtnDis(false);

                                setTimeout(() => {
                                  setModalAlerShow1(true);
                                  setModalMsg1("Provider Not Available");
                                }, 1);

                                setTimeout(
                                  () => setModalAlerShow1(false),
                                  2000,
                                );
                                return;
                              } else if (
                                apptAdded ===
                                "You Can't place the Appointment at this time"
                              ) {
                                setBtnDis(false);

                                setTimeout(() => {
                                  setModalAlerShow1(true);
                                  setModalMsg1(
                                    "You Can't place the Appointment at this time",
                                  );
                                }, 1);

                                setTimeout(
                                  () => setModalAlerShow1(false),
                                  2000,
                                );
                                return;
                              } else if (
                                apptAdded.includes(
                                  "You are only allowed to add telehealth appointments",
                                )
                              ) {
                                setBtnDis(false);

                                setTimeout(() => {
                                  setModalAlerShow1(true);
                                  setModalMsg1(apptAdded);
                                }, 1);

                                setTimeout(
                                  () => setModalAlerShow1(false),
                                  3000,
                                );
                                return;
                              } else if (
                                apptAdded.includes(
                                  "Appointment already scheduled at",
                                )
                              ) {
                                setBtnDis(false);

                                setTimeout(() => {
                                  setModalAlerShow1(true);
                                  setModalMsg1(
                                    formatAppointmentOverlapMessage(apptAdded),
                                  );
                                }, 1);

                                setTimeout(
                                  () => setModalAlerShow1(false),
                                  3000,
                                );
                                return;
                              } else if (
                                apptAdded.includes(
                                  "The provider is unavailable on these dates",
                                )
                              ) {
                                setBtnDis(false);

                                setTimeout(() => {
                                  setModalAlerShow1(true);
                                  setModalMsg1(apptAdded);
                                }, 1);

                                setTimeout(
                                  () => setModalAlerShow1(false),
                                  3000,
                                );
                                return;
                              } else {
                                setBtnDis(true);

                                props.savealertmsg(
                                  "New Appointment Added Successfully",
                                  true,
                                );
                                setBtnDis(true);
                                axiosInstance
                                  .get("/vozo/tele/checkemailsent")
                                  .then((response) => {
                                    setBtnDis(true);
                                    setSpinnerVal(false);
                                    props.savealertmsg(response.data, true);
                                    // props.onBookAppointment(startdatenew);
                                    setTimeout(() => {
                                      props.popuphide();
                                      props.closepopup();
                                    }, 4000);
                                  })
                                  .catch((err) => {
                                    setSpinnerVal(false);
                                    console.error(err);
                                    setBtnDis(false);
                                    props.closepopup();
                                  });

                                // props.setBookAgain(false);
                              }
                              setBtnDis(true);
                              setTimeout(() => props.popuphide(), 4000);
                              props.FetchAppointments(
                                props.provarray,
                                props.facarray,
                                props.appFromDate,
                                props.apptoDate,
                                props.pat_share,
                                props.examroom,
                                [],
                                aptdate,
                              );

                              if (
                                typeof props.onBookAppointment === "function"
                              ) {
                                props.onBookAppointment(aptdate);
                              }
                            })
                            .catch((err) => {
                              console.log("failed");
                            });
                        })
                        .catch((err) => {
                          console.error(err);
                        });
                    } else {
                      // setBtnDis(false);

                      if (apptAdded === "out of both range") {
                        setBtnDis(false);

                        setModalAlerShow1(true);
                        setModalMsg1(
                          "Selected Date & time should be within the provider availability range.",
                        );
                        setTimeout(() => setModalAlerShow1(false), 4000);
                        return;
                      } else if (apptAdded === "out of time range") {
                        setBtnDis(false);

                        setModalAlerShow1(true);
                        setModalMsg1(
                          "Selected time should be within the provider availability range.",
                        );
                        setTimeout(() => setModalAlerShow1(false), 4000);
                        return;
                      } else if (apptAdded === "out of date range") {
                        setBtnDis(false);

                        setModalAlerShow1(true);
                        setModalMsg1(
                          "Selected Date should be within the provider availability range.",
                        );
                        setTimeout(() => setModalAlerShow1(false), 4000);
                        return;
                      } else if (
                        apptAdded ===
                        "You Can't place the Appointment at this time"
                      ) {
                        setBtnDis(false);

                        setModalAlerShow1(true);
                        setModalMsg1(
                          "You Can't place the Appointment at this time",
                        );
                        setTimeout(() => setModalAlerShow1(false), 4000);
                        return;
                      } else if (
                        apptAdded.includes(
                          "You are only allowed to add telehealth appointments",
                        )
                      ) {
                        setBtnDis(false);

                        setTimeout(() => {
                          setModalAlerShow1(true);
                          setModalMsg1(apptAdded);
                        }, 1);

                        setTimeout(() => setModalAlerShow1(false), 3000);
                        return;
                      } else if (
                        apptAdded.includes(
                          "The provider is unavailable on these dates",
                        )
                      ) {
                        setBtnDis(false);

                        setTimeout(() => {
                          setModalAlerShow1(true);
                          setModalMsg1(apptAdded);
                        }, 1);

                        setTimeout(() => setModalAlerShow1(false), 3000);
                        return;
                      } else if (
                        apptAdded.includes("Appointment already scheduled at")
                      ) {
                        setBtnDis(false);

                        setTimeout(() => {
                          setModalAlerShow1(true);
                          setModalMsg1(
                            formatAppointmentOverlapMessage(apptAdded),
                          );
                        }, 1);

                        setTimeout(() => setModalAlerShow1(false), 3000);
                        return;
                      } else {
                        setBtnDis(true);

                        props.savealertmsg(
                          "New Appointment Added Successfully",
                          true,
                        );

                        axiosInstance
                          .get("/vozo/getGMeet/data")
                          .then(async (response) => {
                            var res = Decrypt_Value(response.data, "vozo");
                            let article = {
                              start_time: res["start_time"],
                              end_time: res["end_time"],
                              attendees: res["attendees"],
                              start: res["pc_startTime"],
                              end: res["pc_endTime"],
                              eventdate: res["pc_eventDate"],
                              eid: res["pc_eid"],
                              aid: res["pc_aid"],
                              pid: res["pc_pid"],
                              fac_id: res["pc_facility"],
                              name: res["pat_name"],
                              geventid: res["gevent"],
                              google_appt_sync: res["google_appt_sync"],
                              google_availability_sync:
                                res["google_availability_sync"],
                              uid: userID,
                              tenant_id: DBHost,
                              outlook_appt_sync: res["outlook_appt_sync"],
                              outlook_availability_sync:
                                res["outlook_availability_sync"],
                              user_id: userID,
                              is_telehealth: res["pc_telehealth"],
                            };
                            if (res["google_appt_sync"] === 1) {
                              axios
                                .get(
                                  fileurl +
                                    "/interface/customized/g-meet/index.php?action=create",
                                  { params: article },
                                )
                                .then((res) => {
                                  // setBtnDis(false);
                                })
                                .catch((err) => {
                                  console.log("failed");
                                });
                            }
                            if (res["outlook_appt_sync"] === 1) {
                              axios.post(
                                fileurl +
                                  "/interface/customized/outlook/create_event.php",
                                { params: article },
                              );
                            }
                          })
                          .catch((err) => {
                            console.error(err);
                          });

                        if (
                          statusid === "doc_confirmed" ||
                          statusid === "EMAIL"
                        ) {
                          axiosInstance
                            .get("/vozo/tele/checkemailsent")
                            .then((response) => {
                              setSpinnerVal(false);
                              props.savealertmsg(response.data, true);
                              // props.onBookAppointment(startdatenew);
                              setTimeout(() => {
                                props.popuphide();
                                props.closepopup();
                              }, 4000);
                            })
                            .catch((err) => {
                              setSpinnerVal(false);
                              console.error(err);
                              props.closepopup();
                            });
                        } else {
                          props.closepopup();
                        }

                        // props.setBookAgain(false);
                      }
                      setTimeout(() => props.popuphide(), 4000);
                      props.FetchAppointments(
                        props.provarray,
                        props.facarray,
                        props.appFromDate,
                        props.apptoDate,
                        props.pat_share,
                        props.examroom,
                        [],
                        aptdate,
                      );
                      if (typeof props.onBookAppointment === "function") {
                        props.onBookAppointment(aptdate);
                      }
                    }
                  })
                  .catch((err) => console.error(err));
              }
              // else {
              //   alert("Please update a valid Email in Patient Demographics");
              //   props.closepopup();
              // }
              // setBtnDis(false);
            })
            .catch((err) => {
              setSpinnerVal(false);
              setBtnDis(false);
              console.error(err);
            });
        } else {
          // props.setspinnerfornewapp();
          axiosInstance
            .post("/vozo/appointment?pid=" + patientid, encryptedData)
            .then((res) => {
              setBtnDis(true);
              let apptAdded = res.data;
              // return;
              // props.setNewShow(false);
              // props.setBookAgain(false);

              // setBtnDis(false);

              if (apptAdded === "out of both range") {
                setBtnDis(false);

                setModalAlerShow1(true);
                setModalMsg1(
                  "Selected Date & time should be within the provider availability range.",
                );
                setTimeout(() => setModalAlerShow1(false), 4000);
                return;
              } else if (apptAdded === "out of time range") {
                setBtnDis(false);

                setTimeout(() => {
                  setModalAlerShow1(true);
                  setModalMsg1(
                    "Selected time should be within the provider availability range.",
                  );
                }, 1);

                setTimeout(() => setModalAlerShow1(false), 4000);
                return;
              } else if (apptAdded === "Provider Not Available") {
                setBtnDis(false);

                setTimeout(() => {
                  setModalAlerShow1(true);
                  setModalMsg1("Provider Not Available");
                }, 1);

                setTimeout(() => setModalAlerShow1(false), 4000);
                return;
              } else if (
                apptAdded === "You Can't place the Appointment at this time"
              ) {
                setBtnDis(false);

                setTimeout(() => {
                  setModalAlerShow1(true);
                  setModalMsg1("You Can't place the Appointment at this time");
                }, 1);

                setTimeout(() => setModalAlerShow1(false), 4000);
                return;
              } else if (apptAdded === "out of date range") {
                setBtnDis(false);

                setModalAlerShow1(true);
                setModalMsg1(
                  "Selected Date should be within the provider availability range.",
                );
                setTimeout(() => setModalAlerShow1(false), 4000);
                return;
              } else if (
                apptAdded.includes(
                  "You are only allowed to add telehealth appointments",
                )
              ) {
                setBtnDis(false);

                setTimeout(() => {
                  setModalAlerShow1(true);
                  setModalMsg1(apptAdded);
                }, 1);

                setTimeout(() => setModalAlerShow1(false), 3000);
                return;
              } else if (
                apptAdded.includes("The provider is unavailable on these dates")
              ) {
                setBtnDis(false);

                setTimeout(() => {
                  setModalAlerShow1(true);
                  setModalMsg1(apptAdded);
                }, 1);

                setTimeout(() => setModalAlerShow1(false), 3000);
                return;
              } else if (
                apptAdded.includes("Appointment already scheduled at")
              ) {
                setBtnDis(false);

                setTimeout(() => {
                  setModalAlerShow1(true);
                  setModalMsg1(formatAppointmentOverlapMessage(apptAdded));
                }, 1);

                setTimeout(() => setModalAlerShow1(false), 3000);
                return;
              } else {
                setBtnDis(true);

                props.savealertmsg("New Appointment Added Successfully", true);

                axiosInstance
                  .get("/vozo/getGMeet/data")
                  .then(async (response) => {
                    var res = Decrypt_Value(response.data, "vozo");

                    let article = {
                      start_time: res["start_time"],
                      end_time: res["end_time"],
                      attendees: res["attendees"],
                      start: res["pc_startTime"],
                      end: res["pc_endTime"],
                      eventdate: res["pc_eventDate"],
                      eid: res["pc_eid"],
                      aid: res["pc_aid"],
                      pid: res["pc_pid"],
                      fac_id: res["pc_facility"],
                      name: res["pat_name"],
                      geventid: res["gevent"],
                      google_appt_sync: res["google_appt_sync"],
                      google_availability_sync: res["google_availability_sync"],
                      uid: userID,
                      tenant_id: DBHost,
                      outlook_appt_sync: res["outlook_appt_sync"],
                      outlook_availability_sync:
                        res["outlook_availability_sync"],
                      user_id: userID,
                      is_telehealth: res["pc_telehealth"],
                    };
                    if (res["google_appt_sync"] === 1) {
                      axios
                        .get(
                          fileurl +
                            "/interface/customized/g-meet/index.php?action=create",
                          { params: article },
                        )
                        .then((res) => {})
                        .catch((err) => {
                          console.log("failed");
                        });
                    }
                    if (res["outlook_appt_sync"] === 1) {
                      axios.post(
                        fileurl +
                          "/interface/customized/outlook/create_event.php",
                        { params: article },
                      );
                    }
                  })
                  .catch((err) => {
                    console.error(err);
                  });

                if (statusid === "doc_confirmed") {
                  axiosInstance
                    .get("/vozo/getGMeet/data")
                    .then((response) => {
                      // console.log(response);
                    })
                    .catch((err) => {
                      setSpinnerVal(false);
                      console.error(err);
                    });

                  axiosInstance
                    .get("/vozo/tele/checkemailsent")
                    .then((response) => {
                      setSpinnerVal(false);
                      props.savealertmsg(response.data, true);
                      // props.onBookAppointment(startdatenew);
                      setTimeout(() => {
                        props.popuphide();
                        props.closepopup();
                      }, 4000);
                    })
                    .catch((err) => {
                      props.closepopup();
                      setSpinnerVal(false);
                      console.error(err);
                    });
                } else {
                  props.closepopup();
                }
                // props.setBookAgain(false);
              }
              setTimeout(() => props.popuphide(), 4000);
              setSpinnerVal(false);

              props.FetchAppointments(
                props.provarray,
                props.facarray,
                props.appFromDate,
                props.apptoDate,
                props.pat_share,
                props.examroom,
                [],
                aptdate,
              );
              if (typeof props.onBookAppointment === "function") {
                props.onBookAppointment(aptdate);
              }

              // setBtnDis(false);
            })
            .catch((err) => {
              console.error(err);
              props.closepopup();
              setBtnDis(false);
            });
        }
      }
    } else if (select1 > 0) {
      let error = 1;
      if (
        patientid === "" ||
        profileid === "" ||
        providerid === "" ||
        providerid === null ||
        !endTimeCheck.isAfter(startTimeCheck) ||
        providerid === undefined ||
        aptdate === "" ||
        // statusid === "" ||
        officeid === "" ||
        (roomval === "" && !isSuffixEnabledSite) ||
        speciality === "" ||
        // billFacilityID === "" ||
        // billFacilityID === null ||
        (repvalue === "Week" && (weekday === "" || weekday.length == 0))
        // ||
        // untildate === ""
      ) {
        if (patientid === "" && groupId === null) {
          setpatError(true);
          setGroupPatError(true);
          error = 2;
        }
        if (aptdate === "") {
          setDateErr(true);
          error = 2;
        }
        if (profileid === "") {
          setprofileError(true);
          error = 2;
        }
        if (roomval === "" && !isSuffixEnabledSite) {
          setexamroomError(true);
          error = 2;
        }
        if (!endTimeCheck.isAfter(startTimeCheck)) {
          setTimeMismatch(true);
          error = 2;
        }
        // if (billFacilityID === "" || billFacilityID === null) {
        //   setBillFacilityError(true);
        //   error = 2;
        // }

        if (repvalue === "Week" && (weekday === "" || weekday.length == 0)) {
          setselectdayError(true);
          error = 2;
        }

        if (
          providerid === "" ||
          providerid === null ||
          providerid === undefined
        ) {
          setprovError(true);
          error = 2;
        }

        if (officeid === "") {
          setofficeError(true);
          error = 2;
        }

        if (speciality === "") {
          setSpecialError(true);
          error = 2;
        }

        // if (untildate === "") {
        //   setuntildateError(true);
        //   error = 2;
        // }

        if (error > 1) {
          setBtnDis(false);
          return false;
        }
      } else {
        setBtnDis(true);
        if (statusid === "doc_confirmed") {
          axiosInstance
            .get("/vozo/pat_mail_check?pid=" + patientid)
            .then((response) => {
              if (response.data) {
                // props.setspinnerfornewapp();
                setSpinnerVal(false);

                axiosInstance
                  .post("/vozo/appointment?pid=" + patientid, encryptedData)
                  .then((res) => {
                    setBtnDis(true);
                    let apptAdded = res.data;

                    if (
                      MeetMode === "GMeet" &&
                      videochck &&
                      (statusid === "doc_confirmed" || statusid === "EMAIL")
                    ) {
                      axiosInstance
                        .get("/vozo/getGMeet/data")
                        .then(async (response) => {
                          var res = Decrypt_Value(response.data, "vozo");
                          let article = {
                            start_time: res["start_time"],
                            end_time: res["end_time"],
                            attendees: res["attendees"],
                            start: res["pc_startTime"],
                            end: res["pc_endTime"],
                            eventdate: res["pc_eventDate"],
                            eid: res["pc_eid"],
                            aid: res["pc_aid"],
                            pid: res["pc_pid"],
                          };
                          if (props.fromWaitList) {
                            await deleteWaitlistEntry(props.waitlistData.id);
                          }
                          axios
                            .get(
                              fileurl +
                                "/interface/customized/g-meet/index.php?action=create",
                              { params: article },
                            )
                            .then((res) => {})
                            .catch((err) => {
                              console.log("failed");
                            });
                        })
                        .catch((err) => {
                          console.error(err);
                        });
                    }

                    // setBtnDis(false);

                    if (apptAdded === "out of both range") {
                      setBtnDis(false);

                      setModalAlerShow1(true);
                      setModalMsg1(
                        "Selected Date & time should be within the provider availability range.",
                      );
                      setTimeout(() => setModalAlerShow1(false), 4000);
                      return;
                    } else if (apptAdded === "out of time range") {
                      setBtnDis(false);

                      setModalAlerShow1(true);
                      setModalMsg1(
                        "Selected time should be within the provider availability range.",
                      );
                      setTimeout(() => setModalAlerShow1(false), 4000);
                      return;
                    } else if (apptAdded === "out of date range") {
                      setBtnDis(false);

                      setModalAlerShow1(true);
                      setModalMsg1(
                        "Selected Date should be within the provider availability range.",
                      );
                      setTimeout(() => setModalAlerShow1(false), 4000);
                      return;
                    } else if (apptAdded === "Provider Not Available") {
                      setBtnDis(false);

                      setTimeout(() => {
                        setModalAlerShow1(true);
                        setModalMsg1("Provider Not Available");
                      }, 1);

                      setTimeout(() => setModalAlerShow1(false), 4000);
                      return;
                    } else if (
                      apptAdded ===
                      "You Can't place the Appointment at this time"
                    ) {
                      setBtnDis(false);

                      setTimeout(() => {
                        setModalAlerShow1(true);
                        setModalMsg1(
                          "You Can't place the Appointment at this time",
                        );
                      }, 1);

                      setTimeout(() => setModalAlerShow1(false), 4000);
                      return;
                    } else if (
                      apptAdded.includes(
                        "You are only allowed to add telehealth appointments",
                      )
                    ) {
                      setBtnDis(false);

                      setTimeout(() => {
                        setModalAlerShow1(true);
                        setModalMsg1(apptAdded);
                      }, 1);

                      setTimeout(() => setModalAlerShow1(false), 3000);
                      return;
                    } else if (
                      apptAdded.includes(
                        "The provider is unavailable on these dates",
                      )
                    ) {
                      setBtnDis(false);

                      setTimeout(() => {
                        setModalAlerShow1(true);
                        setModalMsg1(apptAdded);
                      }, 1);

                      setTimeout(() => setModalAlerShow1(false), 3000);
                      return;
                    } else if (
                      apptAdded.includes("Appointment already scheduled at")
                    ) {
                      setBtnDis(false);

                      setTimeout(() => {
                        setModalAlerShow1(true);
                        setModalMsg1(
                          formatAppointmentOverlapMessage(apptAdded),
                        );
                      }, 1);

                      setTimeout(() => setModalAlerShow1(false), 3000);
                      return;
                    } else {
                      setBtnDis(true);

                      props.savealertmsg(
                        "New Appointment Added Successfully",
                        true,
                      );
                      axiosInstance
                        .get("/vozo/getGMeet/data")
                        .then(async (response) => {
                          var res = Decrypt_Value(response.data, "vozo");

                          let article = {
                            start_time: res["start_time"],
                            end_time: res["end_time"],
                            attendees: res["attendees"],
                            start: res["pc_startTime"],
                            end: res["pc_endTime"],
                            eventdate: res["pc_eventDate"],
                            enddate: res["pc_endDate"],
                            eid: res["pc_eid"],
                            aid: res["pc_aid"],
                            pid: res["pc_pid"],
                            fac_id: res["pc_facility"],
                            name: res["pat_name"],
                            geventid: res["gevent"],
                            google_appt_sync: res["google_appt_sync"],
                            google_availability_sync:
                              res["google_availability_sync"],
                            uid: userID,
                            tenant_id: DBHost,
                            outlook_appt_sync: res["outlook_appt_sync"],
                            outlook_availability_sync:
                              res["outlook_availability_sync"],
                            user_id: userID,
                          };
                          if (res["google_appt_sync"] === 1) {
                            axios
                              .get(
                                fileurl +
                                  "/interface/customized/g-meet/index.php?action=create",
                                { params: article },
                              )
                              .then((res) => {
                                // setBtnDis(false);
                              })
                              .catch((err) => {
                                console.log("failed");
                              });
                          }
                          if (res["outlook_appt_sync"] === 1) {
                            axios.post(
                              fileurl +
                                "/interface/customized/outlook/create_event.php",
                              { params: article },
                            );
                          }
                        })
                        .catch((err) => {
                          console.error(err);
                        });
                      if (statusid === "doc_confirmed") {
                        axiosInstance
                          .get("/vozo/tele/checkemailsent")
                          .then((response) => {
                            props.savealertmsg(response.data, true);
                            // props.onBookAppointment(startdatenew);
                            setTimeout(() => {
                              props.popuphide();
                              props.closepopup();
                            }, 4000);
                          })
                          .catch((err) => {
                            console.error(err);
                            props.closepopup();
                          });
                      } else {
                        props.closepopup();
                      }
                    }
                    setTimeout(() => props.popuphide(), 4000);
                    props.FetchAppointments(
                      props.provarray,
                      props.facarray,
                      props.appFromDate,
                      props.apptoDate,
                      props.pat_share,
                      props.examroom,
                      [],
                      aptdate,
                    );
                    if (typeof props.onBookAppointment === "function") {
                      props.onBookAppointment(aptdate);
                    }
                  })
                  .catch((err) => console.error(err));
              }

              // setBtnDis(false);
            })
            .catch((err) => {
              console.error(err);
              setBtnDis(false);
            });
        } else {
          await axiosInstance
            .post("/vozo/appointment?pid=" + patientid, encryptedData)
            .then((res) => {
              setBtnDis(true);
              let apptAdded = res.data;
              if (
                MeetMode === "GMeet" &&
                videochck &&
                (statusid === "doc_confirmed" || statusid === "EMAIL")
              ) {
                axiosInstance
                  .get("/vozo/getGMeet/data")
                  .then(async (response) => {
                    var res = Decrypt_Value(response.data, "vozo");
                    let article = {
                      start_time: res["start_time"],
                      end_time: res["end_time"],
                      attendees: res["attendees"],
                      start: res["pc_startTime"],
                      end: res["pc_endTime"],
                      eventdate: res["pc_eventDate"],
                      eid: res["pc_eid"],
                      aid: res["pc_aid"],
                      pid: res["pc_pid"],
                    };

                    if (props.fromWaitList) {
                      await deleteWaitlistEntry(props.waitlistData.id);
                    }
                    axios
                      .get(
                        fileurl +
                          "/interface/customized/g-meet/index.php?action=create",
                        { params: article },
                      )
                      .then((res) => {})
                      .catch((err) => {
                        console.log("failed");
                      });
                  })
                  .catch((err) => {
                    console.error(err);
                  });
              }

              // setBtnDis(false);

              if (apptAdded === "out of both range") {
                setBtnDis(false);

                setModalAlerShow1(true);
                setModalMsg1(
                  "Selected Date & time should be within the provider availability range.",
                );
                setTimeout(() => setModalAlerShow1(false), 4000);
                return;
              } else if (apptAdded === "out of time range") {
                setBtnDis(false);

                setModalAlerShow1(true);
                setModalMsg1(
                  "Selected time should be within the provider availability range.",
                );
                setTimeout(() => setModalAlerShow1(false), 4000);
                return;
              } else if (apptAdded === "out of date range") {
                setBtnDis(false);

                setModalAlerShow1(true);
                setModalMsg1(
                  "Selected Date should be within the provider availability range.",
                );
                setTimeout(() => setModalAlerShow1(false), 4000);
                return;
              } else if (apptAdded === "Provider Not Available") {
                setBtnDis(false);

                setTimeout(() => {
                  setModalAlerShow1(true);
                  setModalMsg1("Provider Not Available");
                }, 1);

                setTimeout(() => setModalAlerShow1(false), 4000);
                return;
              } else if (
                apptAdded === "You Can't place the Appointment at this time"
              ) {
                setBtnDis(false);

                setTimeout(() => {
                  setModalAlerShow1(true);
                  setModalMsg1("You Can't place the Appointment at this time");
                }, 1);

                setTimeout(() => setModalAlerShow1(false), 4000);
                return;
              } else if (
                apptAdded.includes(
                  "You are only allowed to add telehealth appointments",
                )
              ) {
                setBtnDis(false);

                setTimeout(() => {
                  setModalAlerShow1(true);
                  setModalMsg1(apptAdded);
                }, 1);

                setTimeout(() => setModalAlerShow1(false), 3000);
                return;
              } else if (
                apptAdded.includes("The provider is unavailable on these dates")
              ) {
                setBtnDis(false);

                setTimeout(() => {
                  setModalAlerShow1(true);
                  setModalMsg1(apptAdded);
                }, 1);

                setTimeout(() => setModalAlerShow1(false), 3000);
                return;
              } else if (
                apptAdded.includes("Appointment already scheduled at")
              ) {
                setBtnDis(false);

                setTimeout(() => {
                  setModalAlerShow1(true);
                  setModalMsg1(formatAppointmentOverlapMessage(apptAdded));
                }, 1);

                setTimeout(() => setModalAlerShow1(false), 3000);
                return;
              } else {
                setBtnDis(true);

                props.savealertmsg("New Appointment Added Successfully", true);
                axiosInstance
                  .get("/vozo/getGMeet/data")
                  .then(async (response) => {
                    var res = Decrypt_Value(response.data, "vozo");

                    let article = {
                      start_time: res["start_time"],
                      end_time: res["end_time"],
                      attendees: res["attendees"],
                      start: res["pc_startTime"],
                      end: res["pc_endTime"],
                      eventdate: res["pc_eventDate"],
                      enddate: res["pc_endDate"],
                      eid: res["pc_eid"],
                      aid: res["pc_aid"],
                      pid: res["pc_pid"],
                      fac_id: res["pc_facility"],
                      name: res["pat_name"],
                      geventid: res["gevent"],
                      google_appt_sync: res["google_appt_sync"],
                      google_availability_sync: res["google_availability_sync"],
                      uid: userID,
                      tenant_id: DBHost,
                      outlook_appt_sync: res["outlook_appt_sync"],
                      outlook_availability_sync:
                        res["outlook_availability_sync"],
                      user_id: userID,
                    };
                    if (res["google_appt_sync"] === 1) {
                      axios
                        .get(
                          fileurl +
                            "/interface/customized/g-meet/index.php?action=create",
                          { params: article },
                        )
                        .then((res) => {
                          // setBtnDis(false);
                        })
                        .catch((err) => {
                          console.log("failed");
                        });
                    }
                    if (res["outlook_appt_sync"] === 1) {
                      axios.post(
                        fileurl +
                          "/interface/customized/outlook/create_event.php",
                        { params: article },
                      );
                    }
                  })
                  .catch((err) => {
                    console.error(err);
                  });
                if (statusid === "doc_confirmed") {
                  axiosInstance
                    .get("/vozo/tele/checkemailsent")
                    .then((response) => {
                      props.savealertmsg(response.data, true);
                      // props.onBookAppointment(startdatenew);
                      setTimeout(() => {
                        props.popuphide();
                        props.closepopup();
                      }, 4000);
                    })
                    .catch((err) => {
                      console.error(err);
                      props.closepopup();
                    });
                } else {
                  props.closepopup();
                }
                // props.setBookAgain(false);
              }
              setTimeout(() => props.popuphide(), 4000);

              props.FetchAppointments(
                props.provarray,
                props.facarray,
                props.appFromDate,
                props.apptoDate,
                props.pat_share,
                props.examroom,
                [],
                aptdate,
              );
              if (typeof props.onBookAppointment === "function") {
                props.onBookAppointment(aptdate);
              }
              // setBtnDis(false);
            })
            .catch((err) => {
              console.error(err);
              props.closepopup();
              setBtnDis(false);
            });
        }
      }
    }
    // setAlertMessage("Checkin Progress for Availity");

    await axiosInstance
      .get(
        "vozonew/patient/eligibleCheck?pid=" + patientid + "&instype=primary",
      )
      .then((response) => {
        // setTimeout(() => {
        //   if (response.data === "Login Failed") {
        //     props.savealertmsg("Cant Verified", true);
        //     setAlertMessage("Cant Verified");
        //   } else if (response.data === "The result array is empty.") {
        //     props.savealertmsg(
        //       "Please fill the necessary fields of Insurance and Demographics before checking eligibility",
        //       true
        //     );
        //     setAlertMessage(
        //       "Please fill the necessary fields of Insurance and Demographics before checking eligibility"
        //     );
        //   }
        // }, 1);
        //else {
        //   props.savealertmsg("Datas has been sent for Eligibility Verification..", true);
        //   setAlertMessage("Datas has been sent for Eligibility Verification..");
        // }
        // setTimeout(() => {
        //   setAlertMessage("");
        // }, 4000);
      })
      // .then(() => {
      //   setBtnDisabled(false);
      // })
      .catch((err) => {
        console.log(err.message);
        // setBtnDisabled(false);
      });
  };

  const checkFacility = (type) => {
    if (type === "classname") {
      return sourceoffice && sourceoffice.length === 0 ? "hide-label" : "";
    } else if (type === "spinner") {
      return sourceoffice &&
        officeid &&
        sourceoffice.length === 0 &&
        officeid.length > 0 ? (
        <Spinner
          animation="border"
          size="sm"
          variant="primary"
          className="add-spinner-sty"
        />
      ) : (
        ""
      );
    }
  };

  const onChange = (timeStandard, typeTime) => {
    if (Appttype === 2 && timeStandard === "Invalid date") {
      return;
    }

    if (timeStandard === "Invalid date" && typeTime === "inTime") {
      setInTime(moment(start).format("h:mm A"));
      setOutTime(
        moment(moment(start, "h:mm A").add(15, "minutes")).format("h:mm A"),
      );

      let out = moment(moment(start, "h:mm A").add(15, "minutes")).format(
        "h:mm A",
      );
      let inTimeNew = inTime.split(":");
      let inTimeMin = inTimeNew[1].split(" ");
      if (inTimeMin[1] === "PM") {
        if (
          moment(out, "h:mm A").isBetween(
            moment("12:00 AM", "h:mm A"),
            moment("1:00 AM", "h:mm A"),
            null,
            "[)",
          )
        ) {
          out = moment(out, "h:mm A").add(1, "day");
        }
      }
      let dur = moment(out, "hh:mm a").diff(
        moment(inTime, "hh:mm a"),
        "minutes",
      );
      setEditing(dur);
    } else if (timeStandard === "Invalid date" && typeTime === "outTime") {
      setOutTime(
        moment(moment(inTime, "h:mm A").add(15, "minutes")).format("h:mm A"),
      );

      let out = moment(moment(inTime, "h:mm A").add(15, "minutes")).format(
        "h:mm A",
      );

      let dur = moment(outTime, "hh:mm a").diff(
        moment(out, "hh:mm a"),
        "minutes",
      );
      setEditing(dur);
    } else {
      let time = timeStandard.split(":");
      let timeMin = time[1].split(" ");

      if (typeTime === "inTime") {
        let intim = moment(timeStandard, "h:mm A").format("h:mm A");
        let out = moment(
          moment(timeStandard, "h:mm A").add(15, "minutes"),
        ).format("h:mm A");
        let dur = moment(out, "hh:mm a").diff(
          moment(intim, "hh:mm a"),
          "minutes",
        );
        setEditing(dur);

        setInTimeErr(false);
        setOutTime(
          moment(moment(timeStandard, "h:mm A").add(15, "minutes")).format(
            "h:mm A",
          ),
        );
        if (timeMin[1] === "AM") {
          if (time[0] === "12") {
            time[0] = Number(time[0]) - 12;
          }
          if (time[0] < Number(startTime)) {
            settimelimiterrorbox(true);
            return false;
          } else {
            settimelimiterrorbox(false);
          }
        } else {
          if (time[0] !== "12") {
            time[0] = Number(time[0]) + 12;
          }
          if (time[0] >= Number(endTime)) {
            settimelimiterrorbox(true);
            return false;
          } else {
            settimelimiterrorbox(false);
          }
        }
        setapttime(timeStandard);
      } else {
        let inTimeNew = inTime.split(":");
        let inTimeMin = inTimeNew[1].split(" ");
        if (inTimeNew[0] === "12" && inTimeMin[1] === "AM") {
          inTimeNew[0] = "00";
        }

        let out = moment(timeStandard, "h:mm A").format("h:mm A");
        if (inTimeMin[1] === "PM") {
          if (
            moment(out, "h:mm A").isBetween(
              moment("12:00 AM", "h:mm A"),
              moment("1:00 AM", "h:mm A"),
              null,
              "[)",
            )
          ) {
            out = moment(out, "h:mm A").add(1, "day");
          }
        }
        let duration = moment(out, "hh:mm a").diff(
          moment(inTime, "hh:mm a"),
          "minutes",
        );
        setEditing(duration);

        if (inTime === timeStandard) {
          setInTimeErr(true);
        }
        if (inTime !== timeStandard) {
          setInTimeErr(false);
        }
        if (timeMin[1] === "AM") {
          if (inTimeMin[1] === "PM" && Number(inTimeNew[0]) !== 12) {
            inTimeNew[0] = Number(inTimeNew[0]) + 12;
          }
          if (time[0] > Number(endTime) || inTimeNew[0] < Number(startTime)) {
            setInTimeErr(true);
            return false;
          } else if (
            (inTimeMin[1] === "PM" && time[0] !== "12") ||
            (Number(inTimeNew[0]) > Number(time[0]) &&
              Number(time[0]) !== 12) ||
            (inTimeNew[0] === time[0] &&
              inTimeMin[0] >= timeMin[0] &&
              time[0] !== "12") ||
            (time[0] === inTimeNew[0] &&
              timeMin[0] <= inTimeMin[0] &&
              time[0] !== "12")
          ) {
            setInTimeErr(true);
            return false;
          } else if (
            (Number(inTimeNew[0]) > time[0] && time[0] !== "12") ||
            (Number(inTimeNew[0]) === time[0] && inTimeMin[0] > timeMin[0])
          ) {
            setInTimeErr(true);
            return false;
          } else {
            setInTimeErr(false);
            settimelimiterrorbox(false);
          }
        } else {
          if (Number(time[0]) !== 12) {
            time[0] = Number(time[0]) + 12;
          }
          if (inTimeMin[1] === "PM" && Number(inTimeNew[0]) !== 12) {
            inTimeNew[0] = Number(inTimeNew[0]) + 12;
          }
          if (inTimeMin[1] === "AM" && Number(inTimeNew[0]) === 12) {
            inTimeNew[0] = 0;
          }
          if (Number(time[0]) === Number(endTime) && Number(timeMin[0]) > 0) {
            settimelimiterrorbox(true);
            return false;
          }
          if (Number(time[0]) === Number(endTime) && Number(timeMin[0]) == 0) {
            settimelimiterrorbox(false);
          }
          if (Number(time[0]) > Number(endTime)) {
            settimelimiterrorbox(true);
            return false;
          }
          if (Number(time[0]) < Number(endTime)) {
            settimelimiterrorbox(false);
          }
          if (Number(inTimeNew[0]) > Number(time[0])) {
            settimelimiterrorbox(true);
            return false;
          }
          if (Number(inTimeNew[0]) < Number(time[0])) {
            settimelimiterrorbox(false);
          }
          if (
            Number(inTimeNew[0]) === Number(time[0]) &&
            Number(inTimeMin[0]) > Number(timeMin[0])
          ) {
            setInTimeErr(true);
            return false;
          }
          if (
            Number(inTimeNew[0]) === Number(time[0]) &&
            Number(inTimeMin[0]) < Number(timeMin[0])
          ) {
            setInTimeErr(false);
          }
          if (Number(inTimeNew[0]) < Number(startTime)) {
            settimelimiterrorbox(true);
          }
        }
      }
    }
  };

  const fornormalapp = () => {
    return (
      <>
        <div className="for-get-started-popup-for-res-2">
          <div className="dis-fl-just">
            <div className="get-st-billinfo-head">Add Appointment</div>
          </div>
          <div className="get-st-client-content-3">
            Schedule your medical appointment with your preferred doctor.
          </div>

          <div className="get-st-box-with-rad-but-2">
            <>
              <Radio.Group value={1}>
                <Radio value={1}></Radio>
                <Radio value={2}></Radio>
              </Radio.Group>
            </>

            <Button
              className="save_active get-st-next-btn"
              variant="primary"
              onClick={() => forexploreteleapp()}
            >
              Next
            </Button>
          </div>
        </div>
      </>
    );
  };

  const forteleapp = () => {
    return (
      <>
        <div className="for-get-started-popup-for-res-2">
          <div className="dis-fl-just">
            <div className="get-st-billinfo-head">Add Tele Appointment</div>
          </div>
          <div className="get-st-client-content-3">
            Select the facility and schedule a video visit on your own.
          </div>

          <div className="get-st-box-with-rad-but-2">
            <div className="m-t-10">
              <Radio.Group value={2}>
                <Radio value={1}></Radio>
                <Radio value={2}></Radio>
              </Radio.Group>
            </div>

            <Button
              className="save_active get-st-next-btn"
              variant="primary"
              onClick={() => forexploreteleappdone()}
            >
              Done
            </Button>
          </div>
        </div>
      </>
    );
  };
  const handleGroupSearch = (value) => {
    if (!value) {
      fetchGroupPatients({ limit: 4 });
    } else {
      fetchGroupPatients({ search: value });
    }
  };

  const dataForBookAgain = (data) => {
    // checkbox22
    if (data.walkin) {
      setwalkincheck(true);
    }
    if (Number(props.dataObj.pc_telehealth) === 1) {
      setAppttype(2);
    } else {
      setAppttype(1);
    }
    // setApptty
    // Separate the assignments
    setofficeid(data.pc_facility);
    //appointment profile 11B
    setprofileid(data.pc_catid);
    // docname44
    setproviderid(data.pc_aid);
    // patient 11
    setpatientid(data.pc_pid);
    // setsearch1(props.dataObj.pname);
    setSearchInputValue(props.dataObj.pname);
    //room 5B
    getRoom(data.pc_facility);
    setRoomVal(data.pc_room);
    if (String(data.pc_telehealth) === "1") {
      setvideochck(true);
    }
    //status44B
    if (data.pc_telehealth === "1") {
      setvideochck(true);
    }
    if (!props.isAptProfileBookAgain) {
      setstatusid(data.pc_apptstatus);
    } //speciality33B
    setSpeciality(data.speciality);
    setEditing(15);
    let options;
    if (Number(props.dataObj.pc_telehealth) === 1) {
      options = teleprofile;
    } else {
      options = sourceprofile;
    }
    for (var j = 0; j < options.length; j++) {
      if (options[j].value.includes(data.pc_catid)) {
        if (options[j].value == data.pc_catid) {
          if (Number(props.dataObj.pc_telehealth) === 1) {
            setbillingid("");
          } else {
            if (
              options[j].pc_bill_profile !== "DEFAULT" &&
              (options[j].pc_bill_profile ?? []).length > 0
            ) {
              setbillingid(options[j].pc_bill_profile);
            } else {
              setbillingid("");
            }
          }
          var filter_pc_duration = options[j].pc_duration;
          if (options[j].pc_duration !== "" || options[j].pc_duration !== "0") {
            let outTimeVal = moment(inTime, "h:mm A").add(
              options[j].pc_duration,
              "minutes",
            );
            setOutTime(moment(outTimeVal).format("h:mm A"));
          }
        }
      }
    }

    setrepeatselectnew(data.pc_select1);
    setrepeatselect2new(data.pc_select2);
    if (data.pc_select2 === "1") {
      setWeek_and_every(true);
    }
    setrepValue(data.pc_repeat_select);
    setLastdateApp(moment(data.pc_endDate).format(dtFormat));

    setRepeatSelectMonth(data.pc_repeatselectmonth);
    setcustChk(parseInt(data.pc_on_after_never));

    let d1 = moment(data.pc_startTime, "h:mm A");
    let d2 = moment(data.pc_endTime, "h:mm A");

    setInTime(d1.format("h:mm A"));

    setOutTime(d2.format("h:mm A"));

    setapttime(d1.format("h:mm A"));
    setReason(data.reason_for_appointment);

    if (data.pc_recurrtype > "0") {
      setchecking1(true);

      if (data.pc_recurrtype === "1" || data.pc_recurrtype === "2") {
        setrepeatselectnew(data.pc_recurrspec.event_repeat_freq);

        setrepeatselect2new(data.pc_recurrspec.event_repeat_freq_type);
      } else if (data.pc_recurrtype === "3") {
        let temp = data.pc_recurrspec.event_repeat_freq.split(",");
        var temp_a = [];
        for (let i = 0; i < temp.length; i++) {
          let text = Number(temp[i]);
          temp_a.push(text);
        }

        setweekday(temp_a);
      } else if (data.pc_recurrtype === "4") {
        let temp = data.pc_recurrspec.event_repeat_freq_by_day.split(",");
        var temp_a = [];
        for (let i = 0; i < temp.length; i++) {
          let text = Number(temp[i]);
          temp_a.push(text);
        }

        setweekday(temp_a);
      } else if (data.pc_recurrtype === "5") {
        let temp = data.pc_recurrspec.event_repeat_freq_by_day.split(",");
        var temp_a = [];
        for (let i = 0; i < temp.length; i++) {
          let text = Number(temp[i]);
          temp_a.push(text);
        }

        setweekday(temp_a);
      }
    } else {
      setchecking1(false);
    }
  };

  const WeekdayChange = (val) => {
    const hasOnlyEmptyStrings =
      val.length > 0 && val.every((item) => item === "");
    if (hasOnlyEmptyStrings) {
      setweekday("");
    } else {
      setweekday(val);
    }
    setselectdayError(false);
  };

  const forexploreteleapp = () => {
    localStorage.removeItem("normalapppopup");
    setnormalappointment(false);
    setforteleornor(2);
    setteleappointment(true);
  };

  const forexploreteleappdone = () => {
    setforteleornor(1);
    setteleappointment(false);
  };
  const handleDropDownSelect = (event, data) => {
    let options;
    if (videochck) {
      options = teleprofile;
    } else {
      options = sourceprofile;
    }
    for (var j = 0; j < options.length; j++) {
      if (options[j].value.includes(data.value)) {
        if (options[j].value == data.value) {
          if (
            options[j].pc_bill_profile !== "DEFAULT" &&
            (options[j].pc_bill_profile ?? []).length > 0
          ) {
            setbillingid(options[j].pc_bill_profile);
          } else {
            setbillingid("");
          }

          var filter_pc_duration = options[j].pc_duration;
          if (options[j].pc_duration !== "" || options[j].pc_duration !== "0") {
            let outTimeVal = moment(inTime, "h:mm A").add(
              options[j].pc_duration,
              "minutes",
            );
            setOutTime(moment(outTimeVal).format("h:mm A"));
          }
        }
      }
    }

    settimelimiterrorbox();
    setInTimeErr();
    setprofileid(data.value);
    setEditing(filter_pc_duration);
    setprofileError(false);
  };

  const getRoom = async (id) => {
    await axiosInstance
      .get("/vozonew/facilityRoom?id=" + id)
      .then((res) => {
        let decode = Decrypt_Value(res.data, "vozo");
        setRoomList(decode.examRoom);
      })
      .catch((err) => {});
  };

  var i = 0;
  const setRoomList = (val) => {
    setSourceRoom([]);

    i = parseInt(val);
    for (let j = 1; j <= i; j++) {
      let obj = {
        id: "" + j,
        text: "Exam Room " + j,
        title: "Exam Room " + j,
        value: "" + j,
      };
      // test build end

      setSourceRoom((item) => [...item, obj]);
    }
    // setRoomVal("");
  };

  const handleDropDownSelectOffice = (event, data) => {
    setproviderid("");
    setSpeciality("");
    setofficeid(data.value);
    setofficeError(false);
    getRoom(data.value);
  };
  const isSuffixEnabledSite = [
    "laibonhealthllc",
    // "default",
    "laibonhealth",
  ].includes(DBHost);
  const changeSpeciality = (data, from = "") => {
    if (from === "" && !isInitialWaitlistLoad) {
      setproviderid("");
    }
    setSpeciality(data);
    setSpecialError(false);
    setInTimeErr(false);
  };

  const handleDropDownSelectStatus = (event, data) => {
    setstatusid(data.value);
    setstatusError(false);
  };

  const setSpecialityByusers = (value) => {
    axiosInstance
      .get("/vozo/getspeciality/users?id=" + value)
      .then((res) => {
        let temp_role_spec_user = Decrypt_Value(res.data, "vozo");

        changeSpeciality(temp_role_spec_user.specialty, "fromProv");
      })
      .catch(() => {});
  };

  const handleDropDownSelectProvider = (event, data) => {
    if (provError) {
      setprovError(false);
    }
    setproviderid(data.value);
    setprovError(false);
    setInTimeErr(false);
    setSpecialityByusers(data.value);
  };

  // const handleBillingFacility = (event, data) => {
  //   setBillFacilityID(data.value);
  //   setBillFacilityError(false);
  // };

  const handleDropDownSelectPatient = (event, data) => {
    // setsearch1(data.title);
    setSearchInputValue(data.title);

    if (!data.email || data.email.trim() === "" || data.email === undefined) {
      setEmptyEmailWarning(true);
    } else {
      setEmptyEmailWarning(false);
    }

    setpatientid(data.value);
    setpatError(false);
    if (accountType > "0" || (accountType === "0" && trial)) {
      axiosInstance
        .get("/vozo/getpatient/flags?pid=" + data.value)
        .then((res) => {
          let temp_role_pat_flag = Decrypt_Value(res.data, "vozo");
          setPatFlag(temp_role_pat_flag);
        })
        .catch(() => {
          setPatFlag([]);
        });
    }
  };

  const timeout = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  // const walkinclick = (e) => {
  //   e.preventDefault();
  //   setvideochck(false);
  //   setwalkincheck(!walkincheck);
  // };

  const walkinclick = (e) => {
    e.preventDefault();

    // For telehealth-only providers, treat walk-in as telehealth
    if (allowAppt === 2) {
      setAppttype(2); // Set as telehealth type
      setvideochck(true);
    } else {
      setvideochck(false);
    }

    setwalkincheck(!walkincheck);
  };
  // const onChangeRadio = (e) => {
  //   if (e === 2) {
  //     e = { target: { value: 2 } };
  //   }

  //   setAppttype(e.target.value);
  //   if (e.target.value == 2) {
  //     setwalkincheck(false);
  //     setaptdate(moment(start).format(dtFormat));

  //     let t1 = inTime.split(" ");
  //     let t2 = outTime.split(" ");

  //     let from = disabledFromTimes(t1[0], t1[1], e.target.value);
  //     let to = disabledToTime(t2[0], t2[1], fromId, e.target.value);

  //     if (!from) {
  //       let intime = moment(roundedDate);
  //       let now = moment();
  //       let intimee = moment(roundedDate).format("h:mm A");

  //       setaptdate(moment(start).format(dtFormat));

  //       setInTime(intimee);

  //       let out = moment(intimee, "h:mm A").add(15, "minutes").format("h:mm A");
  //       setOutTime(out);
  //       let dur = moment(out, "hh:mm a").diff(
  //         moment(intimee, "hh:mm a"),
  //         "minutes"
  //       );
  //       setEditing(dur);

  //       setapttime(intimee);

  //       if (intime.isAfter(now)) {
  //         if (props.view === "month") {
  //           let intime = moment(props.startTime1, "H").format("h:mm A");
  //           setInTime(intime);

  //           let outtime = moment(intime, "h:mm A")
  //             .add(15, "minutes")
  //             .format("h:mm A");
  //           setOutTime(outtime);

  //           let dur = moment(outtime, "h:mm A").diff(
  //             moment(intime, "h:mm A"),
  //             "minutes"
  //           );
  //           setEditing(dur);
  //         } else {
  //           setaptdate(moment(start).format(dtFormat));

  //           let intime = moment(roundedDate).format("h:mm A");
  //           setInTime(intime);

  //           let out = moment(intime, "h:mm A")
  //             .add(15, "minutes")
  //             .format("h:mm A");
  //           setOutTime(out);
  //           let dur = moment(out, "hh:mm a").diff(
  //             moment(intime, "hh:mm a"),
  //             "minutes"
  //           );
  //           setEditing("");
  //         }
  //       }
  //     } else {
  //       let now = moment(roundedDate);

  //       let intime = now.format("h:mm A");

  //       let checktime = moment(aptdate, dtFormatsec);

  //       if (checktime.isBefore(now.format(dtFormat))) {
  //         // setInTime("");
  //         // setOutTime("");
  //         setEditing("");
  //       } else {
  //         let out = moment(
  //           moment(now.format("h:mm A"), "h:mm A").add(15, "minutes")
  //         ).format("h:mm A");

  //         setInTime(intime);
  //         setOutTime(out);
  //         let dur = moment(out, "hh:mm a").diff(
  //           moment(now, "hh:mm a"),
  //           "minutes"
  //         );
  //         setEditing(dur);
  //         setapttime(intime);
  //       }
  //     }
  //     setstatusid("");
  //     setbillingid("");
  //     setprofileid("");
  //   } else if (e.target.value == 1 || e.target.value == 3) {
  //     setwalkincheck(false);

  //     let now = moment();

  //     let intime = moment(start).format("h:mm A");
  //     setInTime(moment(start).format("h:mm A"));
  //     let out = moment(start).add(15, "minutes").format("h:mm A");
  //     setOutTime(out);
  //     let checktime = moment(aptdate, dtFormatsec);
  //     if (checktime.isBefore(now.format(dtFormat))) {
  //       // setInTime("");
  //       // setOutTime("");
  //       setEditing("");
  //     } else {
  //       if (props.view === "month") {
  //         let inmonth = moment(props.startTime1, "H").format("h:mm A");
  //         setInTime(moment(props.startTime1, "H").format("h:mm A"));

  //         let out = moment(
  //           moment(props.startTime1, "H").add(15, "minutes")
  //         ).format("h:mm A");
  //         setOutTime(out);
  //         let dur = moment(out, "hh:mm a").diff(
  //           moment(inmonth, "hh:mm a"),
  //           "minutes"
  //         );
  //         setEditing(dur);
  //         setapttime(inmonth);
  //       } else {
  //         let out = moment(moment(intime, "h:mm A").add(15, "minutes")).format(
  //           "h:mm A"
  //         );
  //         setInTime(intime);
  //         setOutTime(out);
  //         let dur = moment(out, "hh:mm a").diff(
  //           moment(now, "hh:mm a"),
  //           "minutes"
  //         );
  //         setEditing(dur);
  //         setapttime(intime);
  //       }
  //     }
  //     let ofc_firstId = "";
  //     if (props.officeId) {
  //       const idArray = props.officeId.split(",");
  //       ofc_firstId = idArray[0];
  //     }
  //     setofficeid(ofc_firstId);
  //     setprofileid("");
  //     setstatusid("");
  //     setbillingid("");
  //   }
  //   // }
  // };

  // const checkvideovisit = () => {
  //   const currentTime = moment(start);
  //   if ((accountType === "1" && teleFlag === "0") || accountType === "-1") {
  //     setvideochck(false);
  //   } else {
  //     // if (Appttype !== 3) {
  //     //   setproviderid("");
  //     // }
  //     setvideochck(true);
  //     if (props.view === "month") {
  //       let intime = moment(props.startTime1, "H").format("h:mm A");
  //       setInTime(intime);

  //       let outtime = moment(intime, "h:mm A")
  //         .add(15, "minutes")
  //         .format("h:mm A");
  //       setOutTime(outtime);

  //       let dur = moment(outtime, "h:mm A").diff(
  //         moment(intime, "h:mm A"),
  //         "minutes"
  //       );
  //       setEditing(dur);
  //     } else {
  //       setInTime(currentTime.format("h:mm A"));
  //       setapttime(currentTime.format("h:mm A"));
  //       setOutTime(moment(currentTime.add(15, "minutes")).format("h:mm A"));
  //     }
  //   }
  // };

  const onChangeRadio = (e) => {
    if (e === 2) {
      e = { target: { value: 2 } };
    }

    setAppttype(e.target.value);

    if (e.target.value == 2) {
      // Telehealth
      setwalkincheck(false);
      setaptdate(moment(start).format(dtFormat));

      let t1 = inTime.split(" ");
      let t2 = outTime.split(" ");

      let from = disabledFromTimes(t1[0], t1[1], e.target.value);
      let to = disabledToTime(t2[0], t2[1], fromId, e.target.value);

      if (!from) {
        let intime = moment(roundedDate);
        let now = moment();
        let intimee = moment(roundedDate).format("h:mm A");

        setaptdate(moment(start).format(dtFormat));

        setInTime(intimee);

        let out = moment(intimee, "h:mm A").add(15, "minutes").format("h:mm A");
        setOutTime(out);
        let dur = moment(out, "hh:mm a").diff(
          moment(intimee, "hh:mm a"),
          "minutes",
        );
        setEditing(dur);

        setapttime(intimee);

        if (intime.isAfter(now)) {
          if (props.view === "month") {
            let intime = moment(props.startTime1, "H").format("h:mm A");
            setInTime(intime);

            let outtime = moment(intime, "h:mm A")
              .add(15, "minutes")
              .format("h:mm A");
            setOutTime(outtime);

            let dur = moment(outtime, "h:mm A").diff(
              moment(intime, "h:mm A"),
              "minutes",
            );
            setEditing(dur);
          } else {
            setaptdate(moment(start).format(dtFormat));

            let intime = moment(roundedDate).format("h:mm A");
            setInTime(intime);

            let out = moment(intime, "h:mm A")
              .add(15, "minutes")
              .format("h:mm A");
            setOutTime(out);
            let dur = moment(out, "hh:mm a").diff(
              moment(intime, "hh:mm a"),
              "minutes",
            );
            setEditing("");
          }
        }
      } else {
        let now = moment(roundedDate);

        let intime = now.format("h:mm A");

        let checktime = moment(aptdate, dtFormatsec);

        if (checktime.isBefore(now.format(dtFormat))) {
          setEditing("");
        } else {
          let out = moment(
            moment(now.format("h:mm A"), "h:mm A").add(15, "minutes"),
          ).format("h:mm A");

          setInTime(intime);
          setOutTime(out);
          let dur = moment(out, "hh:mm a").diff(
            moment(now, "hh:mm a"),
            "minutes",
          );
          setEditing(dur);
          setapttime(intime);
        }
      }
      setstatusid("");
      setbillingid("");
      setprofileid("");
    } else if (e.target.value == 1) {
      // Regular Appointment
      setwalkincheck(false);

      let now = moment();

      let intime = moment(start).format("h:mm A");
      setInTime(moment(start).format("h:mm A"));
      let out = moment(start).add(15, "minutes").format("h:mm A");
      setOutTime(out);
      let checktime = moment(aptdate, dtFormatsec);
      if (checktime.isBefore(now.format(dtFormat))) {
        setEditing("");
      } else {
        if (props.view === "month") {
          let inmonth = moment(props.startTime1, "H").format("h:mm A");
          setInTime(moment(props.startTime1, "H").format("h:mm A"));

          let out = moment(
            moment(props.startTime1, "H").add(15, "minutes"),
          ).format("h:mm A");
          setOutTime(out);
          let dur = moment(out, "hh:mm a").diff(
            moment(inmonth, "hh:mm a"),
            "minutes",
          );
          setEditing(dur);
          setapttime(inmonth);
        } else {
          let out = moment(moment(intime, "h:mm A").add(15, "minutes")).format(
            "h:mm A",
          );
          setInTime(intime);
          setOutTime(out);
          let dur = moment(out, "hh:mm a").diff(
            moment(now, "hh:mm a"),
            "minutes",
          );
          setEditing(dur);
          setapttime(intime);
        }
      }
      let ofc_firstId = "";
      if (props.officeId) {
        const idArray = props.officeId.split(",");
        ofc_firstId = idArray[0];
      }
      setofficeid(ofc_firstId);
      setprofileid("");
      setstatusid("");
      setbillingid("");
    } else if (e.target.value == 3) {
      // Walk-in appointment
      if (allowAppt === 2) {
        // For telehealth-only providers, treat walk-in as telehealth
        setAppttype(2);
        setvideochck(true);
      } else {
        setvideochck(false);
      }

      setwalkincheck(true);

      let now = moment();

      let intime = moment(start).format("h:mm A");
      setInTime(moment(start).format("h:mm A"));
      let out = moment(start).add(15, "minutes").format("h:mm A");
      setOutTime(out);
      let checktime = moment(aptdate, dtFormatsec);

      if (checktime.isBefore(now.format(dtFormat))) {
        setEditing("");
      } else {
        if (props.view === "month") {
          let inmonth = moment(props.startTime1, "H").format("h:mm A");
          setInTime(moment(props.startTime1, "H").format("h:mm A"));

          let out = moment(
            moment(props.startTime1, "H").add(15, "minutes"),
          ).format("h:mm A");
          setOutTime(out);
          let dur = moment(out, "hh:mm a").diff(
            moment(inmonth, "hh:mm a"),
            "minutes",
          );
          setEditing(dur);
          setapttime(inmonth);
        } else {
          let out = moment(moment(intime, "h:mm A").add(15, "minutes")).format(
            "h:mm A",
          );
          setInTime(intime);
          setOutTime(out);
          let dur = moment(out, "hh:mm a").diff(
            moment(now, "hh:mm a"),
            "minutes",
          );
          setEditing(dur);
          setapttime(intime);
        }
      }

      let ofc_firstId = "";
      if (props.officeId) {
        const idArray = props.officeId.split(",");
        ofc_firstId = idArray[0];
      }
      setofficeid(ofc_firstId);
      setprofileid("");
      setstatusid("");
      setbillingid("");
    }
  };
  const checkvideovisit = () => {
    const currentTime = moment(start);

    // Check if user has access to telehealth
    if ((accountType === "1" && teleFlag === "0") || accountType === "-1") {
      setvideochck(false);
    } else {
      // Set video check to true for telehealth
      setvideochck(true);

      // If it's a walk-in appointment, don't reset provider
      // Otherwise, clear provider selection
      if (!walkincheck) {
        setproviderid("");
      }

      // If it's a walk-in appointment for a telehealth-only provider,
      // we're already handling it in onChangeRadio, so don't reset things
      if (walkincheck && allowAppt === 2) {
        // For walk-in with telehealth-only provider, keep current settings
        return;
      }

      // Set time for telehealth appointment
      if (props.view === "month") {
        let intime = moment(props.startTime1, "H").format("h:mm A");
        setInTime(intime);

        let outtime = moment(intime, "h:mm A")
          .add(15, "minutes")
          .format("h:mm A");
        setOutTime(outtime);

        let dur = moment(outtime, "h:mm A").diff(
          moment(intime, "h:mm A"),
          "minutes",
        );
        setEditing(dur);
      } else {
        setInTime(currentTime.format("h:mm A"));
        setapttime(currentTime.format("h:mm A"));
        setOutTime(moment(currentTime.add(15, "minutes")).format("h:mm A"));
      }
    }
  };
  // const checkapt = () => {
  //   // if (Appttype !== 3) {
  //   //   setproviderid("");
  //   // }
  //   setvideochck(false);
  // };

  const checkapt = () => {
    // If it's a walk-in appointment for telehealth-only provider,
    // don't reset video check
    if (walkincheck && allowAppt === 2) {
      return; // Keep video check as true
    }

    // For regular appointments, set video check to false
    setvideochck(false);
  };

  const handleRoomVal = (data) => {
    setRoomVal(data);
    setexamroomError(false);
  };

  const handleSelect2 = (id, val) => {
    // setOccurence("1");
    if (id === "new-app-select1") {
      setrepeatselectnew(val);
    } else {
      setweekday("");
      if (val === "1") {
        setrepeatselect2new("1");
        if (
          repeatselectnew === "4" ||
          repeatselectnew === "5" ||
          repeatselectnew === "6"
        ) {
          setrepeatselectnew("");
        }

        setdayswise(true);
        setswict_check(true);

        setWeek_and_every(true);
      } else if (val === "2") {
        setrepeatselect2new("2");
        if (repeatselectnew === "5" || repeatselectnew === "6") {
          setrepeatselectnew("");
        }
        setswict_check(false);

        setdayswise(false);
        setWeek_and_every(false);
      } else if (val === "3") {
        setrepeatselect2new("3");
        setswict_check(false);

        setdayswise(false);
        setWeek_and_every(false);
      } else {
        setswict_check(false);

        setdayswise(false);
        setWeek_and_every(false);
      }
      setrepeatselect2new(val);
    }
  };

  const getDatas = async () => {
    let Data_frsh_doc =
      "authorized=" +
      authorized +
      "&main_pro=" +
      main_pro +
      "&group_id=" +
      group_id;
    let Data_enc_doc = Encrypt_Value(Data_frsh_doc, "vozo");
    await axiosInstance
      .get("/vozonew/facility?search=" + Data_enc_doc)
      .then((response) => {
        let decryptval = Decrypt_Value(response.data, "vozo");
        setSourceoffice(decryptval);
      })
      .catch((err) => console.error(err));
    if (!props.pid) {
      let alle_data =
        "limit=40&authorized=" +
        authorized +
        "&main_pro=" +
        main_pro +
        "&userID=" +
        userID +
        "&pat_share=" +
        storedNames.pat_share +
        "&owner_id=" +
        owner_id +
        "&activepatlist=" +
        1;

      let alle_data_enc = Encrypt_Value(alle_data, "vozo");

      await axiosInstance
        .get("/vozo/patientsearch?search=" + alle_data_enc)
        .then((response) => {
          let temp_role = Decrypt_Value(response.data, "vozo");
          setSource(temp_role);
        })
        .catch(() => {
          setSource([]);
        });
    }

    await axiosInstance
      .get("/vozo/appstatus/category")
      .then((response) => {
        let temp_role_cat = Decrypt_Value(response.data, "vozo");
        setSourcestatus(temp_role_cat[0]);
        setSourcestatustele(temp_role_cat[1]);
        setSourceprofile(temp_role_cat[2]);
        setteleprofile(temp_role_cat[2]);
        if (!props.fromWaitList) {
          setSpinnerVal(false);
        }
      })
      .catch((err) => console.error(err));

    // await axiosInstance
    //   .get("/vozonew/facility/telehealth")
    //   .then((response) => {
    //     let temp_role_tele_cat = Decrypt_Value(response.data, "vozo");
    //     settelehealth(temp_role_tele_cat);
    //   })
    //   .catch((err) => console.error(err));

    if (props.pid !== undefined) {
      setpatientid(props.pid);
    }
    if (props.pid !== undefined) {
      await axiosInstance
        .get("/vozonew/patient?pid=" + props.pid)
        .then((response) => {
          let temp_role_pat_flag = Decrypt_Value(response.data, "vozo");

          let alle_data =
            "limit=40&fname=" +
            temp_role_pat_flag.patient_name.toLowerCase() +
            "&authorized=" +
            authorized +
            "&main_pro=" +
            main_pro +
            "&userID=" +
            userID +
            "&pat_share=" +
            storedNames.pat_share +
            "&owner_id=" +
            owner_id +
            "&activepatlist=" +
            1;

          let alle_data_enc = Encrypt_Value(alle_data, "vozo");

          axiosInstance
            .get("/vozo/patientsearch?search=" + alle_data_enc)
            .then((response) => {
              let temp_role = Decrypt_Value(response.data, "vozo");

              const findName = temp_role.find(
                (item) => Number(item.pid) === Number(props.pid),
              );

              // setsearch1(findName.name);
              setSearchInputValue(findName.name);
              setSource(temp_role);
            })
            .catch(() => {
              setSource([]);
              // setsearch1("");
              setSearchInputValue("");
            });

          setpatientid(temp_role_pat_flag.pid);
        })
        .catch((err) => console.error(err));

      await axiosInstance
        .get("/vozo/getpatient/flags?pid=" + props.pid)
        .then((res) => {
          let temp_role_pat_flag = Decrypt_Value(res.data, "vozo");
          setPatFlag(temp_role_pat_flag);
        })
        .catch(() => {
          setPatFlag([]);
        });
    }
  };

  const handlecloseUpgrade = () => setUpgrade(false);

  const modalhide = () => {
    setModalAlerShow1(false);
    setModalMsg1("");
  };

  const generateDateArray = (startDate, endDate) => {
    const [startYear, startMonth, startDay] = startDate.split("-").map(Number);
    const [endYear, endMonth, endDay] = endDate.split("-").map(Number);

    const start = new Date(startYear, startMonth - 1, startDay); // month is 0-based
    const end = new Date(endYear, endMonth - 1, endDay);

    const dateArray = [];

    while (start <= end) {
      const year = start.getFullYear();
      const month = String(start.getMonth() + 1).padStart(2, "0");
      const day = String(start.getDate()).padStart(2, "0");

      dateArray.push(`${year}-${month}-${day}`);
      start.setDate(start.getDate() + 1);
    }

    return dateArray;
  };

  const generateSpecificWeekdayArray = (startDate, endDate, weekdays) => {
    // Parse YYYY-MM-DD safely to avoid UTC timezone shifts
    const [startYear, startMonth, startDay] = startDate.split("-").map(Number);
    const [endYear, endMonth, endDay] = endDate.split("-").map(Number);

    const start = new Date(startYear, startMonth - 1, startDay);
    const end = new Date(endYear, endMonth - 1, endDay);

    const dateArray = [];
    const dayNames = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    // Adjust weekdays from ["2", "3", ...] → JS day indices ["1", "2", ...]
    weekdays = weekdays.map((day) => (parseInt(day, 10) - 1).toString());

    while (start <= end) {
      const dayIndex = start.getDay(); // 0 = Sunday, 1 = Monday, ...

      if (weekdays.includes(dayIndex.toString())) {
        const year = start.getFullYear();
        const month = String(start.getMonth() + 1).padStart(2, "0");
        const day = String(start.getDate()).padStart(2, "0");

        dateArray.push(`${year}-${month}-${day}`);
      }

      start.setDate(start.getDate() + 1);
    }

    return dateArray;
  };

  const handleFromTime = () => {
    if (fromShow === false) {
      setFromShow(true);
      setToShow(false);
      setTempOpen(true);
    } else {
      setFromShow(false);
    }
  };
  const handleToTime = () => {
    if (toShow === false) {
      setToShow(true);
      setFromShow(false);
      setTempOpen(true);
    } else {
      setToShow(false);
    }
  };
  const handleFromButton = (e, index) => {
    e.preventDefault();
    if (fromShow === true || toShow === true) {
      setFromShow(false);
      setToShow(false);
    }
  };
  const handleToButton = (e, index) => {
    e.preventDefault();
    if (fromShow === true || toShow === true) {
      setFromShow(false);
      setToShow(false);
    }
  };

  // nisha end //

  window.onclick = function (e) {
    if (fromShow && tempOpen === false) {
      setFromShow(false);
    } else if (toShow && tempOpen === false) {
      setToShow(false);
    }
  };
  var regexFirstNum = /^[a-zA-Z].*/;

  const handleAddPatient = (e) => {
    if (storedNames.demo) {
      setTemShow(false);
      setShow(true);
    }
  };

  const deleteWaitlistEntry = async (waitlistId) => {
    try {
      await axiosInstance.delete(
        `/vozo/appointment_waitlist/delete?id=${waitlistId}`,
      );
    } catch (error) {
      console.error("Error deleting waitlist entry:", error);
      // Continue with appointment creation even if deletion fails
    }
  };

  const handleSubmit = (e) => {
    // setBtnDis(true);
    if (changeTab === "1" || changeTab === "3") {
      buttonClickActions(e);
    } else {
      if (!storedNames.setProviderAvailability_viewOnly) {
        dispatch(SetPatientBool(true));
      } else {
        alert("You only have view-only access.");
        // setBtnDis(false);
      }
    }

    // setTimeout(() => setBtnDis(false), 500);
  };

  const populateAppointmentData = (appointmentData) => {
    if (!appointmentData) return;

    try {
      // Set basic appointment information
      if (appointmentData.patient_id) {
        setpatientid(appointmentData.patient_id);
        setpatError(false);
      }

      if (appointmentData.patient_name) {
        setSearchInputValue(appointmentData.patient_name);
      }

      // Set appointment type - IMPORTANT: This must be set FIRST
      if (appointmentData.appt_type) {
        const apptTypeNum = Number(appointmentData.appt_type);
        if (apptTypeNum === 1) {
          // Walk-in
          setAppttype(1);
          setvideochck(false);
          setwalkincheck(true);
        } else if (apptTypeNum === 2) {
          // Telehealth
          setAppttype(2);
          setvideochck(true);
          setwalkincheck(false);
        } else {
          // Regular appointment
          setAppttype(1);
          setvideochck(false);
          setwalkincheck(false);
        }
      }

      // Set facility/office - Convert to string to match Select options
      if (appointmentData.facility_id) {
        const facilityId = String(appointmentData.facility_id);
        setofficeid(facilityId);
        setofficeError(false);
        // Get room data for this facility
        getRoom(facilityId);
      }

      // Set provider - Convert to string to match Select options
      if (appointmentData.provider_id) {
        const providerId = String(appointmentData.provider_id);

        setproviderid(providerId);
        setprovError(false);
      }

      // Set appointment date
      if (appointmentData.appointment_date) {
        setaptdate(moment(appointmentData.appointment_date).format(dtFormat));
        setDateErr(false);
      }

      // Set appointment times
      if (appointmentData.start_time) {
        let formattedStartTime;
        // Check if time is in HH:mm:ss format or h:mm A format
        if (
          appointmentData.start_time.includes("AM") ||
          appointmentData.start_time.includes("PM")
        ) {
          formattedStartTime = moment(
            appointmentData.start_time,
            "h:mm A",
          ).format("h:mm A");
        } else {
          formattedStartTime = moment(
            appointmentData.start_time,
            "HH:mm:ss",
          ).format("h:mm A");
        }
        setInTime(formattedStartTime);
        setapttime(formattedStartTime);
        setInTimeErr(false);
      }

      if (appointmentData.end_time) {
        let formattedEndTime;
        // Check if time is in HH:mm:ss format or h:mm A format
        if (
          appointmentData.end_time.includes("AM") ||
          appointmentData.end_time.includes("PM")
        ) {
          formattedEndTime = moment(appointmentData.end_time, "h:mm A").format(
            "h:mm A",
          );
        } else {
          formattedEndTime = moment(
            appointmentData.end_time,
            "HH:mm:ss",
          ).format("h:mm A");
        }
        setOutTime(formattedEndTime);
      }

      // Calculate duration
      if (appointmentData.start_time && appointmentData.end_time) {
        let start, end;
        if (
          appointmentData.start_time.includes("AM") ||
          appointmentData.start_time.includes("PM")
        ) {
          start = moment(appointmentData.start_time, "h:mm A");
          end = moment(appointmentData.end_time, "h:mm A");
        } else {
          start = moment(appointmentData.start_time, "HH:mm:ss");
          end = moment(appointmentData.end_time, "HH:mm:ss");
        }
        const duration = end.diff(start, "minutes");
        setEditing(duration);
      }

      // Set speciality
      if (appointmentData.speciality) {
        setSpeciality(appointmentData.speciality);
        setSpecialError(false);
      }

      // Set profile if available - Convert to string and verify it exists
      if (appointmentData.profile_id) {
        const profileId = String(appointmentData.profile_id);

        // Check if the profile exists in the available options
        const profileExists = sourceprofile.some(
          (p) => String(p.value) === profileId,
        );

        if (profileExists) {
          setprofileid(profileId);
          setprofileError(false);

          // Set billing ID based on profile
          const selectedProfile = sourceprofile.find(
            (p) => String(p.value) === profileId,
          );
          if (selectedProfile) {
            if (
              selectedProfile.pc_bill_profile !== "DEFAULT" &&
              (selectedProfile.pc_bill_profile ?? []).length > 0
            ) {
              setbillingid(selectedProfile.pc_bill_profile);
            } else {
              setbillingid("");
            }

            // Set duration if available
            if (
              selectedProfile.pc_duration &&
              selectedProfile.pc_duration !== "0"
            ) {
              const duration = end.diff(start, "minutes");
              setEditing(selectedProfile.pc_duration);
              let outTimeVal = moment(appointmentData.start_time, "h:mm A").add(
                duration,
                "minutes",
              );
              setOutTime(moment(outTimeVal).format("h:mm A"));
            }
          }
        } else {
          console.warn("Profile ID not found in available options:", profileId);
          // Don't set the profile if it doesn't exist in options
          setprofileid("");
        }
      }

      // Set reason if available
      if (appointmentData.reason) {
        setReason(appointmentData.reason);
      }

      // Reset recurrence settings (waitlist appointments are typically one-time)
      setchecking1(false);
      setrepeatselectnew("");
      setrepeatselect2new("");
      setWeek_and_every(false);
      setrepValue("Does not repeat");
      setweekday([]);
    } catch (error) {
      console.error("Error populating appointment form:", error);
    }
  };

  // ------------------------------ Functions End--------------------------------------------------- //

  // ------------------------------ useEffect Start--------------------------------------------------- //
  useEffect(() => {
    if (aptdate !== "" && repvalue !== "Week" && repvalue !== "Daily") {
      const formattedApptDate = moment(aptdate, dtFormat);

      setLastdateApp(formattedApptDate.format(dtFormat));
    }
  }, [aptdate]);

  useEffect(() => {
    const updateZoom = () => {
      const zoom = window.devicePixelRatio;
      if (zoom >= 1.25) {
        setPopupWidth("194px");
      } else {
        setPopupWidth("270px");
      }
    };

    updateZoom();

    window.addEventListener("resize", updateZoom);
    return () => window.removeEventListener("resize", updateZoom);
  }, []);

  useEffect(() => {
    if (props.defaultTele === true) {
      onChangeRadio(2);
      checkvideovisit();
      props.handlesetDefaultTele();
    }
  }, [props.defaultTele]);

  useEffect(() => {
    if (props.ApptTab === "2") {
      if (props.start.Id !== undefined && props.start.Id !== "0") {
        const pc_eventDateW = props.start.pc_eventDate;
        const pc_endDateW = props.start.pc_endDate;

        const id = props.start.Id;
        const recType = props.start.pc_recurrtype;
        let repDates;
        if (recType !== "0") {
          //for weekly START
          if (props.start.customDate && props.start.customDate.length > 0) {
            const weekdays = props.start.customDate; // Monday, Wednesday, Friday (1-based mapping)

            const resultDates = generateSpecificWeekdayArray(
              pc_eventDateW,
              pc_endDateW,
              weekdays,
            );
            repDates = resultDates;
          } else {
            const Fudates = generateDateArray(pc_eventDateW, pc_endDateW);
            repDates = Fudates;
          }
        }

        axiosInstance
          .get("/vozo/getappointmenttemplate?id=" + props.start.Id)
          .then((response) => {
            let temp_role = Decrypt_Value(response.data, "vozo");

            var currdate = moment().format("YYYY-MM-DD");
            const futureDates =
              repDates && repDates.length > 0
                ? repDates.filter((date) =>
                    moment(date).isSameOrAfter(currdate),
                  )
                : [];

            temp_role.futureDates = futureDates[0];
            temp_role.futureDatesall = futureDates;
            temp_role.repDates = repDates;
            temp_role.recType = recType;

            setSingleRow(temp_role);
          });
      } else {
        setSingleRow([]);
      }
      props.handlesetDefaultTele();
    }
  }, [props.ApptTab]);

  useEffect(() => {
    fetchGroupPatients({ limit: 4 });

    axiosInstance
      .get("/vozo/telehealth/getPlatform")
      .then((response) => {
        let decodingResponse = Decrypt_Value(response.data, "vozo");
        setTelehealthplatform(decodingResponse);
      })
      .catch((err) => {
        setTelehealthplatform("zoom");
      });
  }, []);
  useEffect(() => {
    const getWeeklyData = async () => {
      await axiosInstance
        .get("/vozo/calendarsettingdata")
        .then((response) => {
          let decodingResponse = Decrypt_Value(response.data, "vozo");
          setWeeklyDisable(decodingResponse[1].gl_value);
        })
        .catch(() => {});
    };

    const getAvailability = async () => {
      await axiosInstance
        .get("/vozo/settingdocumentdataAvailability")
        .then((response) => {
          let temp_role_setng_doc_data = Decrypt_Value(response.data, "vozo");

          setswitchvalue(
            temp_role_setng_doc_data[0].gl_value === "1" ? true : false,
          );
        })
        .catch((err) => console.error(err));
    };
    getAvailability();
    getWeeklyData();
  }, []);

  useEffect(() => {
    let ofc_firstId = "";
    if (props.officeId) {
      const idArray = props.officeId.split(",");
      ofc_firstId = idArray[0];
    }
    if (providerid !== "" && providerid !== null && providerid !== undefined) {
      axiosInstance.get("/sprovider?uid=" + providerid).then((response) => {
        const data = Decrypt_Value(response.data, "vozo");
        setAllowAppt(Number(data.appt_type));
        if (Number(data.appt_type) === 3 && Appttype !== 2) {
          setofficeid(ofc_firstId);
          setAppttype(1);
          setvideochck(false);
          // setprofileid("");
          if (props.type !== "book again") {
            setstatusid("");
          }
          setbillingid("");
          let dur = moment(outTime, "hh:mm a").diff(
            moment(inTime, "hh:mm a"),
            "minutes",
          );
          setEditing(dur);
        } else if (Number(data.appt_type) === 2) {
          setAppttype(2);
          let t1 = inTime.split(" ");
          let t2 = outTime.split(" ");

          let from = disabledFromTimes(t1[0], t1[1], 2);

          if (!from) {
            let intime = moment(start);
            let now = moment();

            if (intime.isAfter(now)) {
              setInTime(moment(start).format("h:mm A"));
              let intime = moment(start).format("h:mm A");
              let out = moment(
                moment(start, "h:mm A").add(15, "minutes"),
              ).format("h:mm A");
              setOutTime(out);
              let dur = moment(out, "hh:mm a").diff(
                moment(intime, "hh:mm a"),
                "minutes",
              );
              setEditing(dur);
            }
          } else {
            let now = moment(start);

            let intime = now.format("h:mm A");

            let checktime = moment(aptdate, dtFormatsec);

            if (checktime.isBefore(now.format(dtFormat))) {
              // setOutTime("");
              setEditing("");
            } else {
              let out = moment(
                moment(now.format("h:mm A"), "h:mm A").add(15, "minutes"),
              ).format("h:mm A");

              setInTime(intime);
              setOutTime(out);
              let dur = moment(out, "hh:mm a").diff(
                moment(now, "hh:mm a"),
                "minutes",
              );
              setEditing(dur);
              setapttime(intime);
            }
          }

          if (props.type !== "book again") {
            setstatusid("");
          }
          setbillingid("");
          setprofileid("");
          setvideochck(true);
        } else if (Number(data.appt_type) === 1) {
          setofficeid(ofc_firstId);
          setAppttype(1);
          setvideochck(false);
          setprofileid("");
          if (props.type !== "book again") {
            setstatusid("");
          }
          setbillingid("");
        }
      });
    }
  }, [officeid, teleprofile]);
  useEffect(() => {
    let ofc_firstId = "";
    if (props.officeId) {
      const idArray = props.officeId.split(",");
      ofc_firstId = idArray[0];
    }
    if (providerid !== "" && providerid !== null && providerid !== undefined) {
      axiosInstance.get("/sprovider?uid=" + providerid).then((response) => {
        const data = Decrypt_Value(response.data, "vozo");
        setAllowAppt(Number(data.appt_type));
        if (Number(data.appt_type) === 3 && Appttype !== 2) {
          setAppttype(1);
          setvideochck(false);
          if (props.type !== "book again") {
            setstatusid("");
          }
          setbillingid("");
          let dur = moment(outTime, "hh:mm a").diff(
            moment(inTime, "hh:mm a"),
            "minutes",
          );
          setEditing(dur);
        } else if (Number(data.appt_type) === 2) {
          setAppttype(2);
          let t1 = inTime.split(" ");
          let t2 = outTime.split(" ");

          let from = disabledFromTimes(t1[0], t1[1], 2);

          if (!from) {
            let intime = moment(start);
            let now = moment();

            if (intime.isAfter(now)) {
              setInTime(moment(start).format("h:mm A"));
              let intime = moment(start).format("h:mm A");
              let out = moment(
                moment(start, "h:mm A").add(15, "minutes"),
              ).format("h:mm A");
              setOutTime(out);
              let dur = moment(out, "hh:mm a").diff(
                moment(intime, "hh:mm a"),
                "minutes",
              );
              setEditing(dur);
            }
          } else {
            let now = moment();

            let intime = now.format("h:mm A");

            let checktime = moment(aptdate, dtFormatsec);

            if (checktime.isBefore(now.format(dtFormat))) {
              // setOutTime("");
              setEditing("");
            } else {
              let out = moment(
                moment(now.format("h:mm A"), "h:mm A").add(15, "minutes"),
              ).format("h:mm A");

              setInTime(intime);
              setOutTime(out);
              let dur = moment(out, "hh:mm a").diff(
                moment(now, "hh:mm a"),
                "minutes",
              );
              setEditing(dur);
              setapttime(intime);
            }
          }

          if (props.type !== "book again") {
            setstatusid("");
          }
          setbillingid("");
          // setprofileid("");
          setvideochck(true);
        } else if (Number(data.appt_type) === 1) {
          setAppttype(1);
          setvideochck(false);
          // setprofileid("");
          if (props.type !== "book again") {
            setstatusid("");
          }
          setbillingid("");
        }
      });
    }
  }, [providerid]);

  useEffect(() => {
    const tempIntime = moment(start).format("h:mm A");
    if (props.view === "month") {
      let intime = moment(props.startTime1, "H").format("h:mm A");
      setInTime(intime);
      setapttime(intime);

      let outtime = moment(intime, "h:mm A")
        .add(15, "minutes")
        .format("h:mm A");
      setOutTime(outtime);

      let dur = moment(outtime, "h:mm A").diff(
        moment(intime, "h:mm A"),
        "minutes",
      );
      setEditing(dur);
    } else {
      if (props.fromDashboard) {
        axiosInstance
          .get("vozo/calendarsettingdata/main")
          .then((response) => {
            let temp_role_cal = Decrypt_Value(response.data, "vozo");

            let intime = moment(temp_role_cal.schedule_start, "H").format(
              "h:mm A",
            );

            setInTime(intime);

            let outtime = moment(intime, "h:mm A")
              .add(15, "minutes")
              .format("h:mm A");
            setOutTime(outtime);
            setapttime(intime);
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        setInTime(moment(start).format("h:mm A"));
        const tempIntime = moment(start).format("h:mm A");
        setOutTime(
          moment(moment(tempIntime, "h:mm A").add(15, "minutes")).format(
            "h:mm A",
          ),
        );
        setapttime(moment(start).format("h:mm A"));
      }
    }

    const intimeSplit = tempIntime.split(" ");

    getRoom(props.officeId);
    if (props.type !== "book again" && !props.isGroupAppointment) {
      setaptdate(moment(start).format(dtFormat));
    }
    setLastdateApp(moment(start).format(dtFormat));

    setappfromdate(moment(start).format("YYYY-MM-DD"));
    setapptodate(moment(start).format("YYYY-MM-DD"));

    setRoomVal(
      props.view === "day"
        ? props.examroom === true
          ? props.start.resourceId || ""
          : ""
        : props.examroom === true
          ? props.examRoomValueRef &&
            props.examRoomValueRef.current &&
            props.examRoomValueRef.current.length === 1
            ? props.examRoomValueRef.current[0]
            : ""
          : "",
    );
    let ofc_firstId = "";
    if (props.officeId) {
      const idArray = props.officeId.split(",");
      ofc_firstId = idArray[0];
    }
    setofficeid(ofc_firstId);
    getDatas();
  }, [props.start]);

  useEffect(() => {
    setproviderid(
      props.start === undefined
        ? props.examroom
          ? props.providerSelect[0]
          : props.provider
        : props.examroom !== true
          ? props.start.resourceId
          : props.providerSelect[0],
    );

    setSpecialityByusers(
      props.start === undefined
        ? props.examroom
          ? props.providerSelect[0]
          : props.provider
        : props.examroom !== true
          ? props.start.resourceId
          : props.providerSelect[0],
    );
  }, [props.start, props.providerSelect]);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      let data =
        "pat_share=" +
        encodeURIComponent(storedNames.appt_a) +
        "&main_pro=" +
        encodeURIComponent(main_pro) +
        "&owner_id=" +
        encodeURIComponent(owner_id) +
        "&userID=" +
        encodeURIComponent(userID) +
        "&authorized=" +
        encodeURIComponent(authorized) +
        "&facilityId=" +
        encodeURIComponent(officeid) +
        "&speciality=" +
        encodeURIComponent(speciality) +
        "&apttype=" +
        encodeURIComponent(
          Appttype == 1
            ? "Appointment"
            : Appttype == 2
              ? "Telehealth"
              : "Appointment",
        );

      let data1 = Encrypt_Value(data, "vozo");

      let url;
      let user = authorized === "1" ? userID : main_pro;

      if (storedNames.appt_a) {
        url = "/vozonew/provider?search=" + data1;
      } else {
        url = "/vozonew/provider?uid=" + user;
      }

      axiosInstance
        .get(url)
        .then((response) => {
          let temp_role_prov = Decrypt_Value(response.data, "vozo");

          setSourceprovider(temp_role_prov);

          if (!storedNames.appt_a || authorized === "0") {
            setNotDisabledSpec(temp_role_prov[0].specialty);
          }
        })
        .catch((err) => console.error(err));
    }
  }, [officeid, speciality, Appttype]);
  useEffect(() => {
    if (officeid !== "" && officeid !== undefined) {
      axiosInstance
        .get("vozo/speciality/getspeciality?officeid=" + officeid)
        .then((res) => {
          let decryptval = Decrypt_Value(res.data, "vozo");

          const countDict = decryptval.reduce((acc, item) => {
            acc[item.specialty] = item.count;
            return acc;
          }, {});

          const matchedSpecialties = specialityList.map((specialty) => ({
            specialty,
            count: countDict[specialty] || 0,
          }));
          matchedSpecialties.sort((a, b) => b.count - a.count);

          setSortSpecility(matchedSpecialties);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [officeid, speciality]);

  // useEffect(() => {
  //   axiosInstance
  //     .get("vozo/getBillingFacility")
  //     .then((res) => {
  //       setBillFacility(res.data);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  useEffect(() => {
    if (patsrchvalue !== "") {
      let isCancelled = false;
      const handlechange = async () => {
        await timeout(1000);

        if (!isCancelled) {
          let alle_data =
            "limit=40&fname=" +
            patsrchvalue.toLowerCase() +
            "&authorized=" +
            authorized +
            "&main_pro=" +
            main_pro +
            "&userID=" +
            userID +
            "&pat_share=" +
            storedNames.pat_share +
            "&owner_id=" +
            owner_id +
            "&activepatlist=" +
            1;

          let alle_data_enc = Encrypt_Value(alle_data, "vozo");

          axiosInstance
            .get("/vozo/patientsearch?search=" + alle_data_enc)
            .then((response) => {
              let temp_role = Decrypt_Value(response.data, "vozo");
              setFetchingOptions(false);
              setSource(temp_role); // get 10 datas from response.data main array
            })
            .catch(() => {
              setSource([]);
            });
        }
      };
      handlechange();
      return () => {
        isCancelled = true;
      };
    } else {
      let alle_data =
        "limit=40&authorized=" +
        authorized +
        "&main_pro=" +
        main_pro +
        "&userID=" +
        userID +
        "&pat_share=" +
        storedNames.pat_share +
        "&owner_id=" +
        owner_id +
        "&activepatlist=" +
        1;

      let alle_data_enc = Encrypt_Value(alle_data, "vozo");

      axiosInstance
        .get("/vozo/patientsearch?search=" + alle_data_enc)
        .then((response) => {
          let temp_role = Decrypt_Value(response.data, "vozo");

          setSource(temp_role);
        })
        .catch(() => {
          setSource([]);
        });
    }
  }, [patsrchvalue]);

  useEffect(() => {
    setBillFacId(bill_facility_id);
    axiosInstance
      .get("vozo/calendarsettingdata/main")
      .then((response) => {
        let temp_role_cal = Decrypt_Value(response.data, "vozo");
        setStartTime(
          temp_role_cal.schedule_start === "0"
            ? "0"
            : temp_role_cal.schedule_start,
        );
        setEndTime(
          temp_role_cal.schedule_end === "0"
            ? "24"
            : temp_role_cal.schedule_end,
        );

        const timeSlots1 = [];
        const timeSlots2 = [];
        let i = 0;
        let j = 0;
        let skipFirstMidnight = true;
        if (
          temp_role_cal.schedule_start === "0" &&
          temp_role_cal.schedule_end === "24"
        ) {
          for (let hour = 0; hour < 24; hour++) {
            for (let minute = 0; minute < 60; minute += 15) {
              let ampm = hour < 12 ? "AM" : "PM";
              let hourFormatted = hour === 0 ? 0 : hour > 12 ? hour - 12 : hour;
              if (hour === 24 && minute === 0) {
                ampm = "AM";
                hourFormatted = 12;
              }
              if (hour === 0) {
                hourFormatted = 12;
              }

              const time = `${hourFormatted
                .toString()
                .padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
              timeSlots1.push({ id: ++i, time: time, meridiem: ampm });
              if (time === "12:00" && ampm === "AM" && skipFirstMidnight) {
                skipFirstMidnight = false;
                continue;
              }
              if (time !== "00:00") {
                timeSlots2.push({ id: ++j, time: time, meridiem: ampm });
              }
              if (hour === 23 && minute === 45) {
                if (
                  timeSlots2[timeSlots2.length - 1].time === "11:45" &&
                  timeSlots2[timeSlots2.length - 1].meridiem === "PM"
                ) {
                  timeSlots2.push({ id: ++j, time: "11:59", meridiem: "PM" });
                }
              }
            }
          }
        } else {
          for (
            let hour = Number(temp_role_cal.schedule_start);
            hour < Number(temp_role_cal.schedule_end);
            hour++
          ) {
            for (let minute = 0; minute < 60; minute += 15) {
              const ampm = hour < 12 ? "AM" : "PM";
              const hourFormatted = hour > 12 ? hour - 12 : hour;
              const time = `${hourFormatted
                .toString()
                .padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
              timeSlots1.push({ id: ++i, time: time, meridiem: ampm });
            }
          }
          const scheduleStart = Number(temp_role_cal.schedule_start);
          const scheduleEnd = Number(temp_role_cal.schedule_end);

          for (let hour = scheduleStart; hour <= scheduleEnd; hour++) {
            for (let minute = 0; minute < 60; minute += 15) {
              const isPM = hour >= 12;
              const ampm = isPM ? "PM" : "AM";
              let hourFormatted = hour % 12;
              if (hourFormatted === 0) hourFormatted = 12;
              const time = `${hourFormatted
                .toString()
                .padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;

              timeSlots2.push({ id: ++j, time: time, meridiem: ampm });

              if (hour === scheduleEnd && minute === 0) break;
            }
          }
        }
        setFromTimeSlots(timeSlots1);
        var frSlotTmId = timeSlots1
          .filter((ele) => {
            return (
              moment(ele.time + ele.meridiem, "HH:mm A").format("HH:mm A") >=
              moment(start).format("HH:mm A")
            );
          })
          .map((ele) => {
            return ele.id;
          });

        setFromId(frSlotTmId.slice(0, 1));
        setToTimeSlots(timeSlots2);

        if (temp_role_cal.schedule_end >= 12) {
          if (temp_role_cal.schedule_end === "24") {
            setEndErrTime("12:00 AM");
          } else if (temp_role_cal.schedule_end !== "12")
            setEndErrTime(temp_role_cal.schedule_end - 12 + ":00 PM");
          else setEndErrTime("12:00 PM");
        } else {
          setEndErrTime(temp_role_cal.schedule_end + ":00 AM");
        }
        if (temp_role_cal.schedule_start >= 12) {
          if (temp_role_cal.schedule_start !== "12")
            setStartErrTime(temp_role_cal.schedule_start - 12 + ":00 PM");
          else setStartErrTime("12:00 PM");
        } else {
          setStartErrTime(temp_role_cal.schedule_start + ":00 AM");
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, [bill_facility_id, props.start]);

  useEffect(() => {
    const week_day = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    const month = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const day = new Date(moment(aptdate, dtFormat).format("YYYY-MM-DD"));
    setDay(week_day[day.getDay()]);

    // setMonth(month[day.getMonth()]);

    setDyOfMont(day.getDate());

    const weekNum = Math.ceil(day.getDate() / 7);
    if (weekNum == 1) {
      setWkOfMont("First");
    } else if (weekNum == 2) {
      setWkOfMont("Second");
    } else if (weekNum == 3) {
      setWkOfMont("Third");
    } else if (weekNum == 4) {
      setWkOfMont("Fourth");
    } else {
      setWkOfMont("Fifth");
    }
  }, [aptdate, repeatselectmonth]);
  useEffect(() => {
    if (repeatselect2new === "0") {
      if (repeatselectnew === "1") {
        //setOccurenceday(365);
      } else if (repeatselectnew === "2") {
        //setOccurenceday(182);
      } else if (repeatselectnew === "3") {
        //setOccurenceday(120);
      } else if (repeatselectnew === "4") {
        //setOccurenceday(91);
      } else if (repeatselectnew === "5") {
        //setOccurenceday(73);
      }
    } else if (repeatselect2new === "1") {
      if (repeatselectnew === "1") {
        //setOccurenceday(52);
      } else if (repeatselectnew === "2") {
        //setOccurenceday(26);
      } else if (repeatselectnew === "3") {
        //setOccurenceday(13);
      }
    } else if (repeatselect2new === "2") {
      if (repeatselectnew === "1") {
        //setOccurenceday(12);
      } else if (repeatselectnew === "2") {
        //setOccurenceday(6);
      } else if (repeatselectnew === "3") {
        //setOccurenceday(4);
      } else if (repeatselectnew === "4") {
        //setOccurenceday(3);
      }
    }
  }, [handleSelect2]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (props.type === "book again" || props.isGroupAppointment) {
          const data = await props.getAppointmentData();
          dispatch(setBookingData(data));
        }
      } catch (error) {
        console.error("Error fetching data in useEffect:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (props.type === "book again" || props.isGroupAppointment) {
      dataForBookAgain(bookingData);
    }
  }, [teleprofile, sourceprofile, bookingData]);

  useEffect(() => {
    if (typeof props.getStartApptDate === "function") {
      props.getStartApptDate(aptdate);
    }
  }, [aptdate]);

  useEffect(() => {
    if (props?.patEmail) {
      setEmptyEmailWarning(props.patEmail);
    }
  }, [props?.patEmail]);

  useEffect(() => {
    if (props.fromWaitList && props.waitlistData && !isWaitlistDataLoaded) {
      setIsInitialWaitlistLoad(true);
      const timer = setTimeout(() => {
        if (
          sourceoffice.length > 0 &&
          sourceprovider.length > 0 &&
          sourceprofile.length > 0
        ) {
          populateAppointmentData(props.waitlistData);
          setIsWaitlistDataLoaded(true);
        } else {
          const retryTimer = setTimeout(() => {
            populateAppointmentData(props.waitlistData);
            setIsWaitlistDataLoaded(true);
          }, 1000);

          return () => clearTimeout(retryTimer);
        }
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [
    props.waitlistData,
    props.fromWaitList,
    sourceoffice,
    sourceprovider,
    sourceprofile,
    speciality,
  ]);

  useEffect(() => {
    if (
      props.fromWaitList &&
      props.waitlistData &&
      officeid &&
      officeid !== "" &&
      !isWaitlistDataLoaded
    ) {
      setSpinnerVal(true);
      setTimeout(() => {
        if (props.waitlistData.speciality && speciality === "") {
          setSpeciality(props.waitlistData.speciality);
          setSpecialError(false);
        }

        setSpinnerVal(false);
      }, 3000);

      setSpinnerVal(false);
      // }, 3000);

      // return () => clearTimeout(timer);
    }
  }, [officeid, props.fromWaitList, props.waitlistData]);

  useEffect(() => {
    if (
      props.fromWaitList &&
      props.waitlistData &&
      officeid &&
      officeid !== ""
    ) {
      const timer = setTimeout(() => {
        if (props.waitlistData.appt_profile && sourceprofile.length > 0) {
          const profileId = String(props.waitlistData.appt_profile);
          const profileExists = sourceprofile.some(
            (p) => String(p.value) === profileId,
          );

          if (profileExists && profileid !== profileId) {
            setprofileid(profileId);
            setprofileError(false);
          }
        }

        if (props.waitlistData.speciality && speciality === "") {
          setSpeciality(props.waitlistData.speciality);
          setSpecialError(false);
        }
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [officeid, sourceprofile, props.fromWaitList, props.waitlistData]);

  // ------------------------------ useEffect----end---------------------------------------------------- //
  return (
    <>
      {/* changes by sridar */}

      <Modal
        className=" client-popup topcreate_popup_centre wid_562"
        centered
        show={show}
        onHide={() => {
          setShow(false);
          setTemShow(true);
        }}
      >
        <CreateClient
          setappshow={props.setappshow}
          setTemShow={setTemShow}
          clientShow={setShow}
          dataFetch={() => getDatas()}
          ClientAdd={ClientAdd}
          // ClientAdd={handleClientCreateSuccess}
          ClientFailed1={setClientFail1}
          openIntake={openIntake}
        />
      </Modal>
      <IntakeForms
        toShow={showIntakeForm}
        toHide={() => setShowIntakeForm(false)}
        patientName={intakeData?.name}
        patientMail={intakeData?.email}
        patientId={intakeData?.id}
        from="create_client"
      />

      {/* <Modal className="alert-popup-message" show={clientAddIs}>
        <div className="alert msg alert-success" role="alert">
          <BsCheckCircle className="icons-bs" /> Successfully added...
        </div>
      </Modal> */}

      {clientAddIs?.show && (
        <Modal
          className="alert-popup-message"
          show={true}
          backdrop="static"
          keyboard={false}
        >
          <div className="alert msg alert-success" role="alert">
            <BsCheckCircle className="icons-bs" />
            <span style={{ marginLeft: "8px" }}>{clientAddIs?.message}</span>
          </div>
        </Modal>
      )}

      {/* ...................... */}
      <div style={{ display: temShow ? "block" : "none" }}>
        {props.isGroupAppointment ? (
          <Modal.Header
            closeButton
            className={
              props.type == "book again"
                ? "bookAgain_bottom_border"
                : "new_appointment_pop_topHeading "
            }
          >
            <Modal.Title className="table-top ">Group Book Again</Modal.Title>
          </Modal.Header>
        ) : props.type !== "book again" ? (
          <Modal.Header
            closeButton
            className={
              props.type == "book again"
                ? "bookAgain_bottom_border"
                : "new_appointment_pop_topHeading "
            }
          >
            <Modal.Title className="table-top ">
              Schedule Appointment
            </Modal.Title>
          </Modal.Header>
        ) : (
          <div className="new_app_for_book">
            <Modal.Header
              closeButton
              className={
                props.type == "book again"
                  ? "bookAgain_bottom_border"
                  : "new_appointment_pop_topHeading "
              }
            >
              <Modal.Title className="table-top ">Book Again</Modal.Title>
            </Modal.Header>
          </div>
        )}

        <Modal.Body className="c-pop New-App_Mod-Body ref_app" id="new-appts">
          {SpinnerVal ? (
            <SpinnerDiv height="247px">
              <Spinner animation="border" variant="primary" />
            </SpinnerDiv>
          ) : (
            <>
              {props.isGroupAppointment ? (
                <Div
                  className="c-pop-one "
                  margin={
                    props.isGroupAppointment
                      ? "20px 0px 0px 5px"
                      : props.type !== "book again"
                        ? "20px 0px 0px -20px"
                        : "20px 0px 0px 0px"
                  }
                >
                  <Form.Row className="app-block  antd-select-height1">
                    {accountType > "0" || (accountType === "0" && trial) ? (
                      <>
                        {patFlag.map((item, ind) => (
                          <Div
                            key={ind}
                            className="new_appt_flag pt-fg-app-new"
                            style={{ backgroundColor: item.flag_color }}
                          >
                            <IoFlagOutline className="new_appt_flag_icon" />
                            <span className="new_appt_flag_amt">{`${item.flag_name} : ${item.description}`}</span>
                          </Div>
                        ))}
                      </>
                    ) : (
                      ""
                    )}
                    <div className="d_flex">
                      <div className="m_l_10">
                        <Div
                          alignItems="center"
                          className="search-pat  wholediv patient_name_out"
                        >
                          <Div margin="-20px 0px 0px -2px">
                            <PeopleOutline className="people" />
                          </Div>
                          <Div className="dropdiv" id="GroupPatient">
                            <Select
                              className={
                                groupPatError
                                  ? "err_mess_border w-100 b1"
                                  : "w-100"
                              }
                              placeholder="Group Name"
                              suffixIcon={<BsFillCaretDownFill />}
                              showSearch
                              filterOption={false} // IMPORTANT
                              loading={loading}
                              value={groupId}
                              onSearch={handleGroupSearch}
                              onChange={(value) => {
                                setGroupPatError(false);
                                setGroupId(value);
                              }}
                              notFoundContent={
                                loading ? "Loading..." : "No Group Found"
                              }
                              dropdownRender={(menu) => (
                                <>
                                  {menu}
                                  <div
                                    style={{
                                      borderTop: "1px solid #eaeaea",
                                      padding: "8px 12px",
                                      cursor: "pointer",
                                      color: "#1677ff",
                                      fontWeight: 500,
                                    }}
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={() => handleOpenGroupModal()}
                                  >
                                    + Add Patient Group
                                  </div>
                                </>
                              )}
                            >
                              {groupPatients.map((group) => (
                                <Select.Option
                                  key={group.value}
                                  value={group.value}
                                >
                                  {group.label}
                                </Select.Option>
                              ))}
                            </Select>
                            {groupPatError && (
                              <p className="errormessage">
                                Please Select Group
                              </p>
                            )}
                          </Div>
                        </Div>

                        <Div
                          alignItems="center"
                          className="appointment_poup_div appointment_poup_div_w"
                        >
                          <Div
                            id="new_appt_radio"
                            className="appt-spn-vdovis new_app_radio_group"
                          >
                            <Radio.Group
                              onChange={
                                accountType === "-1" ||
                                (accountType === "1" && teleFlag === "0")
                                  ? (e) => {
                                      if (Number(e.target.value) === 2) {
                                        setUpgrade(true);
                                      } else {
                                        onChangeRadio(e);
                                      }
                                    }
                                  : onChangeRadio
                              }
                              value={
                                walkincheck
                                  ? 3
                                  : forteleornor === 2
                                    ? forteleornor
                                    : Appttype
                              }
                            >
                              <Radio
                                className="radio_appt_btn"
                                value={1}
                                onChange={checkapt}
                                disabled={
                                  allowAppt !== 3 &&
                                  (allowAppt === 2 || videochck)
                                }
                              >
                                Appointment
                              </Radio>

                              <Radio
                                value={2}
                                onChange={checkvideovisit}
                                disabled={
                                  allowAppt !== 3 &&
                                  (allowAppt === 1 || !videochck)
                                }
                              >
                                Telehealth
                              </Radio>

                              <Radio
                                className="app-dashboard-radioBut m-0"
                                onClick={walkinclick}
                                value={3}
                                disabled={videochck}
                                id="new-app-walkin"
                              >
                                Walk-in
                              </Radio>
                            </Radio.Group>
                          </Div>
                        </Div>

                        <Div margin="13px 0 0 0">
                          <Div
                            alignItems="center"
                            className=" alx wholediv new_app_facility"
                          >
                            <Div margin="-20px 0px 0px -2px">
                              <RoomOutlined />
                            </Div>
                            <Div className="dropdiv" id="officeId">
                              <Select
                                virtual={false}
                                showSearch
                                placeholder="Hospital Name"
                                id="new-app-facility_1"
                                suffixIcon={<BsFillCaretDownFill />}
                                className={
                                  officeError
                                    ? `err_mess_border w-100 to-hide-ant-label ${checkFacility(
                                        "classname",
                                      )}`
                                    : `to-hide-ant-label w-100 ${checkFacility(
                                        "classname",
                                      )}`
                                }
                                onChange={(e, data) =>
                                  handleDropDownSelectOffice(e, data)
                                }
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.title ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                value={officeid ? officeid : null}
                                getPopupContainer={() =>
                                  document.getElementById("officeId")
                                }
                              >
                                {sourceoffice.map((i) => (
                                  <Option
                                    key={i.value}
                                    value={i.value}
                                    title={i.text}
                                  >
                                    {i.text}
                                  </Option>
                                ))}
                              </Select>
                              {checkFacility("spinner")}
                              {officeError && (
                                <p className="errormessage">
                                  Please select Office
                                </p>
                              )}
                            </Div>
                          </Div>
                        </Div>

                        <Div
                          alignItems="center"
                          className="search-pat new_app_select_prov appointment_patient_div"
                        >
                          <Div margin="-2px 0px 0px -2px">
                            <PeopleOutline />
                          </Div>
                          <Div className="appointment_drop_div" id="provId">
                            <Select
                              // virtual={false}
                              showSearch
                              placeholder="Doctor Name"
                              suffixIcon={<BsFillCaretDownFill />}
                              id="new-app-provider new-app-provider_1"
                              className={
                                provError ? "err_mess_border w-100 " : "w-100"
                              }
                              onChange={(e, data) =>
                                handleDropDownSelectProvider(e, data)
                              }
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                (option?.title ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              value={providerid ? providerid : undefined}
                              // getPopupContainer={() =>
                              //   document.getElementById("provId")
                              // }
                            >
                              {sourceprovider.map((i) => (
                                <Option
                                  key={i.value}
                                  value={i.value}
                                  title={i.text}
                                >
                                  {i.text}
                                </Option>
                              ))}
                            </Select>
                            {provError && (
                              <p className="errormessage">
                                Please select Provider
                              </p>
                            )}
                          </Div>
                        </Div>
                      </div>

                      <div>
                        <Div className=" w-100 m_b_12">
                          <Div className="wholediv">
                            <Div margin="-20px 0px 0px -2px">
                              <PersonOutline />
                            </Div>
                            <Div className="dropdiv" id="ProfId">
                              <Select
                                virtual={false}
                                getPopupContainer={(triggerNode) =>
                                  triggerNode.parentNode
                                }
                                className={
                                  profileError
                                    ? "err_mess_border w-100"
                                    : "w-100"
                                }
                                showSearch
                                placeholder="Appt Profile"
                                id="new-app-profile_1 appt-inp-profsrch"
                                suffixIcon={<BsFillCaretDownFill />}
                                onChange={(e, data) =>
                                  handleDropDownSelect(e, data)
                                }
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.title ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                value={profileid ? profileid : null}
                                dropdownAlign={{
                                  points: ["tl", "bl"],
                                  offset: [0, 4],
                                }}
                                dropdownStyle={{
                                  zIndex: 1050,
                                }}
                              >
                                {sourceprofile.map((i) => (
                                  <Option
                                    key={i.value}
                                    value={i.value}
                                    title={i.text}
                                  >
                                    {i.text}
                                  </Option>
                                ))}
                              </Select>

                              {profileError && (
                                <p className="errormessage">
                                  Please select Appointment Profile
                                </p>
                              )}
                            </Div>
                          </Div>
                        </Div>

                        <Div className="new_app_date_bookAgain">
                          <Div className="access_icon">
                            <AccessTimeIcon className="people" />
                          </Div>
                          <form
                            className={`${classes.container} frm-apoint`}
                            noValidate
                          >
                            <div
                              id="crt_appt-time-ok"
                              className="date-pick date-pick-parent app-datepick_bookAgain"
                            >
                              <DatePicker
                                getPopupContainer={(triggerNode) =>
                                  triggerNode.parentNode
                                }
                                style={{ width: "100px" }}
                                onChange={(date) => {
                                  if (date) {
                                    setDateErr(false);

                                    setaptdate(moment(date).format(dtFormat));
                                  } else {
                                    setaptdate(moment().format(dtFormat));
                                  }
                                }}
                                className={dateErr ? "err-bdr-date" : ""}
                                placeholder="Select date"
                                format={dtFormat}
                                value={
                                  aptdate ? moment(aptdate, dtFormat) : null
                                }
                                allowClear={false}
                                disabledDate={
                                  Appttype == 2 &&
                                  ((current) => {
                                    // Disable dates before today
                                    return (
                                      current &&
                                      current < moment().startOf("day")
                                    );
                                  })
                                }
                              />

                              <div className="App-time ">
                                <div className="showTime">
                                  <input
                                    className="fromTime-toTime-start"
                                    onClick={() => {
                                      handleFromTime();
                                    }}
                                    onMouseLeave={() => {
                                      setTempOpen(false);
                                    }}
                                    style={
                                      timeMismatch || inTimeErr
                                        ? {
                                            border: "1px solid red",
                                          }
                                        : {}
                                    }
                                    value={inTime}
                                    onChange={(e) => {
                                      if (!regexFirstNum.test(e.target.value)) {
                                        setFromShow(false);
                                        setToShow(false);
                                        setInTime(e.target.value);
                                        setTimeMismatch(false);
                                        setTimeout(() => {
                                          setInTime(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                          );

                                          onChange(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                            "inTime",
                                          );
                                        }, 4000);
                                      }
                                    }}
                                    onBlur={(e) => {
                                      setTimeMismatch(false);
                                      setInTime(
                                        moment(e.target.value, "h:mm A").format(
                                          "h:mm A",
                                        ),
                                      );
                                      onChange(
                                        moment(e.target.value, "h:mm A").format(
                                          "h:mm A",
                                        ),
                                        "inTime",
                                      );
                                    }}
                                  />
                                  <p className="time--space">-</p>
                                  <input
                                    className="fromTime-toTime"
                                    onClick={() => {
                                      handleToTime();
                                    }}
                                    style={
                                      timeMismatch || inTimeErr
                                        ? {
                                            border: "1px solid red",
                                          }
                                        : {}
                                    }
                                    onChange={(e) => {
                                      if (!regexFirstNum.test(e.target.value)) {
                                        setFromShow(false);
                                        setToShow(false);
                                        setOutTime(e.target.value);
                                        setTimeMismatch(false);
                                        setTimeout(() => {
                                          setOutTime(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                          );

                                          onChange(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                            "outTime",
                                          );
                                        }, 4000);
                                      }
                                    }}
                                    onMouseLeave={() => {
                                      setTempOpen(false);
                                    }}
                                    onBlur={(e) => {
                                      setTimeMismatch(false);
                                      setOutTime(
                                        moment(e.target.value, "h:mm A").format(
                                          "h:mm A",
                                        ),
                                      );
                                      onChange(
                                        moment(e.target.value, "h:mm A").format(
                                          "h:mm A",
                                        ),
                                        "outTime",
                                      );
                                    }}
                                    value={outTime}
                                  />
                                </div>

                                {/* From Button */}
                                <div
                                  className={
                                    fromShow
                                      ? "fromArray-toArray"
                                      : "fromArray_hide"
                                  }
                                >
                                  {frtimeSlots.map((item, index) => {
                                    return (
                                      <button
                                        key={item.id}
                                        value={item.time + " " + item.meridiem}
                                        disabled={disabledFromTimes(
                                          item.time,
                                          item.meridiem,
                                          Appttype,
                                        )}
                                        onClick={async (e) => {
                                          setTimeMismatch(false);
                                          setInTime(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                          );
                                          await setFromId(item.id);
                                          handleFromButton(e);
                                          onChange(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                            "inTime",
                                          );
                                        }}
                                      >
                                        {item.time + " " + item.meridiem}
                                      </button>
                                    );
                                  })}
                                </div>
                                {/* To button */}
                                <div
                                  className={
                                    toShow
                                      ? "fromArray-toArray"
                                      : "toArray_hide"
                                  }
                                  style={{ left: 70 }}
                                >
                                  {totimeSlots.map((item, index) => {
                                    return (
                                      <button
                                        disabled={disabledToTime(
                                          item.time,
                                          item.meridiem,
                                          item.id,
                                          Appttype,
                                        )}
                                        key={index}
                                        value={item.time + " " + item.meridiem}
                                        onClick={async (e) => {
                                          setTimeMismatch(false);
                                          setOutTime(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                          );

                                          handleToButton(e);
                                          onChange(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                            "outTime",
                                          );
                                        }}
                                      >
                                        {item.time + " " + item.meridiem}
                                      </button>
                                    );
                                  })}
                                </div>
                              </div>
                              {/* nisha end */}
                            </div>
                            {dateErr && (
                              <Form.Text
                                id="new-app-time-codetext appt-warn-time"
                                className="colour-red m-t-0-imp_editAppointment "
                              >
                                Please Select valid date
                              </Form.Text>
                            )}
                          </form>
                        </Div>
                        {(inTimeErr || timeMismatch) && (
                          <Form.Text
                            id="new-app-time-codetext appt-warn-time"
                            className="colour-red p-l-66 m-t-0-imp m-b-3"
                          >
                            Please Select valid Time
                          </Form.Text>
                        )}
                        {timelimiterrorbox && (
                          <Form.Text
                            id="new-app-time-codetext appt-warn-time"
                            className="colour-red p-l-66 m-t-0-imp m-b-3"
                          >
                            Provider Only Available Between {startErrTime} to{" "}
                            {endErrTime}
                          </Form.Text>
                        )}

                        <Div style={{ textAlign: "left" }}>
                          <Popup
                            content={fornormalapp}
                            open={normalappointment}
                            trigger={
                              <Button
                                id="click_event_app_normal"
                                content="Button"
                              />
                            }
                            position="left center"
                          />
                        </Div>
                        <Div>
                          <Popup
                            content={forteleapp}
                            open={teleappointment}
                            trigger={
                              <Button
                                id="click_event_app_tele"
                                content="Button"
                              />
                            }
                            position="left center"
                          />
                        </Div>

                        <Div className=" w-100">
                          <Div className="wholediv">
                            <Div margin="-20px 0px 0px -2px" size="20px">
                              <Image
                                src={doctorLogo}
                                alt="speciality"
                                height="20px"
                                width="20px"
                              />
                            </Div>

                            <Div className="dropdiv">
                              <Select
                                getPopupContainer={(triggerNode) =>
                                  triggerNode.parentNode
                                }
                                virtual={false}
                                showSearch
                                placeholder="Select Specialityyyy"
                                suffixIcon={<BsFillCaretDownFill />}
                                className={
                                  specialError
                                    ? "err_mess_border w-100"
                                    : "w-100"
                                }
                                onChange={(data) => changeSpeciality(data)}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.title ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                value={speciality ? speciality : null}
                                optionLabelProp="label"
                                dropdownClassName="speciality-option"
                              >
                                {sortSpeciality &&
                                  sortSpeciality
                                    .filter(
                                      (item) =>
                                        (storedNames.appt_a ||
                                          item.specialty === notDisabledSpec) &&
                                        item.count > 0,
                                    ) // Filter disabled options
                                    .map((item) => (
                                      <Option
                                        key={item.specialty}
                                        value={item.specialty}
                                        title={item.specialty}
                                        disabled={
                                          (!storedNames.appt_a &&
                                            item.specialty !==
                                              notDisabledSpec) ||
                                          item.count === 0
                                        }
                                        id={
                                          !storedNames.appt_a &&
                                          item.specialty !== notDisabledSpec
                                            ? "clr-disable"
                                            : "" || item.count == 0
                                              ? "clr-disable"
                                              : ""
                                        }
                                        className={
                                          (!storedNames.appt_a &&
                                            item.speciality !==
                                              notDisabledSpec) ||
                                          item.count === 0
                                        }
                                      >
                                        {item.speciality}
                                      </Option>
                                    ))}
                              </Select>
                              {specialError && (
                                <p className="errormessage">
                                  Select a specialityyyy
                                </p>
                              )}
                            </Div>
                          </Div>
                        </Div>

                        <Div className=" w-100">
                          <Div
                            className="wholediv"
                            // className="alx p-r-20"
                          >
                            <Div margin="-20px 0px 0px -2px">
                              <HomeOutlinedIcon />
                            </Div>
                            <Div className="dropdiv" id="ExaId">
                              <Select
                                getPopupContainer={(triggerNode) =>
                                  triggerNode.parentNode
                                }
                                virtual={false}
                                showSearch
                                placeholder="Exam Room"
                                id="new-app-profile_1"
                                suffixIcon={<BsFillCaretDownFill />}
                                className={
                                  examroomError
                                    ? "err_mess_border w-100"
                                    : "w-100"
                                }
                                onChange={(e, data) =>
                                  handleRoomVal(data.value)
                                }
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.title ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                value={roomval ? roomval : null}
                                dropdownAlign={{
                                  points: ["tl", "bl"],
                                  offset: [0, 4],
                                }}
                                dropdownStyle={{
                                  zIndex: 1050,
                                  maxHeight: "200px",
                                }}
                              >
                                {sourceroom.map((i) => (
                                  <Option
                                    key={i.value}
                                    value={i.value}
                                    title={i.text}
                                  >
                                    {i.text}
                                  </Option>
                                ))}
                              </Select>
                              {examroomError && (
                                <p className="errormessage">
                                  Please select Exam Room
                                </p>
                              )}
                            </Div>
                          </Div>
                        </Div>
                      </div>
                    </div>
                    <Div display="flex" padding="0px 0px 10px 45px">
                      <p className="remove-bor-mar">Reason</p>
                      {ENABLE_REASON_DROPDOWN ? (
                        <Select
                          value={reason || undefined}
                          onChange={(value) => setReason(value)}
                          style={{
                            width: "528px",
                            minWidth: "528px",
                            maxWidth: "528px",
                          }}
                          placeholder="Select Reason"
                          suffixIcon={
                            <BsFillCaretDownFill size={12} color="#808080" />
                          }
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentNode
                          }
                        >
                          {reasonOptions.map((item) => (
                            <Option key={item} value={item}>
                              {item}
                            </Option>
                          ))}
                        </Select>
                      ) : (
                        <InputSchedule
                          maxLength={200}
                          width="528px"
                          value={reason}
                          onChange={(e) => setReason(e.target.value)}
                        />
                      )}
                      {!ENABLE_REASON_DROPDOWN && (
                        <p
                          className="remove-bor-mar-reason"
                          style={{
                            color:
                              reason && reason.length >= 200
                                ? "red"
                                : "inherit",
                          }}
                        >
                          Maximum of 200 characters
                        </p>
                      )}
                    </Div>
                  </Form.Row>
                </Div>
              ) : props.type !== "book again" ? (
                <Tabs
                  activeKey={changeTab}
                  className="tabheader for_add_app_avail"
                  onChange={(val) => setChangeTag(val)}
                >
                  <Popup
                    offset={[-40, 20]}
                    content={
                      <GetStartedPopup
                        title="Schedule your first appointment"
                        bullets={[
                          "Select Patient",
                          "Select Type of Appointment",
                          "Select Appointment Profile",
                          "Select Facility",
                          "Select Specialty",
                          "Select Provider (based on Specialty)",
                          "Select Appointment Status",
                          "Select Exam Room",
                          "Click Save to save your appointment",
                        ]}
                        thanksnote="Thank you taking your time to finish the setup. With this your initial account setup is complete."
                        currentStep={6}
                        totalSteps={6}
                        onBack={handleIntroBack}
                        onGotIt={handleIntroGotIt}
                        onClose={() => {
                          props.setShowStepSixIntro(false);
                          props.closepopup();
                        }}
                        width={popupWidth}
                      />
                    }
                    open={props.showStepSixIntro}
                    className="m-t-10"
                    trigger={<div></div>}
                    position="left center"
                  />
                  <TabPane
                    tab="New Appointment"
                    key="1"
                    className="appt-dash-hed p_l_10"
                  >
                    <Div className="c-pop-one " margin="20px 0px 0px -20px">
                      <Form.Row className="app-block  antd-select-height1">
                        {accountType > "0" || (accountType === "0" && trial) ? (
                          <>
                            {patFlag.map((item, ind) => (
                              <Div
                                key={ind}
                                className="new_appt_flag pt-fg-app-new"
                                style={{ backgroundColor: item.flag_color }}
                              >
                                {/* <IoFlagOutline className="new_appt_flag_icon" />
                                <span className="new_appt_flag_amt">
                                  {`${item.flag_name} : ${item.description}`} */}
                                <div
                                  className="app_pro_text_wrap new_app_flag"
                                  title={item.flag_name}
                                >
                                  {" "}
                                  <IoFlagOutline
                                    className="new_appt_flag_icon"
                                    style={{ marginRight: "5px" }}
                                  />
                                  {item.flag_name}
                                </div>
                                {/* </span> */}
                              </Div>
                            ))}
                          </>
                        ) : (
                          ""
                        )}
                        <div className="d_flex">
                          <div className="m_l_10">
                            <Div
                              alignItems="center"
                              className="search-pat  wholediv patient_name_out patient_name_filter"
                            >
                              <Div margin="-20px 0px 0px -2px">
                                <PeopleOutline className="people" />
                              </Div>
                              <Div className="dropdiv " id="PatId">
                                <Select
                                  virtual={false}
                                  getPopupContainer={(triggerNode) =>
                                    triggerNode.parentNode
                                  }
                                  // dropdownStyle={{
                                  //   maxHeight: "200px",
                                  // }}
                                  showSearch
                                  allowClear={false}
                                  placeholder="Patient Name"
                                  id="new-app-patient_1 appt-inp-patsrch "
                                  suffixIcon={<BsFillCaretDownFill />}
                                  disabled={props?.from === "patient_detail"}
                                  className={
                                    patError
                                      ? "err_mess_border w-100 b1"
                                      : "w-100"
                                  }
                                  // value={
                                  //   patientid || searchInput
                                  //     ? search1
                                  //     : undefined
                                  // } // control value
                                  value={
                                    searchInputValue || patientid
                                      ? searchInputValue
                                      : undefined
                                  }
                                  // searchInputValue || patientid
                                  //   ? searchInputValue
                                  //   : undefined
                                  searchValue={searchInput}
                                  onSearch={(value) => {
                                    setSearchInput(value);
                                    setpatsrchvalue(value);
                                    setFetchingOptions(true);
                                  }}
                                  onSelect={(value, option) => {
                                    handleDropDownSelectPatient(value, option);
                                    setSearchInput(option.title);
                                  }}
                                  onChange={(value, option) => {
                                    if (!value) {
                                      setSearchInput("");
                                      setSearchInputValue("");
                                      setpatientid(null);
                                      setpatsrchvalue("");
                                      return;
                                    }

                                    const selectedTitle = option?.title || "";

                                    setSearchInputValue(selectedTitle);
                                    setSearchInput(selectedTitle);
                                    setpatientid(value);
                                    handleDropDownSelectPatient(value, option);
                                  }}
                                  filterOption={false}
                                  notFoundContent={
                                    fetchingOptions
                                      ? "Loading..."
                                      : "No Data found"
                                  }
                                  // getPopupContainer={(triggerNode) =>
                                  //   triggerNode.parentNode
                                  // }
                                  // dropdownStyle={{
                                  //   maxHeight: "200px",
                                  // }}
                                  dropdownAlign={{
                                    points: ["tl", "bl"],
                                    offset: [0, 4],
                                  }}
                                  // dropdownStyle={{ zIndex: 1050 }}
                                  dropdownRender={(menu) => (
                                    <>
                                      {menu}
                                      <StyledDiv>
                                        <StyledButton
                                          disabled={
                                            storedNames.demo1_viewOnly ||
                                            storedNames.demo_v
                                          }
                                          onClick={() => {
                                            if (!storedNames.demo) {
                                              alert(
                                                "You don’t have access to add patients",
                                              );
                                            } else {
                                              setTemShow(false);
                                              setShow(true);
                                            }
                                          }}
                                          onMouseDown={(e) =>
                                            e.preventDefault()
                                          }
                                        >
                                          <StyledSvg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 448 512"
                                          >
                                            <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" />
                                          </StyledSvg>
                                          <span
                                            onClick={() => {
                                              if (
                                                storedNames.demo1_viewOnly ||
                                                storedNames.demo_v
                                              ) {
                                                alert(
                                                  "You only have view-only access.",
                                                );
                                              } else {
                                                handleAddPatient();
                                              }
                                            }}
                                          >
                                            Add Patient
                                          </span>
                                        </StyledButton>
                                      </StyledDiv>
                                      <StyledDiv>
                                        <StyledButton
                                          onClick={() => {
                                            history.push("/schedule/waitlist");
                                            props.closepopup();
                                          }}
                                        >
                                          <Image
                                            height="16px"
                                            width="16px"
                                            src={waitListIcon}
                                            // className="spin-img center-loading-image"
                                          />{" "}
                                          Select From Waitlist
                                        </StyledButton>
                                      </StyledDiv>
                                    </>
                                  )}
                                >
                                  {source.map((i) => {
                                    const titleLength = i.text.length;

                                    return (
                                      <Option
                                        key={i.value}
                                        value={i.value}
                                        title={i.text}
                                        phone_cell={i.phone_cell}
                                        dob={i.dob}
                                        ss={i.ss}
                                        email={i.email}
                                      >
                                        <div>
                                          {titleLength < 15 ? (
                                            <>
                                              {i.text} -{" "}
                                              {i.dob
                                                ? moment(i.dob).format(dtFormat)
                                                : " "}
                                            </>
                                          ) : (
                                            <>
                                              <div>{i.text} -</div>
                                              <div>
                                                {i.dob
                                                  ? moment(i.dob).format(
                                                      dtFormat,
                                                    )
                                                  : " "}
                                              </div>
                                            </>
                                          )}
                                        </div>
                                        <div>{i.phone_cell}</div>
                                      </Option>
                                    );
                                  })}
                                </Select>

                                {patError && (
                                  <p className="errormessage">
                                    Please select Patient
                                  </p>
                                )}
                              </Div>
                            </Div>

                            <Div
                              alignItems="center"
                              className="appointment_poup_div appointment_poup_div_w"
                            >
                              <Div
                                id="new_appt_radio"
                                className="appt-spn-vdovis new_app_radio_group"
                              >
                                <Radio.Group
                                  onChange={
                                    accountType === "-1" ||
                                    (accountType === "1" && teleFlag === "0")
                                      ? (e) => {
                                          if (Number(e.target.value) === 2) {
                                            setUpgrade(true);
                                          } else {
                                            onChangeRadio(e);
                                          }
                                        }
                                      : onChangeRadio
                                  }
                                  value={
                                    walkincheck
                                      ? 3
                                      : forteleornor === 2
                                        ? forteleornor
                                        : Appttype
                                  }
                                >
                                  <Radio
                                    className="radio_appt_btn"
                                    value={1}
                                    onChange={checkapt}
                                    disabled={
                                      allowAppt !== 3 &&
                                      (allowAppt === 2 || videochck)
                                    }
                                  >
                                    Appointment
                                  </Radio>

                                  <Radio
                                    value={2}
                                    onChange={checkvideovisit}
                                    disabled={
                                      allowAppt !== 3 &&
                                      (allowAppt === 1 || !videochck)
                                    }
                                  >
                                    Telehealth
                                  </Radio>

                                  {/* <Radio
                                    className="app-dashboard-radioBut m-0"
                                    onClick={walkinclick}
                                    value={3}
                                    // disabled={videochck}
                                    id="new-app-walkin"
                                    disabled={
                                      allowAppt !== 3 &&
                                      (allowAppt === 2 || videochck)
                                    }
                                  >
                                    Walk-in
                                  </Radio> */}

                                  <Radio
                                    className="app-dashboard-radioBut m-0"
                                    onClick={walkinclick}
                                    value={3}
                                    id="new-app-walkin"
                                  >
                                    Walk-in
                                  </Radio>
                                </Radio.Group>
                              </Div>
                            </Div>

                            {emptyEmailWarning && videochck && (
                              <Div>
                                <p
                                  className="errormessage"
                                  style={{
                                    marginTop: "12px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  <Image
                                    src={errorIcon}
                                    alt="Alert"
                                    height="20px"
                                    width="20px"
                                  />
                                  <span style={{ paddingLeft: "5px" }}>
                                    No email ID found for this patient. Add an
                                    email
                                  </span>
                                </p>
                              </Div>
                            )}

                            <Div margin="13px 0 0 0">
                              <Div
                                alignItems="center"
                                className=" alx wholediv new_app_facility"
                              >
                                <Div margin="-20px 0px 0px -2px">
                                  <RoomOutlined />
                                </Div>
                                <Div className="dropdiv" id="officeId">
                                  <Select
                                    virtual={false}
                                    showSearch
                                    placeholder="Hospital Name"
                                    id="new-app-facility_1"
                                    suffixIcon={<BsFillCaretDownFill />}
                                    className={
                                      officeError
                                        ? `err_mess_border w-100 to-hide-ant-label ${checkFacility(
                                            "classname",
                                          )}`
                                        : `to-hide-ant-label w-100 ${checkFacility(
                                            "classname",
                                          )}`
                                    }
                                    onChange={(e, data) =>
                                      handleDropDownSelectOffice(e, data)
                                    }
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.title ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    value={officeid ? officeid : undefined}
                                    getPopupContainer={(triggerNode) =>
                                      triggerNode.parentNode
                                    }
                                    dropdownStyle={{
                                      maxHeight: "200px",
                                    }}
                                  >
                                    {sourceoffice.map((i) => (
                                      <Option
                                        key={i.value}
                                        value={i.value}
                                        title={i.text}
                                      >
                                        {i.text}
                                      </Option>
                                    ))}
                                  </Select>
                                  {checkFacility("spinner")}
                                  {officeError && (
                                    <p className="errormessage">
                                      Please select Office
                                    </p>
                                  )}
                                </Div>
                              </Div>
                            </Div>

                            <Div
                              alignItems="center"
                              className="search-pat new_app_select_prov appointment_patient_div"
                            >
                              <Div margin="-2px 0px 0px -2px">
                                <PeopleOutline />
                              </Div>
                              <Div className="appointment_drop_div" id="provId">
                                <Select
                                  // virtual={false}
                                  showSearch
                                  placeholder="Doctor Name"
                                  suffixIcon={<BsFillCaretDownFill />}
                                  id="new-app-provider new-app-provider_1"
                                  className={
                                    provError
                                      ? "err_mess_border w-100 "
                                      : "w-100"
                                  }
                                  onChange={(e, data) => {
                                    if (storedNames.appt_a1_viewOnly) {
                                      alert("You only have view-only access.");
                                    } else {
                                      handleDropDownSelectProvider(e, data);
                                    }
                                  }}
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    (option?.title ?? "")
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  value={providerid ? providerid : undefined}
                                  // getPopupContainer={() =>
                                  //   document.getElementById("provId")
                                  // }
                                >
                                  {sourceprovider.map((i) => (
                                    <Option
                                      key={i.value}
                                      value={i.value}
                                      title={i.text}
                                      disabled={storedNames.appt_a1_viewOnly}
                                    >
                                      {i.text}
                                    </Option>
                                  ))}
                                </Select>
                                {provError && (
                                  <p className="errormessage">
                                    Please select Provider
                                  </p>
                                )}
                              </Div>
                            </Div>

                            <Div
                              className="app_repeat_dropdown app_dummy_class"
                              margin=" 0px 0px 10px 40px"
                            >
                              <BsFillCaretDownFill className="down_arrow_doesnt does-not-repeat-icon-new" />

                              <DropdownButton
                                getPopupContainer={(triggerNode) =>
                                  triggerNode.parentNode
                                }
                                id="arrow-newAppt"
                                className="app-nav-dropdown-for-newApp-repect "
                                title={repvalue ? repvalue : "Does not repeat"}
                                onSelect={handlerepSelect}
                                variant="light"
                              >
                                <Dropdownant.Item eventKey="Does not repeat">
                                  Does not repeat
                                </Dropdownant.Item>
                                <Dropdownant.Item
                                  onClick={handleShowuntildate}
                                  eventKey="Daily"
                                >
                                  Daily
                                </Dropdownant.Item>
                                <Dropdownant.Item
                                  onClick={handleShowuntildate}
                                  eventKey={"Week"}
                                >
                                  Week
                                </Dropdownant.Item>
                              </DropdownButton>
                            </Div>

                            {repvalue === "Week" && (
                              <Div margin="5px 4px 14px 40px">
                                <ToggleButtonGroup
                                  type="checkbox"
                                  value={weekday}
                                  className="appt_repeats but-act app_gap "
                                  onChange={WeekdayChange}
                                  style={
                                    selectdayError
                                      ? {
                                          border: "1px solid red",
                                          borderRadius: "5px",
                                        }
                                      : {}
                                  }
                                >
                                  <ToggleButton
                                    disabled={
                                      WeeklyDisable === "Show only weekdays" ||
                                      WeeklyDisable === "Don't show Sundays"
                                        ? true
                                        : false
                                    }
                                    className={
                                      WeeklyDisable === "Show only weekdays" ||
                                      (WeeklyDisable === "Don't show Sundays" &&
                                        "weekDisableBtn")
                                    }
                                    id="tbg-btn-1"
                                    value={1}
                                  >
                                    S
                                  </ToggleButton>
                                  <ToggleButton id="tbg-btn-2" value={2}>
                                    M
                                  </ToggleButton>
                                  <ToggleButton id="tbg-btn-3" value={3}>
                                    T
                                  </ToggleButton>
                                  <ToggleButton id="tbg-btn-3" value={4}>
                                    W
                                  </ToggleButton>
                                  <ToggleButton id="tbg-btn-3" value={5}>
                                    T
                                  </ToggleButton>
                                  <ToggleButton id="tbg-btn-3" value={6}>
                                    F
                                  </ToggleButton>
                                  <ToggleButton
                                    disabled={
                                      WeeklyDisable === "Show only weekdays"
                                        ? true
                                        : false
                                    }
                                    id="tbg-btn-3"
                                    value={7}
                                  >
                                    S
                                  </ToggleButton>
                                </ToggleButtonGroup>

                                {selectdayError && (
                                  <p className="errormessage">
                                    Please select atleast a day
                                  </p>
                                )}
                              </Div>
                            )}

                            {repvalue !== "" &&
                              repvalue !== undefined &&
                              repvalue !== null &&
                              repvalue !== "Does not repeat" &&
                              repvalue !== "Does not repeat " && (
                                <Div margin=" 0px 0px 10px 30px" dis="flex">
                                  <Span
                                    marginRight="3px"
                                    color="#000000 !important"
                                  >
                                    Until:
                                  </Span>
                                  <Div position="relative">
                                    <DatePicker
                                      getPopupContainer={(triggerNode) =>
                                        triggerNode.parentNode
                                      }
                                      disabledDate={(current) => {
                                        const oneYearFromNow = moment()
                                          .add(1, "year")
                                          .startOf("day");
                                        return (
                                          current.isBefore(
                                            moment(aptdate, dtFormat),
                                            "day",
                                          ) ||
                                          current.isAfter(oneYearFromNow, "day")
                                        );
                                      }}
                                      onChange={(date) => {
                                        if (date) {
                                          setLastdateApp(
                                            moment(date).format(dtFormat),
                                          );
                                        } else {
                                          setLastdateApp(
                                            moment().format(dtFormat),
                                          );
                                        }
                                      }}
                                      placeholder="From-"
                                      format={dtFormat}
                                      value={
                                        lastdateApp
                                          ? moment(lastdateApp, dtFormat)
                                          : null
                                      }
                                      allowClear={false}
                                    />
                                  </Div>
                                </Div>
                              )}
                          </div>

                          <div>
                            <Div className=" w-100 m_b_12">
                              <Div
                                className="wholediv"
                                // className="alx p-r-20"
                              >
                                <Div margin="-20px 0px 0px -2px">
                                  <PersonOutline />
                                </Div>
                                <Div className="dropdiv" id="ProfId">
                                  <Select
                                    virtual={false}
                                    className={
                                      profileError
                                        ? "err_mess_border w-100"
                                        : "w-100"
                                    }
                                    showSearch
                                    placeholder="Appt Profile"
                                    id="new-app-profile_1 appt-inp-profsrch"
                                    suffixIcon={<BsFillCaretDownFill />}
                                    onChange={(e, data) =>
                                      handleDropDownSelect(e, data)
                                    }
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.title ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    value={profileid ? profileid : undefined}
                                    getPopupContainer={(triggerNode) =>
                                      triggerNode.parentNode
                                    }
                                    dropdownStyle={{
                                      maxHeight: "200px",
                                    }}
                                    dropdownAlign={{
                                      points: ["tl", "bl"],
                                      offset: [0, 4],
                                    }}
                                    // dropdownStyle={{
                                    //   zIndex: 1050,
                                    // }}
                                  >
                                    {sourceprofile.map((i) => (
                                      <Option
                                        key={i.value}
                                        value={i.value}
                                        title={i.text}
                                      >
                                        {i.text}
                                      </Option>
                                    ))}
                                  </Select>

                                  {profileError && (
                                    <p className="errormessage">
                                      Please select Appointment Profile
                                    </p>
                                  )}
                                </Div>
                              </Div>
                            </Div>

                            <Div className="new_app_date">
                              <Div className="access_icon">
                                <AccessTimeIcon className="people" />
                              </Div>
                              <form
                                className={`${classes.container} frm-apoint`}
                                noValidate
                              >
                                <div
                                  id="crt_appt-time-ok"
                                  className="date-pick date-pick-parent app-datepick"
                                >
                                  <DatePicker
                                    getPopupContainer={(triggerNode) =>
                                      triggerNode.parentNode
                                    }
                                    style={{ width: "100px" }}
                                    onChange={(date) => {
                                      if (date) {
                                        setaptdate(
                                          moment(date).format(dtFormat),
                                        );
                                      } else {
                                        setaptdate(moment().format(dtFormat));
                                      }
                                    }}
                                    placeholder="Select date"
                                    format={dtFormat}
                                    value={
                                      aptdate ? moment(aptdate, dtFormat) : null
                                    }
                                    allowClear={false}
                                    disabledDate={(current) => {
                                      const oneYearFromNow = moment()
                                        .add(1, "year")
                                        .startOf("day");
                                      if (
                                        repvalue === "Week" ||
                                        repvalue === "Daily"
                                      ) {
                                        const untildateblock = moment(
                                          lastdateApp,
                                          dtFormat,
                                        ).startOf("day");
                                        return (
                                          current.isAfter(
                                            oneYearFromNow,
                                            "day",
                                          ) ||
                                          current.isAfter(
                                            untildateblock,
                                            "day",
                                          ) ||
                                          (Appttype == 2 &&
                                            current < moment().startOf("day"))
                                        );
                                      } else {
                                        return (
                                          current.isAfter(
                                            oneYearFromNow,
                                            "day",
                                          ) ||
                                          (Appttype == 2 &&
                                            current < moment().startOf("day"))
                                        );
                                      }
                                    }}
                                  />

                                  <div className="App-time ">
                                    <div className="showTime">
                                      <input
                                        className="fromTime-toTime-start"
                                        onClick={() => {
                                          handleFromTime();
                                        }}
                                        onMouseLeave={() => {
                                          setTempOpen(false);
                                        }}
                                        value={inTime}
                                        style={
                                          timeMismatch || inTimeErr
                                            ? {
                                                border: "1px solid red",
                                              }
                                            : {}
                                        }
                                        onChange={(e) => {
                                          if (
                                            !regexFirstNum.test(e.target.value)
                                          ) {
                                            setTimeMismatch(false);
                                            setFromShow(false);
                                            setToShow(false);
                                            setInTime(e.target.value);
                                            setTimeout(() => {
                                              setInTime(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                              );

                                              onChange(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                                "inTime",
                                              );
                                            }, 4000);
                                          }
                                        }}
                                        onBlur={(e) => {
                                          setTimeMismatch(false);
                                          setInTime(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                          );
                                          onChange(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                            "inTime",
                                          );
                                        }}
                                      />
                                      <p className="time--space">-</p>
                                      <input
                                        className="fromTime-toTime"
                                        onClick={() => {
                                          handleToTime();
                                        }}
                                        style={
                                          inTimeErr || timeMismatch
                                            ? {
                                                border: "1px solid red",
                                              }
                                            : {}
                                        }
                                        onChange={(e) => {
                                          if (
                                            !regexFirstNum.test(e.target.value)
                                          ) {
                                            setTimeMismatch(false);
                                            setFromShow(false);
                                            setToShow(false);
                                            setOutTime(e.target.value);
                                            setTimeout(() => {
                                              setOutTime(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                              );

                                              onChange(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                                "outTime",
                                              );
                                            }, 4000);
                                          }
                                        }}
                                        onMouseLeave={() => {
                                          setTempOpen(false);
                                        }}
                                        onBlur={(e) => {
                                          setTimeMismatch(false);
                                          setOutTime(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                          );
                                          onChange(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                            "outTime",
                                          );
                                        }}
                                        value={outTime}
                                      />
                                    </div>

                                    {/* From Button */}
                                    <div
                                      className={
                                        fromShow
                                          ? "fromArray-toArray"
                                          : "fromArray_hide"
                                      }
                                    >
                                      {frtimeSlots.map((item, index) => {
                                        return (
                                          <button
                                            key={item.id}
                                            value={
                                              item.time + " " + item.meridiem
                                            }
                                            disabled={disabledFromTimes(
                                              item.time,
                                              item.meridiem,
                                              Appttype,
                                            )}
                                            onClick={async (e) => {
                                              setTimeMismatch(false);
                                              setInTime(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                              );
                                              await setFromId(item.id);
                                              handleFromButton(e);
                                              onChange(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                                "inTime",
                                              );
                                            }}
                                          >
                                            {item.time + " " + item.meridiem}
                                          </button>
                                        );
                                      })}
                                    </div>
                                    {/* To button */}
                                    <div
                                      className={
                                        toShow
                                          ? "fromArray-toArray"
                                          : "toArray_hide"
                                      }
                                      style={{ left: 70 }}
                                    >
                                      {totimeSlots.map((item, index) => {
                                        return (
                                          <button
                                            disabled={disabledToTime(
                                              item.time,
                                              item.meridiem,
                                              item.id,
                                              Appttype,
                                            )}
                                            key={index}
                                            value={
                                              item.time + " " + item.meridiem
                                            }
                                            onClick={async (e) => {
                                              setTimeMismatch(false);

                                              setOutTime(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                              );

                                              handleToButton(e);
                                              onChange(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                                "outTime",
                                              );
                                            }}
                                          >
                                            {item.time + " " + item.meridiem}
                                          </button>
                                        );
                                      })}
                                    </div>
                                  </div>
                                  {/* nisha end */}
                                </div>
                              </form>
                            </Div>
                            {(inTimeErr || timeMismatch) && (
                              <Form.Text
                                id="new-app-time-codetext appt-warn-time"
                                className="colour-red err-m-t p-l-40 m-b-6"
                              >
                                Please Select valid Time
                              </Form.Text>
                            )}
                            {timelimiterrorbox && (
                              <Form.Text
                                id="new-app-time-codetext appt-warn-time"
                                className="colour-red p-l-66 m-t-0-imp m-b-3"
                              >
                                Provider Only Available Between {startErrTime}{" "}
                                to {endErrTime}
                              </Form.Text>
                            )}

                            {emptyEmailWarning && videochck && (
                              <Div>
                                <p
                                  className="errormessage"
                                  style={{
                                    marginBottom: "16px",
                                    marginLeft: "-45px",
                                  }}
                                >
                                  &nbsp;address to send the telehealth link.
                                </p>
                              </Div>
                            )}

                            <Div style={{ textAlign: "left" }}>
                              <Popup
                                content={fornormalapp}
                                open={normalappointment}
                                trigger={
                                  <Button
                                    id="click_event_app_normal"
                                    content="Button"
                                  />
                                }
                                position="left center"
                              />
                            </Div>
                            <Div>
                              <Popup
                                content={forteleapp}
                                open={teleappointment}
                                trigger={
                                  <Button
                                    id="click_event_app_tele"
                                    content="Button"
                                  />
                                }
                                position="left center"
                              />
                            </Div>

                            <Div className=" w-100">
                              <Div className="wholediv">
                                <Div margin="-20px 0px 0px -2px" size="20px">
                                  <Image
                                    src={doctorLogo}
                                    alt="speciality"
                                    height="20px"
                                    width="20px"
                                  />
                                </Div>

                                <Div className="dropdiv">
                                  <Select
                                    virtual={false}
                                    getPopupContainer={(triggerNode) =>
                                      triggerNode.parentNode
                                    }
                                    showSearch
                                    placeholder="Select Speciality"
                                    suffixIcon={<BsFillCaretDownFill />}
                                    className={
                                      specialError
                                        ? "err_mess_border w-100"
                                        : "w-100"
                                    }
                                    onChange={(data) => changeSpeciality(data)}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.title ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    value={speciality ? speciality : undefined}
                                    optionLabelProp="label"
                                    dropdownClassName="speciality-option"
                                    dropdownStyle={{
                                      maxHeight: "200px",
                                    }}
                                  >
                                    {sortSpeciality &&
                                      sortSpeciality
                                        .filter(
                                          (item) =>
                                            (storedNames.appt_a ||
                                              item.specialty ===
                                                notDisabledSpec) &&
                                            item.count > 0,
                                        ) // Filter disabled options
                                        .map((item) => (
                                          <Option
                                            key={item.specialty}
                                            value={item.specialty}
                                            title={item.specialty}
                                            disabled={
                                              (!storedNames.appt_a &&
                                                item.specialty !==
                                                  notDisabledSpec) ||
                                              item.count === 0
                                            }
                                            id={
                                              !storedNames.appt_a &&
                                              item.specialty !== notDisabledSpec
                                                ? "clr-disable"
                                                : "" || item.count == 0
                                                  ? "clr-disable"
                                                  : ""
                                            }
                                            className={
                                              (!storedNames.appt_a &&
                                                item.speciality !==
                                                  notDisabledSpec) ||
                                              item.count === 0
                                            }
                                          >
                                            {item.speciality}
                                          </Option>
                                        ))}
                                  </Select>
                                  {specialError && (
                                    <p className="errormessage">
                                      Select a speciality
                                    </p>
                                  )}
                                </Div>
                              </Div>
                            </Div>

                            <Div className=" w-100" id="border">
                              <Div className="wholediv">
                                <Div
                                  className={
                                    repvalue !== "" &&
                                    repvalue !== undefined &&
                                    repvalue !== null &&
                                    repvalue !== "Does not repeat" &&
                                    repvalue !== "Does not repeat "
                                      ? "status_div_Appt"
                                      : ""
                                  }
                                  margin="-20px 0px 0px -2px"
                                >
                                  <LocalHospitalOutlined />
                                </Div>
                                <Div
                                  className={
                                    videochck
                                      ? "dropdiv downDropDown"
                                      : "dropdiv"
                                  }
                                  id="statId"
                                >
                                  <Select
                                    getPopupContainer={(triggerNode) =>
                                      triggerNode.parentNode
                                    }
                                    dropdownStyle={{
                                      maxHeight: "200px",
                                    }}
                                    virtual={false}
                                    disabled={
                                      repvalue !== "" &&
                                      repvalue !== undefined &&
                                      repvalue !== null &&
                                      repvalue !== "Does not repeat" &&
                                      repvalue !== "Does not repeat "
                                    }
                                    showSearch
                                    placeholder="Status"
                                    id="new-app-status_1 appt-inp-stas"
                                    suffixIcon={<BsFillCaretDownFill />}
                                    className={
                                      statusError
                                        ? "err_mess_border w-100"
                                        : "w-100"
                                    }
                                    onChange={(e, data) =>
                                      handleDropDownSelectStatus(e, data)
                                    }
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.title ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    value={statusid ? statusid : undefined}
                                    // getPopupContainer={() =>
                                    //   document.getElementById("statId")
                                    // }

                                    dropdownAlign={{
                                      points: ["tl", "bl"],
                                      offset: [0, 4],
                                    }}
                                    // dropdownStyle={{
                                    //   zIndex: 1050,
                                    // }}
                                  >
                                    {checking1 ? (
                                      <></>
                                    ) : (
                                      <>
                                        {videochck ? (
                                          <>
                                            {sourcestatustele.map((i) => (
                                              <Option
                                                key={i.value}
                                                value={i.value}
                                                title={i.text}
                                              >
                                                {i.text}
                                              </Option>
                                            ))}
                                          </>
                                        ) : (
                                          <>
                                            {sourcestatus.map((i) => (
                                              <Option
                                                key={i.value}
                                                value={i.value}
                                                title={i.text}
                                              >
                                                {i.text}
                                              </Option>
                                            ))}
                                          </>
                                        )}
                                      </>
                                    )}
                                  </Select>
                                  {statusError && (
                                    <p className="errormessage">
                                      Please select Status
                                    </p>
                                  )}
                                  {repvalue !== "" &&
                                    repvalue !== undefined &&
                                    repvalue !== null &&
                                    repvalue !== "Does not repeat" &&
                                    repvalue !== "Does not repeat " && (
                                      <p className="errormessage appt_status_err_msg">
                                        Can't edit status while Daily/Weekly
                                        recurring. Select Does not Repeat
                                      </p>
                                    )}
                                </Div>
                              </Div>
                            </Div>

                            <Div className=" w-100">
                              <Div className="wholediv "></Div>

                              <Div className="wholediv">
                                <Div margin="-20px 0px 0px -2px">
                                  <HomeOutlinedIcon />
                                </Div>
                                <Div className="dropdiv" id="ExaId">
                                  <Select
                                    virtual={false}
                                    getPopupContainer={(triggerNode) =>
                                      triggerNode.parentNode
                                    }
                                    showSearch
                                    placeholder="Exam Room"
                                    id="new-app-profile_1"
                                    suffixIcon={<BsFillCaretDownFill />}
                                    className={
                                      examroomError
                                        ? "err_mess_border w-100"
                                        : "w-100"
                                    }
                                    onChange={(e, data) =>
                                      handleRoomVal(data.value)
                                    }
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.title ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    value={roomval ? roomval : undefined}
                                    dropdownStyle={{
                                      maxHeight: "200px",
                                    }}
                                    dropdownAlign={{
                                      points: ["tl", "bl"],
                                      offset: [0, 4],
                                    }}
                                    // dropdownStyle={{
                                    //   zIndex: 1050,
                                    // }}
                                  >
                                    {sourceroom.map((i) => (
                                      <Option
                                        key={i.value}
                                        value={i.value}
                                        title={i.text}
                                      >
                                        {i.text}
                                      </Option>
                                    ))}
                                  </Select>
                                  {examroomError && (
                                    <p className="errormessage">
                                      Please select Exam Room
                                    </p>
                                  )}
                                </Div>
                              </Div>
                            </Div>
                          </div>
                        </div>
                        <Div display="flex" padding="0px 0px 10px 45px">
                          <p className="remove-bor-mar">Reason</p>

                          {ENABLE_REASON_DROPDOWN ? (
                            <Select
                              value={reason || undefined}
                              onChange={(value) => setReason(value)}
                              style={{
                                width: "528px",
                                minWidth: "528px",
                                maxWidth: "528px",
                              }}
                              placeholder="Select Reason"
                              suffixIcon={
                                <BsFillCaretDownFill
                                  size={12}
                                  color="#808080"
                                />
                              }
                              getPopupContainer={(triggerNode) =>
                                triggerNode.parentNode
                              }
                            >
                              {reasonOptions.map((item) => (
                                <Option key={item} value={item}>
                                  {item}
                                </Option>
                              ))}
                            </Select>
                          ) : (
                            <InputSchedule
                              maxLength={200}
                              width="528px"
                              value={reason}
                              onChange={(e) => setReason(e.target.value)}
                            />
                          )}
                          {!ENABLE_REASON_DROPDOWN && (
                            <p
                              className="remove-bor-mar-reason"
                              style={{
                                color:
                                  reason && reason.length >= 200
                                    ? "red"
                                    : "inherit",
                              }}
                            >
                              Maximum of 200 characters
                            </p>
                          )}
                        </Div>
                      </Form.Row>
                    </Div>
                  </TabPane>

                  <TabPane
                    tab="New Group Appointment"
                    key="3"
                    className="appt-dash-hed p_l_10"
                  >
                    <Div className="c-pop-one " margin="20px 0px 0px -20px">
                      <Form.Row className="app-block  antd-select-height1">
                        {accountType > "0" || (accountType === "0" && trial) ? (
                          <>
                            {patFlag.map((item, ind) => (
                              <Div
                                key={ind}
                                className="new_appt_flag pt-fg-app-new"
                                style={{ backgroundColor: item.flag_color }}
                              >
                                {/* <IoFlagOutline className="new_appt_flag_icon" />
                                <span className="new_appt_flag_amt">
                                  {`${item.flag_name} : ${item.description}`} */}
                                <div
                                  className="app_pro_text_wrap new_app_flag"
                                  title={item.flag_name}
                                >
                                  {" "}
                                  <IoFlagOutline
                                    className="new_appt_flag_icon"
                                    style={{ marginRight: "5px" }}
                                  />
                                  {item.flag_name}
                                </div>
                                {/* </span> */}
                              </Div>
                            ))}
                          </>
                        ) : (
                          ""
                        )}
                        <div className="d_flex">
                          <div className="m_l_10">
                            <Div
                              alignItems="center"
                              className="search-pat  wholediv patient_name_out patient_name_filter"
                            >
                              <Div margin="-20px 0px 0px -2px">
                                <PeopleOutline className="people" />
                              </Div>
                              <Div className="dropdiv" id="GroupPatient">
                                <Select
                                  className={
                                    groupPatError
                                      ? "err_mess_border w-100 b1"
                                      : "w-100"
                                  }
                                  placeholder="Group Name"
                                  suffixIcon={<BsFillCaretDownFill />}
                                  showSearch
                                  filterOption={false} // IMPORTANT
                                  loading={loading}
                                  value={groupId}
                                  onSearch={handleGroupSearch}
                                  onChange={(value) => {
                                    setGroupPatError(false);
                                    setGroupId(value);
                                  }}
                                  notFoundContent={
                                    loading ? "Loading..." : "No Group Found"
                                  }
                                  dropdownRender={(menu) => (
                                    <>
                                      {menu}
                                      <div
                                        style={{
                                          borderTop: "1px solid #eaeaea",
                                          padding: "8px 12px",
                                          cursor: "pointer",
                                          color: "#1677ff",
                                          fontWeight: 500,
                                        }}
                                        onMouseDown={(e) => e.preventDefault()}
                                        onClick={() => handleOpenGroupModal()}
                                      >
                                        + Add Patient Group
                                      </div>
                                    </>
                                  )}
                                >
                                  {groupPatients.map((group) => (
                                    <Select.Option
                                      key={group.value}
                                      value={group.value}
                                    >
                                      {group.label}
                                    </Select.Option>
                                  ))}
                                </Select>
                                {groupPatError && (
                                  <p className="errormessage">
                                    Please Select Group
                                  </p>
                                )}
                              </Div>
                            </Div>

                            <Div
                              alignItems="center"
                              className="appointment_poup_div appointment_poup_div_w"
                            >
                              <Div
                                id="new_appt_radio"
                                className="appt-spn-vdovis new_app_radio_group"
                              >
                                <Radio.Group
                                  onChange={
                                    accountType === "-1" ||
                                    (accountType === "1" && teleFlag === "0")
                                      ? (e) => {
                                          if (Number(e.target.value) === 2) {
                                            setUpgrade(true);
                                          } else {
                                            onChangeRadio(e);
                                          }
                                        }
                                      : onChangeRadio
                                  }
                                  value={
                                    walkincheck
                                      ? 3
                                      : forteleornor === 2
                                        ? forteleornor
                                        : Appttype
                                  }
                                >
                                  <Radio
                                    className="radio_appt_btn"
                                    value={1}
                                    onChange={checkapt}
                                    disabled={
                                      allowAppt !== 3 &&
                                      (allowAppt === 2 || videochck)
                                    }
                                  >
                                    Appointment
                                  </Radio>

                                  <Radio
                                    value={2}
                                    onChange={checkvideovisit}
                                    disabled={
                                      allowAppt !== 3 &&
                                      (allowAppt === 1 || !videochck)
                                    }
                                  >
                                    Telehealth
                                  </Radio>

                                  {/* <Radio
                                    className="app-dashboard-radioBut m-0"
                                    onClick={walkinclick}
                                    value={3}
                                    // disabled={videochck}
                                    id="new-app-walkin"
                                    disabled={
                                      allowAppt !== 3 &&
                                      (allowAppt === 2 || videochck)
                                    }
                                  >
                                    Walk-in
                                  </Radio> */}
                                  <Radio
                                    className="app-dashboard-radioBut m-0"
                                    onClick={walkinclick}
                                    value={3}
                                    disabled={videochck}
                                    id="new-app-walkin"
                                  >
                                    Walk-in
                                  </Radio>
                                </Radio.Group>
                              </Div>
                            </Div>

                            <Div margin="13px 0 0 0">
                              <Div
                                alignItems="center"
                                className=" alx wholediv new_app_facility"
                              >
                                <Div margin="-20px 0px 0px -2px">
                                  <RoomOutlined />
                                </Div>
                                <Div className="dropdiv" id="officeId">
                                  <Select
                                    virtual={false}
                                    showSearch
                                    placeholder="Hospital Name"
                                    id="new-app-facility_1"
                                    suffixIcon={<BsFillCaretDownFill />}
                                    className={
                                      officeError
                                        ? `err_mess_border w-100 to-hide-ant-label ${checkFacility(
                                            "classname",
                                          )}`
                                        : `to-hide-ant-label w-100 ${checkFacility(
                                            "classname",
                                          )}`
                                    }
                                    onChange={(e, data) =>
                                      handleDropDownSelectOffice(e, data)
                                    }
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.title ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    value={officeid ? officeid : undefined}
                                    getPopupContainer={(triggerNode) =>
                                      triggerNode.parentNode
                                    }
                                    dropdownStyle={{
                                      maxHeight: "200px",
                                    }}
                                  >
                                    {sourceoffice.map((i) => (
                                      <Option
                                        key={i.value}
                                        value={i.value}
                                        title={i.text}
                                      >
                                        {i.text}
                                      </Option>
                                    ))}
                                  </Select>
                                  {checkFacility("spinner")}
                                  {officeError && (
                                    <p className="errormessage">
                                      Please select Office
                                    </p>
                                  )}
                                </Div>
                              </Div>
                            </Div>

                            <Div
                              alignItems="center"
                              className="search-pat new_app_select_prov appointment_patient_div"
                            >
                              <Div margin="-2px 0px 0px -2px">
                                <PeopleOutline />
                              </Div>
                              <Div className="appointment_drop_div" id="provId">
                                <Select
                                  // virtual={false}
                                  showSearch
                                  placeholder="Doctor Name"
                                  suffixIcon={<BsFillCaretDownFill />}
                                  id="new-app-provider new-app-provider_1"
                                  className={
                                    provError
                                      ? "err_mess_border w-100 "
                                      : "w-100"
                                  }
                                  onChange={(e, data) => {
                                    if (storedNames.appt_a1_viewOnly) {
                                      alert("You only have view-only access.");
                                    } else {
                                      handleDropDownSelectProvider(e, data);
                                    }
                                  }}
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    (option?.title ?? "")
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  value={providerid ? providerid : undefined}
                                  // getPopupContainer={() =>
                                  //   document.getElementById("provId")
                                  // }
                                >
                                  {sourceprovider.map((i) => (
                                    <Option
                                      key={i.value}
                                      value={i.value}
                                      title={i.text}
                                      disabled={storedNames.appt_a1_viewOnly}
                                    >
                                      {i.text}
                                    </Option>
                                  ))}
                                </Select>
                                {provError && (
                                  <p className="errormessage">
                                    Please select Provider
                                  </p>
                                )}
                              </Div>
                            </Div>
                          </div>

                          <div>
                            <Div className=" w-100 m_b_12">
                              <Div
                                className="wholediv"
                                // className="alx p-r-20"
                              >
                                <Div margin="-20px 0px 0px -2px">
                                  <PersonOutline />
                                </Div>
                                <Div className="dropdiv" id="ProfId">
                                  <Select
                                    virtual={false}
                                    className={
                                      profileError
                                        ? "err_mess_border w-100"
                                        : "w-100"
                                    }
                                    showSearch
                                    placeholder="Appt Profile"
                                    id="new-app-profile_1 appt-inp-profsrch"
                                    suffixIcon={<BsFillCaretDownFill />}
                                    onChange={(e, data) =>
                                      handleDropDownSelect(e, data)
                                    }
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.title ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    value={profileid ? profileid : undefined}
                                    getPopupContainer={(triggerNode) =>
                                      triggerNode.parentNode
                                    }
                                    dropdownStyle={{
                                      maxHeight: "200px",
                                    }}
                                    dropdownAlign={{
                                      points: ["tl", "bl"],
                                      offset: [0, 4],
                                    }}
                                    // dropdownStyle={{
                                    //   zIndex: 1050,
                                    // }}
                                  >
                                    {sourceprofile.map((i) => (
                                      <Option
                                        key={i.value}
                                        value={i.value}
                                        title={i.text}
                                      >
                                        {i.text}
                                      </Option>
                                    ))}
                                  </Select>

                                  {profileError && (
                                    <p className="errormessage">
                                      Please select Appointment Profile
                                    </p>
                                  )}
                                </Div>
                              </Div>
                            </Div>

                            <Div className="new_app_date">
                              <Div className="access_icon">
                                <AccessTimeIcon className="people" />
                              </Div>
                              <form
                                className={`${classes.container} frm-apoint`}
                                noValidate
                              >
                                <div
                                  id="crt_appt-time-ok"
                                  className="date-pick date-pick-parent app-datepick"
                                >
                                  <DatePicker
                                    getPopupContainer={(triggerNode) =>
                                      triggerNode.parentNode
                                    }
                                    style={{ width: "100px" }}
                                    onChange={(date) => {
                                      if (date) {
                                        setaptdate(
                                          moment(date).format(dtFormat),
                                        );
                                      } else {
                                        setaptdate(moment().format(dtFormat));
                                      }
                                    }}
                                    placeholder="Select date"
                                    format={dtFormat}
                                    value={
                                      aptdate ? moment(aptdate, dtFormat) : null
                                    }
                                    allowClear={false}
                                    disabledDate={(current) => {
                                      const oneYearFromNow = moment()
                                        .add(1, "year")
                                        .startOf("day");
                                      if (
                                        repvalue === "Week" ||
                                        repvalue === "Daily"
                                      ) {
                                        const untildateblock = moment(
                                          lastdateApp,
                                          dtFormat,
                                        ).startOf("day");
                                        return (
                                          current.isAfter(
                                            oneYearFromNow,
                                            "day",
                                          ) ||
                                          current.isAfter(
                                            untildateblock,
                                            "day",
                                          ) ||
                                          (Appttype == 2 &&
                                            current < moment().startOf("day"))
                                        );
                                      } else {
                                        return (
                                          current.isAfter(
                                            oneYearFromNow,
                                            "day",
                                          ) ||
                                          (Appttype == 2 &&
                                            current < moment().startOf("day"))
                                        );
                                      }
                                    }}
                                  />

                                  <div className="App-time ">
                                    <div className="showTime">
                                      <input
                                        className="fromTime-toTime-start"
                                        onClick={() => {
                                          handleFromTime();
                                        }}
                                        onMouseLeave={() => {
                                          setTempOpen(false);
                                        }}
                                        value={inTime}
                                        style={
                                          timeMismatch || inTimeErr
                                            ? {
                                                border: "1px solid red",
                                              }
                                            : {}
                                        }
                                        onChange={(e) => {
                                          if (
                                            !regexFirstNum.test(e.target.value)
                                          ) {
                                            setTimeMismatch(false);
                                            setFromShow(false);
                                            setToShow(false);
                                            setInTime(e.target.value);
                                            setTimeout(() => {
                                              setInTime(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                              );

                                              onChange(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                                "inTime",
                                              );
                                            }, 4000);
                                          }
                                        }}
                                        onBlur={(e) => {
                                          setTimeMismatch(false);
                                          setInTime(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                          );
                                          onChange(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                            "inTime",
                                          );
                                        }}
                                      />
                                      <p className="time--space">-</p>
                                      <input
                                        className="fromTime-toTime"
                                        onClick={() => {
                                          handleToTime();
                                        }}
                                        style={
                                          inTimeErr || timeMismatch
                                            ? {
                                                border: "1px solid red",
                                              }
                                            : {}
                                        }
                                        onChange={(e) => {
                                          if (
                                            !regexFirstNum.test(e.target.value)
                                          ) {
                                            setTimeMismatch(false);
                                            setFromShow(false);
                                            setToShow(false);
                                            setOutTime(e.target.value);
                                            setTimeout(() => {
                                              setOutTime(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                              );

                                              onChange(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                                "outTime",
                                              );
                                            }, 4000);
                                          }
                                        }}
                                        onMouseLeave={() => {
                                          setTempOpen(false);
                                        }}
                                        onBlur={(e) => {
                                          setTimeMismatch(false);
                                          setOutTime(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                          );
                                          onChange(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                            "outTime",
                                          );
                                        }}
                                        value={outTime}
                                      />
                                    </div>

                                    {/* From Button */}
                                    <div
                                      className={
                                        fromShow
                                          ? "fromArray-toArray"
                                          : "fromArray_hide"
                                      }
                                    >
                                      {frtimeSlots.map((item, index) => {
                                        return (
                                          <button
                                            key={item.id}
                                            value={
                                              item.time + " " + item.meridiem
                                            }
                                            disabled={disabledFromTimes(
                                              item.time,
                                              item.meridiem,
                                              Appttype,
                                            )}
                                            onClick={async (e) => {
                                              setTimeMismatch(false);
                                              setInTime(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                              );
                                              await setFromId(item.id);
                                              handleFromButton(e);
                                              onChange(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                                "inTime",
                                              );
                                            }}
                                          >
                                            {item.time + " " + item.meridiem}
                                          </button>
                                        );
                                      })}
                                    </div>
                                    {/* To button */}
                                    <div
                                      className={
                                        toShow
                                          ? "fromArray-toArray"
                                          : "toArray_hide"
                                      }
                                      style={{ left: 70 }}
                                    >
                                      {totimeSlots.map((item, index) => {
                                        return (
                                          <button
                                            disabled={disabledToTime(
                                              item.time,
                                              item.meridiem,
                                              item.id,
                                              Appttype,
                                            )}
                                            key={index}
                                            value={
                                              item.time + " " + item.meridiem
                                            }
                                            onClick={async (e) => {
                                              setTimeMismatch(false);

                                              setOutTime(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                              );

                                              handleToButton(e);
                                              onChange(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                                "outTime",
                                              );
                                            }}
                                          >
                                            {item.time + " " + item.meridiem}
                                          </button>
                                        );
                                      })}
                                    </div>
                                  </div>
                                  {/* nisha end */}
                                </div>
                              </form>
                            </Div>
                            {(inTimeErr || timeMismatch) && (
                              <Form.Text
                                id="new-app-time-codetext appt-warn-time"
                                className="colour-red err-m-t p-l-40 m-b-6"
                              >
                                Please Select valid Time
                              </Form.Text>
                            )}
                            {timelimiterrorbox && (
                              <Form.Text
                                id="new-app-time-codetext appt-warn-time"
                                className="colour-red p-l-66 m-t-0-imp m-b-3"
                              >
                                Provider Only Available Between {startErrTime}{" "}
                                to {endErrTime}
                              </Form.Text>
                            )}

                            <Div style={{ textAlign: "left" }}>
                              <Popup
                                content={fornormalapp}
                                open={normalappointment}
                                trigger={
                                  <Button
                                    id="click_event_app_normal"
                                    content="Button"
                                  />
                                }
                                position="left center"
                              />
                            </Div>
                            <Div>
                              <Popup
                                content={forteleapp}
                                open={teleappointment}
                                trigger={
                                  <Button
                                    id="click_event_app_tele"
                                    content="Button"
                                  />
                                }
                                position="left center"
                              />
                            </Div>

                            <Div className=" w-100">
                              <Div className="wholediv">
                                <Div margin="-20px 0px 0px -2px" size="20px">
                                  <Image
                                    src={doctorLogo}
                                    alt="speciality"
                                    height="20px"
                                    width="20px"
                                  />
                                </Div>

                                <Div className="dropdiv">
                                  <Select
                                    virtual={false}
                                    getPopupContainer={(triggerNode) =>
                                      triggerNode.parentNode
                                    }
                                    showSearch
                                    placeholder="Select Speciality"
                                    suffixIcon={<BsFillCaretDownFill />}
                                    className={
                                      specialError
                                        ? "err_mess_border w-100"
                                        : "w-100"
                                    }
                                    onChange={(data) => changeSpeciality(data)}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.title ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    value={speciality ? speciality : undefined}
                                    optionLabelProp="label"
                                    dropdownClassName="speciality-option"
                                    dropdownStyle={{
                                      maxHeight: "200px",
                                    }}
                                  >
                                    {sortSpeciality &&
                                      sortSpeciality
                                        .filter(
                                          (item) =>
                                            (storedNames.appt_a ||
                                              item.specialty ===
                                                notDisabledSpec) &&
                                            item.count > 0,
                                        ) // Filter disabled options
                                        .map((item) => (
                                          <Option
                                            key={item.specialty}
                                            value={item.specialty}
                                            title={item.specialty}
                                            disabled={
                                              (!storedNames.appt_a &&
                                                item.specialty !==
                                                  notDisabledSpec) ||
                                              item.count === 0
                                            }
                                            id={
                                              !storedNames.appt_a &&
                                              item.specialty !== notDisabledSpec
                                                ? "clr-disable"
                                                : "" || item.count == 0
                                                  ? "clr-disable"
                                                  : ""
                                            }
                                            className={
                                              (!storedNames.appt_a &&
                                                item.speciality !==
                                                  notDisabledSpec) ||
                                              item.count === 0
                                            }
                                          >
                                            {item.speciality}
                                          </Option>
                                        ))}
                                  </Select>
                                  {specialError && (
                                    <p className="errormessage">
                                      Select a speciality
                                    </p>
                                  )}
                                </Div>
                              </Div>
                            </Div>

                            <Div className=" w-100">
                              <Div className="wholediv "></Div>

                              <Div className="wholediv">
                                <Div margin="-20px 0px 0px -2px">
                                  <HomeOutlinedIcon />
                                </Div>
                                <Div className="dropdiv" id="ExaId">
                                  <Select
                                    virtual={false}
                                    getPopupContainer={(triggerNode) =>
                                      triggerNode.parentNode
                                    }
                                    showSearch
                                    placeholder="Exam Room"
                                    id="new-app-profile_1"
                                    suffixIcon={<BsFillCaretDownFill />}
                                    className={
                                      examroomError
                                        ? "err_mess_border w-100"
                                        : "w-100"
                                    }
                                    onChange={(e, data) =>
                                      handleRoomVal(data.value)
                                    }
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.title ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    value={roomval ? roomval : undefined}
                                    dropdownStyle={{
                                      maxHeight: "200px",
                                    }}
                                    dropdownAlign={{
                                      points: ["tl", "bl"],
                                      offset: [0, 4],
                                    }}
                                    // dropdownStyle={{
                                    //   zIndex: 1050,
                                    // }}
                                  >
                                    {sourceroom.map((i) => (
                                      <Option
                                        key={i.value}
                                        value={i.value}
                                        title={i.text}
                                      >
                                        {i.text}
                                      </Option>
                                    ))}
                                  </Select>
                                  {examroomError && (
                                    <p className="errormessage">
                                      Please select Exam Room
                                    </p>
                                  )}
                                </Div>
                              </Div>
                            </Div>
                          </div>
                        </div>
                        <Div display="flex" padding="0px 0px 10px 45px">
                          <p className="remove-bor-mar">Reason</p>
                          {ENABLE_REASON_DROPDOWN ? (
                            <Select
                              value={reason || undefined}
                              onChange={(value) => setReason(value)}
                              style={{
                                width: "528px",
                                minWidth: "528px",
                                maxWidth: "528px",
                              }}
                              placeholder="Select Reason"
                              suffixIcon={
                                <BsFillCaretDownFill
                                  size={12}
                                  color="#808080"
                                />
                              }
                              getPopupContainer={(triggerNode) =>
                                triggerNode.parentNode
                              }
                            >
                              {reasonOptions.map((item) => (
                                <Option key={item} value={item}>
                                  {item}
                                </Option>
                              ))}
                            </Select>
                          ) : (
                            <InputSchedule
                              maxLength={200}
                              width="528px"
                              value={reason}
                              onChange={(e) => setReason(e.target.value)}
                            />
                          )}
                          {!ENABLE_REASON_DROPDOWN && (
                            <p
                              className="remove-bor-mar-reason"
                              style={{
                                color:
                                  reason && reason.length >= 200
                                    ? "red"
                                    : "inherit",
                              }}
                            >
                              Maximum of 200 characters
                            </p>
                          )}
                        </Div>
                      </Form.Row>
                    </Div>
                  </TabPane>

                  <TabPane
                    tab="Add Availability"
                    key="2"
                    className="appt-dash-hed"
                  >
                    <Div padding="10px 0px" className="avl">
                      <Div>
                        <p>
                          By default, provider availability is set to "In
                          Office," allowing appointments to be scheduled anytime
                          based on calendar hours. To mark unavailable times,
                          enable provider availability and click "Add Provider
                          Availability" to input those periods.
                        </p>
                      </Div>
                      <Div>
                        <div className="Provider_availability_switch_box m_10">
                          <span className="enable_pro_avail">
                            Enable Provider Availability
                          </span>

                          <Switch
                            size="small"
                            className="switch-align-pro"
                            onChange={(checked) => {
                              if (
                                !storedNames.setProviderAvailability_viewOnly
                              ) {
                                enableSwitch(checked);
                              } else {
                                alert("You only have view-only access.");
                              }
                            }}
                            checked={switchvalue}
                            id="setting_email_switch"
                          />
                        </div>
                      </Div>
                      {switchvalue && (
                        <Div margin="10px 0px 5px 0px">
                          <AddAppTemplate
                            newsetBtnDis={setBtnDis}
                            curDate={aptdate}
                            closepopup={handleRefresh}
                            clientShow={() => AddTemplate()}
                            dataFetch={handleRefresh}
                            providerList={sourceprovider}
                            id={
                              props.start?.Id !== "" && props.ApptTab === "2"
                                ? props.start?.Id
                                : id
                            }
                            setEid={() => setEid("")}
                            row={singleRow}
                            from={"new_appointment"}
                            where={props.where}
                          />
                        </Div>
                      )}
                    </Div>
                  </TabPane>
                </Tabs>
              ) : (
                <Div
                  className="c-pop-one "
                  margin={
                    props.type !== "book again"
                      ? "20px 0px 0px -20px"
                      : "20px 0px 0px 0px"
                  }
                >
                  <Form.Row className="app-block  antd-select-height1">
                    {accountType > "0" || (accountType === "0" && trial) ? (
                      <>
                        {patFlag.map((item, ind) => (
                          <Div
                            key={ind}
                            className="new_appt_flag pt-fg-app-new"
                            style={{ backgroundColor: item.flag_color }}
                          >
                            <IoFlagOutline className="new_appt_flag_icon" />
                            <span className="new_appt_flag_amt">{`${item.flag_name} : ${item.description}`}</span>
                          </Div>
                        ))}
                      </>
                    ) : (
                      ""
                    )}
                    <div className="d_flex">
                      <div className="m_l_10">
                        <Div
                          alignItems="center"
                          className="search-pat  wholediv patient_name_out"
                        >
                          <Div margin="-20px 0px 0px -2px">
                            <PeopleOutline className="people" />
                          </Div>
                          <Div className="dropdiv " id="PatId">
                            <Select
                              virtual={false}
                              getPopupContainer={(triggerNode) =>
                                triggerNode.parentNode
                              }
                              showSearch
                              allowClear
                              placeholder="Patient Name"
                              id="new-app-patient_1 appt-inp-patsrch "
                              suffixIcon={<BsFillCaretDownFill />}
                              className={
                                patError ? "err_mess_border w-100 b1" : "w-100"
                              }
                              // value={
                              //   patientid || searchInput
                              //     ? search1
                              //     : undefined
                              // } // control value
                              value={
                                searchInputValue || patientid
                                  ? searchInputValue
                                  : undefined
                              }
                              searchValue={searchInput}
                              onSearch={(value) => {
                                setSearchInput(value);
                                setpatsrchvalue(value);
                                setFetchingOptions(true);
                              }}
                              onSelect={(value, option) => {
                                handleDropDownSelectPatient(value, option);
                                setSearchInput(option.title);
                              }}
                              onChange={(value, option) => {
                                if (!value) {
                                  setSearchInput("");
                                  setSearchInputValue("");
                                  setpatientid(null);
                                  setpatsrchvalue("");
                                  return;
                                }

                                const selectedTitle = option?.title || "";

                                setSearchInputValue(selectedTitle);
                                setSearchInput(selectedTitle);
                                setpatientid(value);
                                handleDropDownSelectPatient(value, option);
                              }}
                              filterOption={false}
                              notFoundContent={
                                fetchingOptions ? "Loading..." : "No Data found"
                              }
                              dropdownAlign={{
                                points: ["tl", "bl"],
                                offset: [0, 4],
                              }}
                              dropdownStyle={{ zIndex: 1050 }}
                              dropdownRender={(menu) => (
                                <>
                                  {menu}
                                  <StyledDiv>
                                    <StyledButton
                                      disabled={
                                        storedNames.demo1_viewOnly ||
                                        storedNames.demo_v
                                      }
                                      onClick={() => {
                                        if (!storedNames.demo) {
                                          alert(
                                            "You don’t have access to add patients",
                                          );
                                        } else {
                                          setTemShow(false);
                                          setShow(true);
                                        }
                                      }}
                                      onMouseDown={(e) => e.preventDefault()}
                                    >
                                      <StyledSvg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 448 512"
                                      >
                                        <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" />
                                      </StyledSvg>
                                      <span
                                        onClick={() => {
                                          if (
                                            storedNames.demo1_viewOnly ||
                                            storedNames.demo_v
                                          ) {
                                            alert(
                                              "You only have view-only access.",
                                            );
                                          } else {
                                            handleAddPatient();
                                          }
                                        }}
                                      >
                                        Add Patient
                                      </span>
                                    </StyledButton>
                                  </StyledDiv>
                                  <StyledButton
                                    onClick={() => {
                                      history.push("/schedule/waitlist");
                                    }}
                                  >
                                    <Image
                                      height="16px"
                                      width="16px"
                                      src={waitListIcon}
                                      // className="spin-img center-loading-image"
                                    />{" "}
                                    Select From Waitlist
                                  </StyledButton>
                                </>
                              )}
                            >
                              {source.map((i) => {
                                const titleLength = i.text.length;

                                return (
                                  <Option
                                    key={i.value}
                                    value={i.value}
                                    title={i.text}
                                    phone_cell={i.phone_cell}
                                    dob={i.dob}
                                    ss={i.ss}
                                    email={i.email}
                                  >
                                    <div>
                                      {titleLength < 15 ? (
                                        <>
                                          {i.text} -{" "}
                                          {i.dob
                                            ? moment(i.dob).format(dtFormat)
                                            : " "}
                                        </>
                                      ) : (
                                        <>
                                          <div>{i.text} -</div>
                                          <div>
                                            {i.dob
                                              ? moment(i.dob).format(dtFormat)
                                              : " "}
                                          </div>
                                        </>
                                      )}
                                    </div>
                                    <div>{i.phone_cell}</div>
                                  </Option>
                                );
                              })}
                            </Select>

                            {patError && (
                              <p className="errormessage">
                                Please select Patient
                              </p>
                            )}
                          </Div>
                        </Div>

                        <Div
                          alignItems="center"
                          className="appointment_poup_div appointment_poup_div_w"
                        >
                          <Div
                            id="new_appt_radio"
                            className="appt-spn-vdovis new_app_radio_group"
                          >
                            <Radio.Group
                              onChange={
                                accountType === "-1" ||
                                (accountType === "1" && teleFlag === "0")
                                  ? (e) => {
                                      if (Number(e.target.value) === 2) {
                                        setUpgrade(true);
                                      } else {
                                        onChangeRadio(e);
                                      }
                                    }
                                  : onChangeRadio
                              }
                              value={
                                walkincheck
                                  ? 3
                                  : forteleornor === 2
                                    ? forteleornor
                                    : Appttype
                              }
                            >
                              <Radio
                                className="radio_appt_btn"
                                value={1}
                                onChange={checkapt}
                                disabled={
                                  allowAppt !== 3 &&
                                  (allowAppt === 2 || videochck)
                                }
                              >
                                Appointment
                              </Radio>

                              <Radio
                                value={2}
                                onChange={checkvideovisit}
                                disabled={
                                  allowAppt !== 3 &&
                                  (allowAppt === 1 || !videochck)
                                }
                              >
                                Telehealth
                              </Radio>

                              <Radio
                                className="app-dashboard-radioBut m-0"
                                onClick={walkinclick}
                                value={3}
                                disabled={videochck}
                                id="new-app-walkin"
                              >
                                Walk-in
                              </Radio>
                            </Radio.Group>
                          </Div>
                        </Div>

                        <Div margin="13px 0 0 0">
                          <Div
                            alignItems="center"
                            className=" alx wholediv new_app_facility"
                          >
                            <Div margin="-20px 0px 0px -2px">
                              <RoomOutlined />
                            </Div>
                            <Div className="dropdiv" id="officeId">
                              <Select
                                virtual={false}
                                showSearch
                                placeholder="Hospital Name"
                                id="new-app-facility_1"
                                suffixIcon={<BsFillCaretDownFill />}
                                className={
                                  officeError
                                    ? `err_mess_border w-100 to-hide-ant-label ${checkFacility(
                                        "classname",
                                      )}`
                                    : `to-hide-ant-label w-100 ${checkFacility(
                                        "classname",
                                      )}`
                                }
                                onChange={(e, data) =>
                                  handleDropDownSelectOffice(e, data)
                                }
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.title ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                value={officeid ? officeid : null}
                                getPopupContainer={() =>
                                  document.getElementById("officeId")
                                }
                              >
                                {sourceoffice.map((i) => (
                                  <Option
                                    key={i.value}
                                    value={i.value}
                                    title={i.text}
                                  >
                                    {i.text}
                                  </Option>
                                ))}
                              </Select>
                              {checkFacility("spinner")}
                              {officeError && (
                                <p className="errormessage">
                                  Please select Office
                                </p>
                              )}
                            </Div>
                          </Div>
                        </Div>

                        <Div
                          alignItems="center"
                          className="search-pat new_app_select_prov appointment_patient_div"
                        >
                          <Div margin="-2px 0px 0px -2px">
                            <PeopleOutline />
                          </Div>
                          <Div className="appointment_drop_div" id="provId">
                            <Select
                              // virtual={false}
                              showSearch
                              placeholder="Doctor Name"
                              suffixIcon={<BsFillCaretDownFill />}
                              id="new-app-provider new-app-provider_1"
                              className={
                                provError ? "err_mess_border w-100 " : "w-100"
                              }
                              onChange={(e, data) =>
                                handleDropDownSelectProvider(e, data)
                              }
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                (option?.title ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              value={providerid ? providerid : undefined}
                              // getPopupContainer={() =>
                              //   document.getElementById("provId")
                              // }
                            >
                              {sourceprovider.map((i) => (
                                <Option
                                  key={i.value}
                                  value={i.value}
                                  title={i.text}
                                >
                                  {i.text}
                                </Option>
                              ))}
                            </Select>
                            {provError && (
                              <p className="errormessage">
                                Please select Provider
                              </p>
                            )}
                          </Div>
                        </Div>

                        <Div
                          className="app_repeat_dropdown position-relative app_dummy_class"
                          margin=" 0px 0px 10px 40px"
                        >
                          <BsFillCaretDownFill className="down_arrow_doesnt does-not-repeat-icon" />

                          <DropdownButton
                            id="arrow-newAppt"
                            className="app-nav-dropdown-for-newApp-repect "
                            title={repvalue ? repvalue : "Does not repeat"}
                            // title=""
                            onSelect={handlerepSelect}
                            variant="light"
                          >
                            <Dropdownant.Item eventKey="Does not repeat">
                              Does not repeat
                            </Dropdownant.Item>
                            <Dropdownant.Item
                              onClick={handleShowuntildate}
                              eventKey="Daily"
                            >
                              Daily
                            </Dropdownant.Item>
                            <Dropdownant.Item
                              onClick={handleShowuntildate}
                              eventKey={"Week"}
                            >
                              Week
                            </Dropdownant.Item>
                          </DropdownButton>
                        </Div>

                        {repvalue === "Week" && (
                          <Div margin="5px 4px 14px 40px">
                            <ToggleButtonGroup
                              type="checkbox"
                              value={weekday}
                              className="appt_repeats but-act app_gap "
                              onChange={WeekdayChange}
                              style={
                                selectdayError
                                  ? {
                                      border: "1px solid red",
                                      borderRadius: "5px",
                                    }
                                  : {}
                              }
                            >
                              <ToggleButton
                                disabled={
                                  WeeklyDisable === "Show only weekdays" ||
                                  WeeklyDisable === "Don't show Sundays"
                                    ? true
                                    : false
                                }
                                className={
                                  WeeklyDisable === "Show only weekdays" ||
                                  (WeeklyDisable === "Don't show Sundays" &&
                                    "weekDisableBtn")
                                }
                                id="tbg-btn-1"
                                value={1}
                              >
                                S
                              </ToggleButton>
                              <ToggleButton id="tbg-btn-2" value={2}>
                                M
                              </ToggleButton>
                              <ToggleButton id="tbg-btn-3" value={3}>
                                T
                              </ToggleButton>
                              <ToggleButton id="tbg-btn-3" value={4}>
                                W
                              </ToggleButton>
                              <ToggleButton id="tbg-btn-3" value={5}>
                                T
                              </ToggleButton>
                              <ToggleButton id="tbg-btn-3" value={6}>
                                F
                              </ToggleButton>
                              <ToggleButton
                                disabled={
                                  WeeklyDisable === "Show only weekdays"
                                    ? true
                                    : false
                                }
                                id="tbg-btn-3"
                                value={7}
                              >
                                S
                              </ToggleButton>
                            </ToggleButtonGroup>

                            {selectdayError && (
                              <p className="errormessage">
                                Please select atleast a day
                              </p>
                            )}
                          </Div>
                        )}

                        {repvalue !== "" &&
                          repvalue !== undefined &&
                          repvalue !== null &&
                          repvalue !== "Does not repeat" &&
                          repvalue !== "Does not repeat " && (
                            <Div margin=" 0px 0px 10px 30px" dis="flex">
                              <Span
                                marginRight="3px"
                                color="#000000 !important"
                              >
                                Until:
                              </Span>
                              <Div position="relative">
                                <DatePicker
                                  getPopupContainer={(triggerNode) =>
                                    triggerNode.parentNode
                                  }
                                  disabledDate={(current) => {
                                    const oneYearFromNow = moment()
                                      .add(1, "year")
                                      .startOf("day");
                                    return (
                                      current.isBefore(
                                        moment(aptdate, dtFormat),
                                        "day",
                                      ) ||
                                      current.isAfter(oneYearFromNow, "day")
                                    );
                                  }}
                                  onChange={(date) => {
                                    if (date) {
                                      setLastdateApp(
                                        moment(date).format(dtFormat),
                                      );
                                    } else {
                                      setLastdateApp(moment().format(dtFormat));
                                    }
                                  }}
                                  placeholder="From-"
                                  format={dtFormat}
                                  value={
                                    lastdateApp
                                      ? moment(lastdateApp, dtFormat)
                                      : null
                                  }
                                  allowClear={false}
                                />
                              </Div>
                            </Div>
                          )}
                      </div>

                      <div>
                        <Div className=" w-100 m_b_12">
                          <Div className="wholediv">
                            <Div margin="-20px 0px 0px -2px">
                              <PersonOutline />
                            </Div>
                            <Div className="dropdiv" id="ProfId">
                              <Select
                                virtual={false}
                                getPopupContainer={(triggerNode) =>
                                  triggerNode.parentNode
                                }
                                className={
                                  profileError
                                    ? "err_mess_border w-100"
                                    : "w-100"
                                }
                                showSearch
                                placeholder="Appt Profile"
                                id="new-app-profile_1 appt-inp-profsrch"
                                suffixIcon={<BsFillCaretDownFill />}
                                onChange={(e, data) =>
                                  handleDropDownSelect(e, data)
                                }
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.title ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                value={profileid ? profileid : null}
                                dropdownAlign={{
                                  points: ["tl", "bl"],
                                  offset: [0, 4],
                                }}
                                dropdownStyle={{
                                  zIndex: 1050,
                                }}
                              >
                                {sourceprofile.map((i) => (
                                  <Option
                                    key={i.value}
                                    value={i.value}
                                    title={i.text}
                                  >
                                    {i.text}
                                  </Option>
                                ))}
                              </Select>

                              {profileError && (
                                <p className="errormessage">
                                  Please select Appointment Profile
                                </p>
                              )}
                            </Div>
                          </Div>
                        </Div>

                        <Div className="new_app_date_bookAgain">
                          <Div className="access_icon">
                            <AccessTimeIcon className="people" />
                          </Div>
                          <form
                            className={`${classes.container} frm-apoint`}
                            noValidate
                          >
                            <div
                              id="crt_appt-time-ok"
                              className="date-pick date-pick-parent app-datepick_bookAgain"
                            >
                              <DatePicker
                                getPopupContainer={(triggerNode) =>
                                  triggerNode.parentNode
                                }
                                style={{ width: "100px" }}
                                onChange={(date) => {
                                  if (date) {
                                    setDateErr(false);

                                    setaptdate(moment(date).format(dtFormat));
                                  } else {
                                    setaptdate(moment().format(dtFormat));
                                  }
                                }}
                                className={dateErr ? "err-bdr-date" : ""}
                                placeholder="Select date"
                                format={dtFormat}
                                value={
                                  aptdate ? moment(aptdate, dtFormat) : null
                                }
                                allowClear={false}
                                disabledDate={
                                  Appttype == 2 &&
                                  ((current) => {
                                    // Disable dates before today
                                    return (
                                      current &&
                                      current < moment().startOf("day")
                                    );
                                  })
                                }
                              />

                              <div className="App-time ">
                                <div className="showTime">
                                  <input
                                    className="fromTime-toTime-start"
                                    onClick={() => {
                                      handleFromTime();
                                    }}
                                    onMouseLeave={() => {
                                      setTempOpen(false);
                                    }}
                                    style={
                                      timeMismatch || inTimeErr
                                        ? {
                                            border: "1px solid red",
                                          }
                                        : {}
                                    }
                                    value={inTime}
                                    onChange={(e) => {
                                      if (!regexFirstNum.test(e.target.value)) {
                                        setFromShow(false);
                                        setToShow(false);
                                        setInTime(e.target.value);
                                        setTimeMismatch(false);
                                        setTimeout(() => {
                                          setInTime(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                          );

                                          onChange(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                            "inTime",
                                          );
                                        }, 4000);
                                      }
                                    }}
                                    onBlur={(e) => {
                                      setTimeMismatch(false);
                                      setInTime(
                                        moment(e.target.value, "h:mm A").format(
                                          "h:mm A",
                                        ),
                                      );
                                      onChange(
                                        moment(e.target.value, "h:mm A").format(
                                          "h:mm A",
                                        ),
                                        "inTime",
                                      );
                                    }}
                                  />
                                  <p className="time--space">-</p>
                                  <input
                                    className="fromTime-toTime"
                                    onClick={() => {
                                      handleToTime();
                                    }}
                                    style={
                                      timeMismatch || inTimeErr
                                        ? {
                                            border: "1px solid red",
                                          }
                                        : {}
                                    }
                                    onChange={(e) => {
                                      if (!regexFirstNum.test(e.target.value)) {
                                        setFromShow(false);
                                        setToShow(false);
                                        setOutTime(e.target.value);
                                        setTimeMismatch(false);
                                        setTimeout(() => {
                                          setOutTime(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                          );

                                          onChange(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                            "outTime",
                                          );
                                        }, 4000);
                                      }
                                    }}
                                    onMouseLeave={() => {
                                      setTempOpen(false);
                                    }}
                                    onBlur={(e) => {
                                      setTimeMismatch(false);
                                      setOutTime(
                                        moment(e.target.value, "h:mm A").format(
                                          "h:mm A",
                                        ),
                                      );
                                      onChange(
                                        moment(e.target.value, "h:mm A").format(
                                          "h:mm A",
                                        ),
                                        "outTime",
                                      );
                                    }}
                                    value={outTime}
                                  />
                                </div>

                                {/* From Button */}
                                <div
                                  className={
                                    fromShow
                                      ? "fromArray-toArray"
                                      : "fromArray_hide"
                                  }
                                >
                                  {frtimeSlots.map((item, index) => {
                                    return (
                                      <button
                                        key={item.id}
                                        value={item.time + " " + item.meridiem}
                                        disabled={disabledFromTimes(
                                          item.time,
                                          item.meridiem,
                                          Appttype,
                                        )}
                                        onClick={async (e) => {
                                          setTimeMismatch(false);
                                          setInTime(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                          );
                                          await setFromId(item.id);
                                          handleFromButton(e);
                                          onChange(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                            "inTime",
                                          );
                                        }}
                                      >
                                        {item.time + " " + item.meridiem}
                                      </button>
                                    );
                                  })}
                                </div>
                                {/* To button */}
                                <div
                                  className={
                                    toShow
                                      ? "fromArray-toArray"
                                      : "toArray_hide"
                                  }
                                  style={{ left: 70 }}
                                >
                                  {totimeSlots.map((item, index) => {
                                    return (
                                      <button
                                        disabled={disabledToTime(
                                          item.time,
                                          item.meridiem,
                                          item.id,
                                          Appttype,
                                        )}
                                        key={index}
                                        value={item.time + " " + item.meridiem}
                                        onClick={async (e) => {
                                          setTimeMismatch(false);
                                          setOutTime(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                          );

                                          handleToButton(e);
                                          onChange(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                            "outTime",
                                          );
                                        }}
                                      >
                                        {item.time + " " + item.meridiem}
                                      </button>
                                    );
                                  })}
                                </div>
                              </div>
                              {/* nisha end */}
                            </div>
                            {dateErr && (
                              <Form.Text
                                id="new-app-time-codetext appt-warn-time"
                                className="colour-red m-t-0-imp_editAppointment "
                              >
                                Please Select valid date
                              </Form.Text>
                            )}
                          </form>
                        </Div>
                        {(inTimeErr || timeMismatch) && (
                          <Form.Text
                            id="new-app-time-codetext appt-warn-time"
                            className="colour-red p-l-66 m-t-0-imp m-b-3"
                          >
                            Please Select valid Time
                          </Form.Text>
                        )}
                        {timelimiterrorbox && (
                          <Form.Text
                            id="new-app-time-codetext appt-warn-time"
                            className="colour-red p-l-66 m-t-0-imp m-b-3"
                          >
                            Provider Only Available Between {startErrTime} to{" "}
                            {endErrTime}
                          </Form.Text>
                        )}

                        <Div style={{ textAlign: "left" }}>
                          <Popup
                            content={fornormalapp}
                            open={normalappointment}
                            trigger={
                              <Button
                                id="click_event_app_normal"
                                content="Button"
                              />
                            }
                            position="left center"
                          />
                        </Div>
                        <Div>
                          <Popup
                            content={forteleapp}
                            open={teleappointment}
                            trigger={
                              <Button
                                id="click_event_app_tele"
                                content="Button"
                              />
                            }
                            position="left center"
                          />
                        </Div>

                        <Div className=" w-100">
                          <Div className="wholediv">
                            <Div margin="-20px 0px 0px -2px" size="20px">
                              <Image
                                src={doctorLogo}
                                alt="speciality"
                                height="20px"
                                width="20px"
                              />
                            </Div>

                            <Div className="dropdiv">
                              <Select
                                getPopupContainer={(triggerNode) =>
                                  triggerNode.parentNode
                                }
                                virtual={false}
                                showSearch
                                placeholder="Select Speciality"
                                suffixIcon={<BsFillCaretDownFill />}
                                className={
                                  specialError
                                    ? "err_mess_border w-100"
                                    : "w-100"
                                }
                                onChange={(data) => changeSpeciality(data)}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.title ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                value={speciality ? speciality : null}
                                optionLabelProp="label"
                                dropdownClassName="speciality-option"
                              >
                                {sortSpeciality &&
                                  sortSpeciality
                                    .filter(
                                      (item) =>
                                        (storedNames.appt_a ||
                                          item.specialty === notDisabledSpec) &&
                                        item.count > 0,
                                    ) // Filter disabled options
                                    .map((item) => (
                                      <Option
                                        key={item.specialty}
                                        value={item.specialty}
                                        title={item.specialty}
                                        disabled={
                                          (!storedNames.appt_a &&
                                            item.specialty !==
                                              notDisabledSpec) ||
                                          item.count === 0
                                        }
                                        id={
                                          !storedNames.appt_a &&
                                          item.specialty !== notDisabledSpec
                                            ? "clr-disable"
                                            : "" || item.count == 0
                                              ? "clr-disable"
                                              : ""
                                        }
                                        className={
                                          (!storedNames.appt_a &&
                                            item.speciality !==
                                              notDisabledSpec) ||
                                          item.count === 0
                                        }
                                      >
                                        {item.speciality}
                                      </Option>
                                    ))}
                              </Select>
                              {specialError && (
                                <p className="errormessage">
                                  Select a speciality
                                </p>
                              )}
                            </Div>
                          </Div>
                        </Div>

                        <Div className=" w-100" id="border">
                          <Div
                            className="wholediv"
                            // className="alx p-r-20"
                          >
                            <Div margin="-20px 0px 0px -2px">
                              <LocalHospitalOutlined />
                            </Div>
                            <Div
                              className={
                                videochck ? "dropdiv downDropDown" : "dropdiv"
                              }
                              id="statId"
                            >
                              <Select
                                getPopupContainer={(triggerNode) =>
                                  triggerNode.parentNode
                                }
                                virtual={false}
                                showSearch
                                placeholder="Status"
                                id="new-app-status_1 appt-inp-stas"
                                suffixIcon={<BsFillCaretDownFill />}
                                // onClick={changeborder}
                                // className="form-control "
                                className={
                                  statusError
                                    ? "err_mess_border w-100"
                                    : "w-100"
                                }
                                onChange={(e, data) =>
                                  handleDropDownSelectStatus(e, data)
                                }
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.title ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                value={statusid ? statusid : null}
                                dropdownAlign={{
                                  points: ["tl", "bl"],
                                  offset: [0, 4],
                                }}
                                dropdownStyle={{
                                  zIndex: 1050,
                                }}
                              >
                                {checking1 ? (
                                  <></>
                                ) : (
                                  <>
                                    {videochck ? (
                                      <>
                                        {sourcestatustele.map((i) => (
                                          <Option
                                            key={i.value}
                                            value={i.value}
                                            title={i.text}
                                          >
                                            {i.text}
                                          </Option>
                                        ))}
                                      </>
                                    ) : (
                                      <>
                                        {sourcestatus.map((i) => (
                                          <Option
                                            key={i.value}
                                            value={i.value}
                                            title={i.text}
                                          >
                                            {i.text}
                                          </Option>
                                        ))}
                                      </>
                                    )}
                                  </>
                                )}
                              </Select>
                              {statusError && (
                                <p className="errormessage">
                                  Please select Status
                                </p>
                              )}
                            </Div>
                          </Div>
                        </Div>

                        <Div className=" w-100">
                          <Div
                            className="wholediv"
                            // className="alx p-r-20"
                          >
                            <Div margin="-20px 0px 0px -2px">
                              <HomeOutlinedIcon />
                            </Div>
                            <Div className="dropdiv" id="ExaId">
                              <Select
                                getPopupContainer={(triggerNode) =>
                                  triggerNode.parentNode
                                }
                                virtual={false}
                                showSearch
                                placeholder="Exam Room"
                                id="new-app-profile_1"
                                suffixIcon={<BsFillCaretDownFill />}
                                className={
                                  examroomError
                                    ? "err_mess_border w-100"
                                    : "w-100"
                                }
                                onChange={(e, data) =>
                                  handleRoomVal(data.value)
                                }
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.title ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                value={roomval ? roomval : null}
                                dropdownAlign={{
                                  points: ["tl", "bl"],
                                  offset: [0, 4],
                                }}
                                dropdownStyle={{
                                  zIndex: 1050,
                                  maxHeight: "200px",
                                }}
                              >
                                {sourceroom.map((i) => (
                                  <Option
                                    key={i.value}
                                    value={i.value}
                                    title={i.text}
                                  >
                                    {i.text}
                                  </Option>
                                ))}
                              </Select>
                              {examroomError && (
                                <p className="errormessage">
                                  Please select Exam Room
                                </p>
                              )}
                            </Div>
                          </Div>
                        </Div>
                      </div>
                    </div>
                    <Div display="flex" padding="0px 0px 10px 45px">
                      <p className="remove-bor-mar">Reason</p>
                      {ENABLE_REASON_DROPDOWN ? (
                        <Select
                          value={reason || undefined}
                          onChange={(value) => setReason(value)}
                          style={{
                            width: "528px",
                            minWidth: "528px",
                            maxWidth: "528px",
                          }}
                          placeholder="Select Reason"
                          suffixIcon={
                            <BsFillCaretDownFill size={12} color="#808080" />
                          }
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentNode
                          }
                        >
                          {reasonOptions.map((item) => (
                            <Option key={item} value={item}>
                              {item}
                            </Option>
                          ))}
                        </Select>
                      ) : (
                        <InputSchedule
                          maxLength={200}
                          width="528px"
                          value={reason}
                          onChange={(e) => setReason(e.target.value)}
                        />
                      )}

                      {!ENABLE_REASON_DROPDOWN && (
                        <p
                          className="remove-bor-mar-reason"
                          style={{
                            color:
                              reason && reason.length >= 200
                                ? "red"
                                : "inherit",
                          }}
                        >
                          Maximum of 200 characters
                        </p>
                      )}
                    </Div>
                  </Form.Row>
                </Div>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="client-app new_appt_btn_alt">
          <Button
            className="close_active close_active2 "
            variant="light"
            onClick={props.closepopup}
          >
            Cancel
          </Button>
          <Button
            id="appt-btn-sve"
            className="save_active save-btn"
            variant="primary"
            type="submit"
            onClick={
              switchvalue === false && changeTab === "2"
                ? () => handleRefresh()
                : (e) => handleSubmit(e)
            }
            disabled={
              btnDis || storedNames.demo1_viewOnly || storedNames.demo_v
            }
          >
            Save
          </Button>
        </Modal.Footer>
        {/* } */}
      </div>
      <Modal
        className="alert-popup-message eramsg"
        show={ModalAlerShow1}
        onHide={modalhide}
      >
        <div role="alert" className="alert-danger erapad">
          {/* <BsExclamationOctagon className="icons-bs alert-icons-bts" /> */}
          <FiAlertCircle className="alert-icons-bts" />
          <span>{ModalMsg1}</span>
        </div>
      </Modal>

      <Modal className="alert-popup-message" show={clientFail1}>
        <div className="alert msg alert-danger" role="alert">
          <IoCloseSharp className="icons-bs" /> This email is already used for
          an existing patient. Please use a different email.
        </div>
      </Modal>

      <Modal
        className="app-popup repeat-popup rept-modal popup_centre for_weekendAppt"
        centered
        backdrop="static"
        keyboard={false}
        show={showPopup}
      >
        <RepeatPopupBlock width="640px">
          <RepeatPopupHeader>
            Recurring appointments will include weekends. Remove unwanted dates
            manually
          </RepeatPopupHeader>

          <RepeatFooter>
            <RepeatBtnConfirm
              confirm={true}
              onClick={() => {
                setShowPopup(false);
                if (onConfirm) onConfirm();
              }}
            >
              Ok
            </RepeatBtnConfirm>
          </RepeatFooter>
        </RepeatPopupBlock>
      </Modal>

      <Modal
        className="client-popup create-client create_modaltop wid_562"
        centered
        show={showGroupModal}
        onHide={() => {
          setShowGroupModal(false);
          // setEditData(null);
        }}
      >
        <CreateGroupClients
          onClose={() => {
            setShowGroupModal(false);
            // setEditData(null);
          }}
          editData={null}
          onSuccess={(msg) => {
            setSuccessMsg(msg);
            setShowSuccess(true);
            setTimeout(() => {
              setShowSuccess(false);
              setSuccessMsg("");
            }, 2000);
          }}
        />
      </Modal>
      <Modal
        className="alert-popup-message"
        show={showSuccess}
        onHide={() => setShowSuccess(false)}
      >
        <div className="alert msg alert-success" role="alert">
          <BsCheckCircle className="icons-bs" />
          {successMsg}
        </div>
      </Modal>
      {upgrade && (
        <UpgradeRequired
          title="Enable Remote Consultation"
          description="Consult patients through video visit remotely conserving resources and improving the care."
          boxContent={
            <span>
              Available in
              <span className="upgradFont"> Premium</span> plan
            </span>
          }
          handlecloseUpgrade={handlecloseUpgrade}
        />
      )}
    </>
  );
};
export default memo(NewAppointment);
